import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export class Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
};

export class Access {
  bloc?: Maybe<Bloc>;
  checkList?: Maybe<Array<CheckListAccessItem>>;
  code?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  place?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
};

export class AccessPage {
  PageSize: Scalars['Int'];
  PreviousPage: Scalars['Boolean'];
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  results: Array<Access>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class AddServiceRequestVehicleInput {
  licensePlate: Scalars['String'];
  serviceRequestId: Scalars['ID'];
  vehicle: Scalars['String'];
};

export class Alarm {
  bloc?: Maybe<Bloc>;
  checkList?: Maybe<Array<CheckListAlarmItem>>;
  code: Scalars['Float'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  place?: Maybe<Scalars['String']>;
  status: Scalars['Boolean'];
  type: Scalars['String'];
};

export class AlarmPage {
  PageSize: Scalars['Int'];
  PreviousPage: Scalars['Boolean'];
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  results: Array<Alarm>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class AuthInput {
  code?: InputMaybe<Scalars['String']>;
  identifier?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  redirectUri?: InputMaybe<Scalars['String']>;
};

export class AuthType {
  token: Scalars['String'];
  user: User;
};

export class BaseInput {
  id: Scalars['String'];
};

export class Bloc {
  access?: Maybe<Array<Access>>;
  alarms?: Maybe<Array<Alarm>>;
  cameras?: Maybe<Array<Camera>>;
  capacity?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  unity?: Maybe<Unity>;
};

export class BlocAvailability {
  available: Scalars['Int'];
  bloc: Bloc;
  capacity: Scalars['Int'];
  occupied: Scalars['Int'];
};

export class BlocPage {
  PageSize: Scalars['Int'];
  PreviousPage: Scalars['Boolean'];
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  results: Array<Bloc>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class Camera {
  bloc?: Maybe<Bloc>;
  checkList?: Maybe<Array<CheckListCftvItem>>;
  code: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  mode: Scalars['String'];
  place: Scalars['String'];
  status: Scalars['String'];
  time: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export class CameraPage {
  PageSize: Scalars['Int'];
  PreviousPage: Scalars['Boolean'];
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  results: Array<Camera>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class CaronaPage {
  PageSize: Scalars['Int'];
  PreviousPage: Scalars['Boolean'];
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  results: Array<CarpoolRecord>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class CarpoolRecord {
  bloc?: Maybe<Bloc>;
  cpf?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  employeeName?: Maybe<Scalars['String']>;
  entryAt: Scalars['DateTime'];
  entryBy?: Maybe<User>;
  entryNote?: Maybe<Scalars['String']>;
  entryRegisteredAt?: Maybe<Scalars['DateTime']>;
  exitAt?: Maybe<Scalars['DateTime']>;
  exitBy?: Maybe<User>;
  exitNote?: Maybe<Scalars['String']>;
  exitRegisteredAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isManualEntry?: Maybe<Scalars['Boolean']>;
  isManualExit?: Maybe<Scalars['Boolean']>;
  licensePlate?: Maybe<Scalars['String']>;
  qrRaw?: Maybe<Scalars['String']>;
  re?: Maybe<Scalars['String']>;
  registration?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  unity?: Maybe<Unity>;
  updatedAt: Scalars['DateTime'];
  vaga?: Maybe<Scalars['String']>;
};

export class CheckListAccess {
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<User>;
  id: Scalars['ID'];
  items?: Maybe<Array<CheckListAccessItem>>;
  status?: Maybe<Scalars['String']>;
  unity?: Maybe<Unity>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export class CheckListAccessComment {
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  id: Scalars['ID'];
  item?: Maybe<CheckListAccessItem>;
  status: Scalars['String'];
};

export class CheckListAccessFinishedDto {
  PageSize: Scalars['Int'];
  PreviousPage: Scalars['Boolean'];
  checklist: CheckListAccess;
  currentPage: Scalars['Int'];
  items: Array<CheckListAccessItem>;
  nextPage: Scalars['Boolean'];
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class CheckListAccessFinishedFilter {
  blocId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
};

export class CheckListAccessItem {
  access?: Maybe<Access>;
  checkList?: Maybe<CheckListAccess>;
  comments?: Maybe<Array<CheckListAccessComment>>;
  condition?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  dateLimit?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export class CheckListAlarm {
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<User>;
  id: Scalars['ID'];
  items?: Maybe<Array<CheckListAlarmItem>>;
  status?: Maybe<Scalars['String']>;
  unity?: Maybe<Unity>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export class CheckListAlarmBlocDto {
  done: Scalars['Int'];
  id: Scalars['String'];
  items: Array<CheckListAlarmItem>;
  lastItemDate?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  total: Scalars['Int'];
};

export class CheckListAlarmComment {
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  id: Scalars['ID'];
  item?: Maybe<CheckListAlarmItem>;
  status: Scalars['String'];
};

export class CheckListAlarmCreateDto {
  id: Scalars['String'];
};

export class CheckListAlarmFinishedDto {
  PageSize: Scalars['Int'];
  PreviousPage: Scalars['Boolean'];
  checklist: CheckListAlarm;
  currentPage: Scalars['Int'];
  items: Array<CheckListAlarmItem>;
  nextPage: Scalars['Boolean'];
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class CheckListAlarmFinishedFilter {
  blocId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
};

export class CheckListAlarmItem {
  alarm?: Maybe<Alarm>;
  checkList?: Maybe<CheckListAlarm>;
  comments?: Maybe<Array<CheckListAlarmComment>>;
  condition?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  dateLimit?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
};

export class CheckListAlarmItemStatusUpdateInput {
  comment: Scalars['String'];
  itemId: Scalars['String'];
  status: Scalars['String'];
};

export class CheckListAlarmUnfinishedDto {
  blocs: Array<CheckListAlarmBlocDto>;
  status: Scalars['String'];
};

export class CheckListAlarmUpdateInput {
  blocId: Scalars['String'];
  checkListId: Scalars['String'];
  items: Array<CheckListAlarmUpdateInputItem>;
};

export class CheckListAlarmUpdateInputItem {
  comments?: InputMaybe<Array<CheckListAlarmUpdateInputItemComment>>;
  condition: Scalars['String'];
  dateLimit?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
};

export class CheckListAlarmUpdateInputItemComment {
  comment: Scalars['String'];
};

export class CheckListCftv {
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<User>;
  id: Scalars['ID'];
  items?: Maybe<Array<CheckListCftvItem>>;
  status?: Maybe<Scalars['String']>;
  unity?: Maybe<Unity>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export class CheckListCftvBlocDto {
  done: Scalars['Int'];
  id: Scalars['String'];
  items: Array<CheckListCftvItem>;
  lastItemDate?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  total: Scalars['Int'];
};

export class CheckListCftvComment {
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  id: Scalars['ID'];
  item?: Maybe<CheckListCftvItem>;
  status: Scalars['String'];
};

export class CheckListCftvCreateDto {
  id: Scalars['String'];
};

export class CheckListCftvFinishedDto {
  PageSize: Scalars['Int'];
  PreviousPage: Scalars['Boolean'];
  checklist: CheckListCftv;
  currentPage: Scalars['Int'];
  items: Array<CheckListCftvItem>;
  nextPage: Scalars['Boolean'];
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class CheckListCftvFinishedFilter {
  blocId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
};

export class CheckListCftvItem {
  alignment?: Maybe<Scalars['String']>;
  alimentation?: Maybe<Scalars['String']>;
  camera?: Maybe<Camera>;
  checkList?: Maybe<CheckListCftv>;
  comments?: Maybe<Array<CheckListCftvComment>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  dateLimit?: Maybe<Scalars['DateTime']>;
  daysRecorded?: Maybe<Scalars['String']>;
  focus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  signal?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export class CheckListCftvItemStatusUpdateInput {
  comment: Scalars['String'];
  itemId: Scalars['String'];
  status: Scalars['String'];
};

export class CheckListCftvUnfinishedDto {
  blocs: Array<CheckListCftvBlocDto>;
  status: Scalars['String'];
};

export class CheckListCftvUpdateInput {
  blocId: Scalars['String'];
  checkListId: Scalars['String'];
  items: Array<CheckListCftvUpdateInputItem>;
};

export class CheckListCftvUpdateInputItem {
  alignment: Scalars['String'];
  alimentation: Scalars['String'];
  comments?: InputMaybe<Array<CheckListCftvUpdateInputItemComment>>;
  dateLimit?: InputMaybe<Scalars['DateTime']>;
  daysRecorded: Scalars['String'];
  focus: Scalars['String'];
  id: Scalars['String'];
  signal: Scalars['String'];
};

export class CheckListCftvUpdateInputItemComment {
  comment: Scalars['String'];
};

export class CheckListCreateDto {
  id: Scalars['String'];
};

export class CheckListItemStatusUpdateInput {
  comment: Scalars['String'];
  itemId: Scalars['String'];
  status: Scalars['String'];
};

export class CheckListUpdateInput {
  blocId: Scalars['String'];
  checkListId: Scalars['String'];
  items: Array<CheckListUpdateInputItem>;
};

export class CheckListUpdateInputItem {
  comments?: InputMaybe<Array<CheckListUpdateInputItemComment>>;
  condition: Scalars['String'];
  dateLimit?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
};

export class CheckListUpdateInputItemComment {
  comment: Scalars['String'];
};

export class ChecklistAccessUnfinishedDto {
  blocs: Array<ChecklistBlocDto>;
  status: Scalars['String'];
};

export class ChecklistBlocDto {
  done: Scalars['Int'];
  id: Scalars['String'];
  items: Array<CheckListAccessItem>;
  lastItemDate?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  total: Scalars['Int'];
};

export class Country {
  deletedAt?: Maybe<Scalars['DateTime']>;
  flag?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  policy?: Maybe<Array<Policy>>;
  unities?: Maybe<Array<Unity>>;
};

export class CreateAccessBlocInput {
  id: Scalars['String'];
};

export class CreateAccessInput {
  bloc: CreateAccessBlocInput;
  place: Scalars['String'];
  status: Scalars['Boolean'];
  /** ENUM biometry|facialBiometrics|badge */
  type: Scalars['String'];
};

export class CreateAlarmBlocInput {
  id: Scalars['String'];
};

export class CreateAlarmInput {
  bloc: CreateAlarmBlocInput;
  place: Scalars['String'];
  status: Scalars['Boolean'];
  type: Scalars['String'];
};

export class CreateBlocInput {
  capacity?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  unity: CreateBlocUnityInput;
};

export class CreateBlocUnityInput {
  id: Scalars['String'];
};

export class CreateCameraBlocInput {
  id: Scalars['String'];
};

export class CreateCameraInput {
  bloc: CreateCameraBlocInput;
  mode: Scalars['String'];
  place: Scalars['String'];
  status: Scalars['String'];
  time: Scalars['String'];
  type: Scalars['String'];
};

export class CreateCountryInput {
  flag: Scalars['String'];
  name: Scalars['String'];
};

export class CreateDaycareChildGuardianInput {
  documentRaw?: InputMaybe<Scalars['String']>;
  kind: Scalars['String'];
  name: Scalars['String'];
};

export class CreateDaycareChildInput {
  employeeEmail?: InputMaybe<Scalars['String']>;
  employeeName: Scalars['String'];
  employeeRe: Scalars['String'];
  guardians?: InputMaybe<Array<CreateDaycareChildGuardianInput>>;
  name: Scalars['String'];
  unityId?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

export class CreateDaycareGuardianInput {
  childId: Scalars['ID'];
  documentRaw?: InputMaybe<Scalars['String']>;
  kind: Scalars['String'];
  name: Scalars['String'];
};

export class CreateEnumTypeInput {
  culture: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  detail?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  unity?: InputMaybe<CreateEnumTypeUnityInput>;
  value: Scalars['String'];
};

export class CreateEnumTypeUnityInput {
  id: Scalars['String'];
};

export class CreateOccurrenceInput {
  area?: InputMaybe<Scalars['String']>;
  areaResponsible?: InputMaybe<Scalars['String']>;
  bulletinNumber?: InputMaybe<Scalars['String']>;
  unity?: InputMaybe<CreateOccurrenceunityInput>;
};

export class CreateOccurrenceunityInput {
  id: Scalars['String'];
};

export class CreatePhysicalSecurityInput {
  cnpj?: InputMaybe<Scalars['String']>;
  companyStatus?: InputMaybe<Scalars['Boolean']>;
  member?: InputMaybe<Array<CreatePhysicalSecurityMemberInput>>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  segment?: InputMaybe<Scalars['String']>;
  stationNumber?: InputMaybe<Scalars['Int']>;
};

export class CreatePhysicalSecurityMemberInput {
  document?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export class CreatePolicyCountryInput {
  id: Scalars['String'];
};

export class CreatePolicyInput {
  country: CreatePolicyCountryInput;
  description?: InputMaybe<Scalars['String']>;
  isPortuguese?: InputMaybe<Scalars['Boolean']>;
  isSpanish?: InputMaybe<Scalars['Boolean']>;
  link?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export class CreateServiceRequestHelperInput {
  departureDate?: InputMaybe<Scalars['DateTime']>;
  doc: Scalars['String'];
  entryDate?: InputMaybe<Scalars['DateTime']>;
  name: Scalars['String'];
};

export class CreateServiceRequestInput {
  area: Scalars['String'];
  cnpj: Scalars['String'];
  company: Scalars['String'];
  cpf: Scalars['String'];
  entranceDate: Scalars['DateTime'];
  exitDate: Scalars['DateTime'];
  helper: Array<CreateServiceRequestHelperInput>;
  meal?: InputMaybe<Scalars['String']>;
  mealCostCenter?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  requestNumber?: InputMaybe<Scalars['String']>;
  unity: CreateServiceRequestUnityInput;
  vehicles?: InputMaybe<Array<CreateServiceRequestVehicleInput>>;
};

export class CreateServiceRequestUnityInput {
  id: Scalars['String'];
};

export class CreateServiceRequestVehicleInput {
  id?: InputMaybe<Scalars['ID']>;
  licensePlate?: InputMaybe<Scalars['String']>;
  vehicle?: InputMaybe<Scalars['String']>;
};

export class CreateTruckCheckListObject {
  comment?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  /** Enum "vehicle"|"trailer" */
  name: Scalars['String'];
  status?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

export class CreateTruckInspectEquipmentInput {
  name: Scalars['String'];
  quantity: Scalars['Int'];
};

export class CreateTruckInspectReceiptInput {
  receipt: Scalars['String'];
};

export class CreateTruckUnityInput {
  id: Scalars['String'];
};

export class CreateUnityCountryInput {
  id: Scalars['String'];
};

export class CreateUnityInput {
  city: Scalars['String'];
  country: CreateUnityCountryInput;
  name: Scalars['String'];
};

export class CreateUserCountryInput {
  id: Scalars['String'];
};

export class CreateUserInput {
  email: Scalars['String'];
  identifier: Scalars['String'];
  name: Scalars['String'];
  office: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  profile: Scalars['String'];
  status: Scalars['Boolean'];
  unity: CreateUserUnityInput;
};

export class CreateUserUnityInput {
  id: Scalars['String'];
};

export class CreateVehicleInput {
  driverCpf: Scalars['String'];
  licensePlate: Scalars['String'];
  trailerLicensePlate?: InputMaybe<Scalars['String']>;
};

export class DaycareChild {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  employee?: Maybe<DaycareEmployee>;
  guardians?: Maybe<Array<DaycareGuardian>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  unity?: Maybe<Unity>;
  updatedAt: Scalars['DateTime'];
  year?: Maybe<Scalars['Int']>;
};

export class DaycareChildPage {
  PageSize: Scalars['Int'];
  PreviousPage: Scalars['Boolean'];
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  results: Array<DaycareChild>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class DaycareEmployee {
  children?: Maybe<Array<DaycareChild>>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  re: Scalars['String'];
  unity?: Maybe<Unity>;
  updatedAt: Scalars['DateTime'];
};

export class DaycareGuardian {
  child?: Maybe<DaycareChild>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  documentRaw?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  kind: Scalars['String'];
  name: Scalars['String'];
  position: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export class DaycarePickupCandidate {
  children: Array<DaycarePickupCandidateChild>;
  employeeRe: Scalars['String'];
  personDocument?: Maybe<Scalars['String']>;
  personKind: Scalars['String'];
  personName: Scalars['String'];
};

export class DaycarePickupCandidateChild {
  entryAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  status: Scalars['String'];
};

export class DaycarePickupItem {
  childName: Scalars['String'];
  employeeRe: Scalars['String'];
  entryAt?: Maybe<Scalars['DateTime']>;
  entryByName?: Maybe<Scalars['String']>;
  entryNote?: Maybe<Scalars['String']>;
  entryPersonKind?: Maybe<Scalars['String']>;
  entryPersonName?: Maybe<Scalars['String']>;
  exitAt?: Maybe<Scalars['DateTime']>;
  exitByName?: Maybe<Scalars['String']>;
  exitNote?: Maybe<Scalars['String']>;
  exitPersonKind?: Maybe<Scalars['String']>;
  exitPersonName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  status: Scalars['String'];
};

export class DaycarePickupPage {
  PageSize: Scalars['Int'];
  PreviousPage: Scalars['Boolean'];
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  results: Array<DaycarePickupItem>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class DaycarePickupRecord {
  child?: Maybe<DaycareChild>;
  childName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  employeeRe: Scalars['String'];
  entryAt?: Maybe<Scalars['DateTime']>;
  entryBy?: Maybe<User>;
  entryNote?: Maybe<Scalars['String']>;
  entryPersonDocument?: Maybe<Scalars['String']>;
  entryPersonKind?: Maybe<Scalars['String']>;
  entryPersonName?: Maybe<Scalars['String']>;
  exitAt?: Maybe<Scalars['DateTime']>;
  exitBy?: Maybe<User>;
  exitNote?: Maybe<Scalars['String']>;
  exitPersonDocument?: Maybe<Scalars['String']>;
  exitPersonKind?: Maybe<Scalars['String']>;
  exitPersonName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  status: Scalars['String'];
  unity?: Maybe<Unity>;
  updatedAt: Scalars['DateTime'];
};

export class DaycareStayResult {
  count: Scalars['Int'];
  message: Scalars['String'];
  requiresConfirmation?: Maybe<Scalars['Boolean']>;
  warning?: Maybe<Scalars['String']>;
};

export class DefaultMessage {
  message: Scalars['String'];
  status: Scalars['Int'];
};

export class EnumType {
  culture: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  detail?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  type: Scalars['String'];
  unity?: Maybe<Unity>;
  value: Scalars['String'];
};

export class EnumTypePage {
  PageSize: Scalars['Int'];
  PreviousPage: Scalars['Boolean'];
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  results: Array<EnumType>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class Equipment {
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export class InspectServiceRequestEquipmentInput {
  name: Scalars['String'];
  quantity: Scalars['Float'];
};

export class InspectServiceRequestInput {
  date: Scalars['DateTime'];
  equipment?: InputMaybe<Array<InspectServiceRequestEquipmentInput>>;
  id?: InputMaybe<Scalars['ID']>;
  isFinalize?: Scalars['Boolean'];
  obs?: InputMaybe<Scalars['String']>;
  others?: InputMaybe<Scalars['String']>;
  serviceRequest: InspectServiceRequestServiceInput;
  /** ENUM entry|exit */
  type: Scalars['String'];
  vehicleId?: InputMaybe<Scalars['ID']>;
};

export class InspectServiceRequestServiceInput {
  id: Scalars['String'];
};

export class InspectTruckInput {
  comment?: InputMaybe<Scalars['String']>;
  date: Scalars['DateTime'];
  equipment?: InputMaybe<Array<CreateTruckInspectEquipmentInput>>;
  receipt?: InputMaybe<Array<CreateTruckInspectReceiptInput>>;
  sealNumber?: InputMaybe<Scalars['String']>;
  trailerLicensePlate?: InputMaybe<Scalars['String']>;
  truck: InspectTruckTruckInput;
};

export class InspectTruckTruckInput {
  id: Scalars['String'];
};

export class Mutation {
  addServiceRequestVehicle: ServiceRequest;
  createAccess: Access;
  createAlarm: Alarm;
  createBloc: Bloc;
  createCamera: Camera;
  createCheckListAccess: CheckListCreateDto;
  createCheckListAlarm: CheckListAlarmCreateDto;
  createCheckListCftv: CheckListCftvCreateDto;
  /** Create a new Country */
  createCountry: Country;
  createDaycareChild: DaycareChild;
  createDaycareGuardian: DaycareChild;
  /** Create new Enum Type */
  createEnumType: EnumType;
  createOccurrence: Occurrence;
  /** Create new company */
  createPhysicalSecurity: PhysicalSecurity;
  createPolicy: Policy;
  createServiceRequest: ServiceRequest;
  createTruck: Truck;
  /** Create a new Unity */
  createUnity: Unity;
  /** Create new User */
  createUser: User;
  createVehicle: Vehicle;
  deleteVehicle: DefaultMessage;
  finishServiceRequest: ServiceRequest;
  forgotPassword: DefaultMessage;
  inspectServiceRequest: ServiceRequestInspect;
  inspectTruck: Truck;
  login: AuthType;
  registerCaronaEntry: CarpoolRecord;
  registerCaronaExit: CarpoolRecord;
  registerDaycareEntry: DaycareStayResult;
  registerDaycareExit: DaycareStayResult;
  releaseTruck: Truck;
  removeAccess: DefaultMessage;
  removeAlarm: DefaultMessage;
  removeBloc: DefaultMessage;
  removeCamera: DefaultMessage;
  removeCarona: DefaultMessage;
  removeCheckListAccess: DefaultMessage;
  removeCheckListAlarm: DefaultMessage;
  removeCheckListCftv: DefaultMessage;
  /** Remove Country By ID */
  removeCountry: DefaultMessage;
  removeDaycareChild: DefaultMessage;
  removeDaycareGuardian: DefaultMessage;
  removeEnumType: DefaultMessage;
  removeOccurrence: DefaultMessage;
  removeOccurrenceFile: DefaultMessage;
  /** Remove company By Id */
  removePhysicalSecurity: DefaultMessage;
  /** Remove member By Id */
  removePhysicalSecurityMember: DefaultMessage;
  removePolicy: DefaultMessage;
  removeServiceRequest: DefaultMessage;
  removeTruck: DefaultMessage;
  removeTruckChecklistPhoto: DefaultMessage;
  removeUnity: DefaultMessage;
  /** Remove User By Id */
  removeUser: DefaultMessage;
  resetPassword: DefaultMessage;
  updateAccess: Access;
  updateAlarm: Alarm;
  updateBloc: Bloc;
  updateCamera: Camera;
  updateCheckListAccess: DefaultMessage;
  updateCheckListAccessItemStatus: DefaultMessage;
  updateCheckListAlarm: DefaultMessage;
  updateCheckListAlarmItemStatus: DefaultMessage;
  updateCheckListCftv: DefaultMessage;
  updateCheckListCftvItemStatus: DefaultMessage;
  updateDaycareChild: DaycareChild;
  updateDaycareGuardian: DaycareChild;
  updateEnumType: EnumType;
  updateOccurrence: Occurrence;
  updatePhysicalSecurity: PhysicalSecurity;
  updatePolicy: Policy;
  updateServiceRequest: ServiceRequest;
  updateServiceRequestDetail: ServiceRequest;
  updateTruck: Truck;
  updateTruckPlate: Truck;
  /** Update Unity */
  updateUnity: Unity;
  /** Update User */
  updateUser: User;
  updateVehicle: Vehicle;
};


export class MutationAddServiceRequestVehicleArgs {
  data: AddServiceRequestVehicleInput;
};


export class MutationCreateAccessArgs {
  data: CreateAccessInput;
};


export class MutationCreateAlarmArgs {
  data: CreateAlarmInput;
};


export class MutationCreateBlocArgs {
  data: CreateBlocInput;
};


export class MutationCreateCameraArgs {
  data: CreateCameraInput;
};


export class MutationCreateCountryArgs {
  data: CreateCountryInput;
};


export class MutationCreateDaycareChildArgs {
  data: CreateDaycareChildInput;
};


export class MutationCreateDaycareGuardianArgs {
  data: CreateDaycareGuardianInput;
};


export class MutationCreateEnumTypeArgs {
  data: CreateEnumTypeInput;
};


export class MutationCreateOccurrenceArgs {
  data: CreateOccurrenceInput;
};


export class MutationCreatePhysicalSecurityArgs {
  data: CreatePhysicalSecurityInput;
};


export class MutationCreatePolicyArgs {
  data: CreatePolicyInput;
};


export class MutationCreateServiceRequestArgs {
  data: CreateServiceRequestInput;
};


export class MutationCreateUnityArgs {
  data: CreateUnityInput;
};


export class MutationCreateUserArgs {
  data: CreateUserInput;
};


export class MutationCreateVehicleArgs {
  data: CreateVehicleInput;
};


export class MutationDeleteVehicleArgs {
  id: Scalars['ID'];
};


export class MutationFinishServiceRequestArgs {
  id: Scalars['ID'];
};


export class MutationForgotPasswordArgs {
  identifier: Scalars['String'];
};


export class MutationInspectServiceRequestArgs {
  data: InspectServiceRequestInput;
};


export class MutationInspectTruckArgs {
  data: InspectTruckInput;
};


export class MutationLoginArgs {
  data: AuthInput;
};


export class MutationRegisterCaronaEntryArgs {
  data: RegisterCaronaEntryInput;
};


export class MutationRegisterCaronaExitArgs {
  data: RegisterCaronaExitInput;
};


export class MutationRegisterDaycareEntryArgs {
  data: RegisterDaycareStayInput;
};


export class MutationRegisterDaycareExitArgs {
  data: RegisterDaycareStayInput;
};


export class MutationReleaseTruckArgs {
  data: ReleaseTruckInput;
};


export class MutationRemoveAccessArgs {
  id: Scalars['ID'];
};


export class MutationRemoveAlarmArgs {
  id: Scalars['String'];
};


export class MutationRemoveBlocArgs {
  id: Scalars['ID'];
};


export class MutationRemoveCameraArgs {
  id: Scalars['String'];
};


export class MutationRemoveCaronaArgs {
  id: Scalars['ID'];
};


export class MutationRemoveCheckListAccessArgs {
  id: Scalars['String'];
};


export class MutationRemoveCheckListAlarmArgs {
  id: Scalars['String'];
};


export class MutationRemoveCheckListCftvArgs {
  id: Scalars['String'];
};


export class MutationRemoveCountryArgs {
  id: Scalars['String'];
};


export class MutationRemoveDaycareChildArgs {
  id: Scalars['ID'];
};


export class MutationRemoveDaycareGuardianArgs {
  id: Scalars['ID'];
};


export class MutationRemoveEnumTypeArgs {
  id: Scalars['String'];
};


export class MutationRemoveOccurrenceArgs {
  id: Scalars['String'];
};


export class MutationRemoveOccurrenceFileArgs {
  id: Scalars['String'];
};


export class MutationRemovePhysicalSecurityArgs {
  id: Scalars['String'];
};


export class MutationRemovePhysicalSecurityMemberArgs {
  id: Scalars['String'];
};


export class MutationRemovePolicyArgs {
  id: Scalars['ID'];
};


export class MutationRemoveServiceRequestArgs {
  id: Scalars['ID'];
};


export class MutationRemoveTruckArgs {
  id: Scalars['ID'];
};


export class MutationRemoveTruckChecklistPhotoArgs {
  id: Scalars['ID'];
};


export class MutationRemoveUnityArgs {
  id: Scalars['String'];
};


export class MutationRemoveUserArgs {
  id: Scalars['String'];
};


export class MutationResetPasswordArgs {
  data: ResetPasswordInput;
};


export class MutationUpdateAccessArgs {
  data: UpdateAccessInput;
};


export class MutationUpdateAlarmArgs {
  data: UpdateAlarmInput;
};


export class MutationUpdateBlocArgs {
  data: UpdateBlocInput;
};


export class MutationUpdateCameraArgs {
  data: UpdateCameraInput;
};


export class MutationUpdateCheckListAccessArgs {
  data: CheckListUpdateInput;
};


export class MutationUpdateCheckListAccessItemStatusArgs {
  data: CheckListItemStatusUpdateInput;
};


export class MutationUpdateCheckListAlarmArgs {
  data: CheckListAlarmUpdateInput;
};


export class MutationUpdateCheckListAlarmItemStatusArgs {
  data: CheckListAlarmItemStatusUpdateInput;
};


export class MutationUpdateCheckListCftvArgs {
  data: CheckListCftvUpdateInput;
};


export class MutationUpdateCheckListCftvItemStatusArgs {
  data: CheckListCftvItemStatusUpdateInput;
};


export class MutationUpdateDaycareChildArgs {
  data: UpdateDaycareChildInput;
};


export class MutationUpdateDaycareGuardianArgs {
  data: UpdateDaycareGuardianInput;
};


export class MutationUpdateEnumTypeArgs {
  data: UpdateEnumTypeInput;
};


export class MutationUpdateOccurrenceArgs {
  data: UpdateOccurrenceInput;
  userData: Array<UpdateOccurrenceUserInput>;
};


export class MutationUpdatePhysicalSecurityArgs {
  data: UpdatePhysicalSecurityInput;
};


export class MutationUpdatePolicyArgs {
  data: UpdatePolicyInput;
};


export class MutationUpdateServiceRequestArgs {
  data: UpdateServiceRequestInput;
};


export class MutationUpdateServiceRequestDetailArgs {
  data: UpdateServiceRequestDetailInput;
};


export class MutationUpdateTruckArgs {
  data: UpdateTruckInput;
};


export class MutationUpdateTruckPlateArgs {
  data: UpdateTruckPlateInput;
};


export class MutationUpdateUnityArgs {
  data: UpdateUnityInput;
};


export class MutationUpdateUserArgs {
  data: UpdateUserInput;
};


export class MutationUpdateVehicleArgs {
  data: UpdateVehicleInput;
};

export class Occurrence {
  abscent?: Maybe<Scalars['Boolean']>;
  area?: Maybe<Scalars['String']>;
  areaResponsible?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  authorDetail?: Maybe<Scalars['String']>;
  authorship?: Maybe<Scalars['String']>;
  bulletinNumber?: Maybe<Scalars['String']>;
  classification?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Float']>;
  colaborators?: Maybe<Array<OccurrenceColaborator>>;
  company?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  department?: Maybe<Scalars['String']>;
  directLoss?: Maybe<Scalars['Float']>;
  directLossCost?: Maybe<Scalars['Float']>;
  directLossDescription?: Maybe<Scalars['String']>;
  directLossObjects?: Maybe<Scalars['String']>;
  directLossType?: Maybe<Scalars['String']>;
  directLossValue?: Maybe<Scalars['Float']>;
  employeesInvolved?: Maybe<Scalars['String']>;
  favor?: Maybe<Scalars['String']>;
  favorDetail?: Maybe<Scalars['String']>;
  favorOther?: Maybe<Scalars['String']>;
  files?: Maybe<Array<OccurrenceFile>>;
  hour?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  indirectLoss?: Maybe<Scalars['Float']>;
  indirectLossActivity?: Maybe<Scalars['String']>;
  indirectLossCost?: Maybe<Scalars['Float']>;
  indirectLossInterruption?: Maybe<Scalars['Boolean']>;
  indirectLossRemoval?: Maybe<Scalars['Float']>;
  indirectLossTime?: Maybe<Scalars['String']>;
  measuresResponsibleName?: Maybe<Scalars['String']>;
  measuresResponsibleRole?: Maybe<Scalars['String']>;
  mitigatingDeadLine?: Maybe<Scalars['DateTime']>;
  mitigatingMeasuresDescription?: Maybe<Scalars['String']>;
  occurrenceDetail?: Maybe<Scalars['String']>;
  place?: Maybe<Scalars['String']>;
  recoveryStatus?: Maybe<Scalars['String']>;
  recoveryStatusDescription?: Maybe<Scalars['String']>;
  recurrent?: Maybe<Scalars['Boolean']>;
  responsible?: Maybe<Scalars['String']>;
  responsibleCommunicatedOther?: Maybe<Scalars['String']>;
  responsiblesCommunicated?: Maybe<Array<OccurrenceResponsible>>;
  retrievedValue?: Maybe<Scalars['Float']>;
  sinister?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  step?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
  typeDetail?: Maybe<Scalars['String']>;
  unity?: Maybe<Unity>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<Array<OccurrenceUser>>;
  victims?: Maybe<Scalars['String']>;
  victimsDetail?: Maybe<Scalars['String']>;
  violence?: Maybe<Scalars['String']>;
};

export class OccurrenceActivityDashboard {
  month: Scalars['String'];
  time: Scalars['Float'];
};

export class OccurrenceAvoidedRecoveredDashboard {
  count: Scalars['Float'];
  status: Scalars['String'];
};

export class OccurrenceColaborator {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  occurrence?: Maybe<Occurrence>;
  re?: Maybe<Scalars['String']>;
};

export class OccurrenceFile {
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  media: Scalars['String'];
  occurrence: Occurrence;
  originalName: Scalars['String'];
  url: Scalars['String'];
};

export class OccurrenceLossDashboard {
  direct: Scalars['Float'];
  indirect: Scalars['Float'];
  month: Scalars['String'];
  total: Scalars['Float'];
};

export class OccurrencePage {
  PageSize: Scalars['Int'];
  PreviousPage: Scalars['Boolean'];
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  occurrence: Array<Occurrence>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class OccurrenceResponsible {
  id: Scalars['String'];
  occurrence?: Maybe<Occurrence>;
  type?: Maybe<Scalars['String']>;
};

export class OccurrenceUser {
  address?: Maybe<Scalars['String']>;
  addressNumber?: Maybe<Scalars['String']>;
  birth?: Maybe<Scalars['DateTime']>;
  cep?: Maybe<Scalars['String']>;
  complement?: Maybe<Scalars['String']>;
  document?: Maybe<Scalars['String']>;
  father?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  jobRole?: Maybe<Scalars['String']>;
  mother?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nationality?: Maybe<Scalars['String']>;
  occurrence: Occurrence;
  rg?: Maybe<Scalars['String']>;
  sector?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  uf?: Maybe<Scalars['String']>;
};

export class OccurrencesDashboard {
  date: Scalars['String'];
  detail: Array<OccurrencesDashboardDetail>;
  month: Scalars['String'];
  year: Scalars['String'];
};

export class OccurrencesDashboardDetail {
  count: Scalars['String'];
  type: Scalars['String'];
};

export class PhysicalSecurity {
  cnpj: Scalars['String'];
  code?: Maybe<Scalars['Float']>;
  companyStatus: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  members?: Maybe<Array<PhysicalSecurityMember>>;
  name: Scalars['String'];
  phone: Scalars['String'];
  segment: Scalars['String'];
  stationNumber: Scalars['Float'];
};

export class PhysicalSecurityMember {
  deletedAt?: Maybe<Scalars['DateTime']>;
  document: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  physicalSecurity?: Maybe<PhysicalSecurity>;
  status: Scalars['Boolean'];
};

export class PhysicalSecurityPage {
  PageSize: Scalars['Int'];
  PreviousPage: Scalars['Boolean'];
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  physicalSecurity: Array<PhysicalSecurity>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class Policy {
  country?: Maybe<Country>;
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  isPortuguese: Scalars['Boolean'];
  isSpanish: Scalars['Boolean'];
  link: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export class Query {
  access: Access;
  accessByBloc: Array<Access>;
  accesses: Array<Access>;
  alarm: Alarm;
  alarmByBloc: Array<Alarm>;
  alarms: Array<Alarm>;
  bloc: Bloc;
  blocByUnity: Array<Bloc>;
  blocs: Array<Bloc>;
  bot: Scalars['String'];
  camera: Camera;
  cameraByBloc: Array<Camera>;
  cameras: Array<Camera>;
  carona?: Maybe<CarpoolRecord>;
  caronaBlocsAvailability: Array<BlocAvailability>;
  caronaVagaOcupada: Scalars['Boolean'];
  checkListAccessFinished: CheckListAccessFinishedDto;
  checkListAccessUnfinished: ChecklistAccessUnfinishedDto;
  checkListAlarmFinished: CheckListAlarmFinishedDto;
  checkListAlarmUnfinished: CheckListAlarmUnfinishedDto;
  checkListCftvFinished: CheckListCftvFinishedDto;
  checkListCftvUnfinished: CheckListCftvUnfinishedDto;
  /** Return All Countries */
  countries: Array<Country>;
  /** Get Country By ID */
  country: Country;
  /** Return User Logged */
  currentUser: User;
  daycareChild: DaycareChild;
  enumByCulture: Array<EnumType>;
  enumByType: Array<EnumType>;
  enumByTypeCulture: Array<EnumType>;
  enumByUnity: Array<EnumType>;
  enumType: EnumType;
  enumTypes: Array<EnumType>;
  equipments: Array<Equipment>;
  findCPF: Truck;
  /** Return All Unities By CountryId */
  getUnitiesByCountry: Array<Unity>;
  occurrence: Occurrence;
  /** Return Activity count */
  occurrenceActivityDashboard: Array<OccurrenceActivityDashboard>;
  /** Return Avoided and Recovered count */
  occurrenceAvoidedRecoveredDashboard: Array<OccurrenceAvoidedRecoveredDashboard>;
  /** Return type occurrence count */
  occurrenceDashboard: Array<OccurrencesDashboard>;
  /** Return loss count */
  occurrenceLossDashboard: Array<OccurrenceLossDashboard>;
  occurrences: Array<Occurrence>;
  openCaronaRecord?: Maybe<CarpoolRecord>;
  openCaronaRecords: Array<CarpoolRecord>;
  physicalSecurities: Array<PhysicalSecurity>;
  physicalSecurity: PhysicalSecurity;
  policies: Array<Policy>;
  policy: Policy;
  searchAccess: AccessPage;
  searchAlarm: AlarmPage;
  searchBloc: BlocPage;
  searchCamera: CameraPage;
  searchCarona: CaronaPage;
  searchCheckListAccess: SearchCheckListAccessResult;
  searchCheckListAlarm: SearchCheckListAlarmResult;
  searchCheckListCftv: SearchCheckListCftvResult;
  searchDaycareChild: DaycareChildPage;
  searchDaycarePickup: DaycarePickupPage;
  searchDaycarePickupCandidates: Array<DaycarePickupCandidate>;
  searchEnumType: EnumTypePage;
  searchOccurrence: OccurrencePage;
  searchPhysicalSecurity: PhysicalSecurityPage;
  searchPolicy: Array<Policy>;
  searchServiceRequest: ServicePage;
  searchTruck: TruckPage;
  searchUnity: UnityPage;
  searchUsers: UserPage;
  serviceRequest: ServiceRequest;
  serviceRequestInspection: ServiceRequestInspect;
  truck: Truck;
  truckChecklistEnum: Array<CreateTruckCheckListObject>;
  /** Return All Unities */
  unities: Array<Unity>;
  /** Get Unity By ID */
  unity: Unity;
  unityBlocs: Array<UnityBlocDto>;
  /** Return User By Id */
  user: User;
  /** Return User By Email */
  userByEmail: User;
  /** Return All Users */
  users: Array<User>;
  vehiclesByCpf: Array<Vehicle>;
};


export class QueryAccessArgs {
  id: Scalars['ID'];
};


export class QueryAccessByBlocArgs {
  id: Scalars['String'];
};


export class QueryAlarmArgs {
  id: Scalars['String'];
};


export class QueryAlarmByBlocArgs {
  id: Scalars['String'];
};


export class QueryBlocArgs {
  id: Scalars['ID'];
};


export class QueryBlocByUnityArgs {
  id: Scalars['String'];
};


export class QueryCameraArgs {
  id: Scalars['String'];
};


export class QueryCameraByBlocArgs {
  id: Scalars['String'];
};


export class QueryCaronaArgs {
  id: Scalars['ID'];
};


export class QueryCaronaBlocsAvailabilityArgs {
  unity: Scalars['ID'];
};


export class QueryCaronaVagaOcupadaArgs {
  unity: Scalars['ID'];
  vaga: Scalars['String'];
};


export class QueryCheckListAccessFinishedArgs {
  data: CheckListAccessFinishedFilter;
};


export class QueryCheckListAccessUnfinishedArgs {
  id: Scalars['String'];
};


export class QueryCheckListAlarmFinishedArgs {
  data: CheckListAlarmFinishedFilter;
};


export class QueryCheckListAlarmUnfinishedArgs {
  id: Scalars['String'];
};


export class QueryCheckListCftvFinishedArgs {
  data: CheckListCftvFinishedFilter;
};


export class QueryCheckListCftvUnfinishedArgs {
  id: Scalars['String'];
};


export class QueryCountryArgs {
  id: Scalars['String'];
};


export class QueryDaycareChildArgs {
  id: Scalars['ID'];
};


export class QueryEnumByCultureArgs {
  culture: Scalars['String'];
};


export class QueryEnumByTypeArgs {
  type: Scalars['String'];
};


export class QueryEnumByTypeCultureArgs {
  culture: Scalars['String'];
  type: Scalars['String'];
};


export class QueryEnumByUnityArgs {
  id: Scalars['String'];
};


export class QueryEnumTypeArgs {
  id: Scalars['String'];
};


export class QueryFindCpfArgs {
  cpf: Scalars['String'];
};


export class QueryGetUnitiesByCountryArgs {
  id: Scalars['String'];
};


export class QueryOccurrenceArgs {
  id: Scalars['String'];
};


export class QueryOccurrenceActivityDashboardArgs {
  data: SearchStatisticInput;
};


export class QueryOccurrenceAvoidedRecoveredDashboardArgs {
  data: SearchStatisticInput;
};


export class QueryOccurrenceDashboardArgs {
  data: SearchStatisticInput;
};


export class QueryOccurrenceLossDashboardArgs {
  data: SearchStatisticInput;
};


export class QueryOpenCaronaRecordArgs {
  term: Scalars['String'];
  unity: Scalars['ID'];
};


export class QueryOpenCaronaRecordsArgs {
  term: Scalars['String'];
  unity: Scalars['ID'];
};


export class QueryPhysicalSecurityArgs {
  id: Scalars['String'];
};


export class QueryPolicyArgs {
  id: Scalars['String'];
};


export class QuerySearchAccessArgs {
  data: SearchAccessInput;
};


export class QuerySearchAlarmArgs {
  data: SearchAlarmInput;
};


export class QuerySearchBlocArgs {
  data: SearchBlocInput;
};


export class QuerySearchCameraArgs {
  data: SearchCameraInput;
};


export class QuerySearchCaronaArgs {
  data: SearchCaronaInput;
};


export class QuerySearchCheckListAccessArgs {
  data: SearchCheckListAccess;
};


export class QuerySearchCheckListAlarmArgs {
  data: SearchCheckListAlarm;
};


export class QuerySearchCheckListCftvArgs {
  data: SearchCheckListCftv;
};


export class QuerySearchDaycareChildArgs {
  data: SearchDaycareChildInput;
};


export class QuerySearchDaycarePickupArgs {
  data: SearchDaycarePickupInput;
};


export class QuerySearchDaycarePickupCandidatesArgs {
  term: Scalars['String'];
};


export class QuerySearchEnumTypeArgs {
  data: SearchEnumTypeInput;
};


export class QuerySearchOccurrenceArgs {
  data: SearchOccurrenceInput;
  page?: Scalars['Int'];
};


export class QuerySearchPhysicalSecurityArgs {
  data: SearchPhysicalSecurityInput;
};


export class QuerySearchPolicyArgs {
  data: SearchPolicyInput;
};


export class QuerySearchServiceRequestArgs {
  data: SearchServiceRequestInput;
};


export class QuerySearchTruckArgs {
  data: SearchTruckInput;
};


export class QuerySearchUnityArgs {
  data: SearchUnityInput;
};


export class QuerySearchUsersArgs {
  data: SearchUserInput;
  page?: Scalars['Int'];
};


export class QueryServiceRequestArgs {
  id: Scalars['ID'];
};


export class QueryServiceRequestInspectionArgs {
  id: Scalars['ID'];
};


export class QueryTruckArgs {
  id: Scalars['ID'];
};


export class QueryUnityArgs {
  id: Scalars['String'];
};


export class QueryUnityBlocsArgs {
  type: Scalars['String'];
};


export class QueryUserArgs {
  id: Scalars['String'];
};


export class QueryUserByEmailArgs {
  email: Scalars['String'];
};


export class QueryVehiclesByCpfArgs {
  cpf: Scalars['String'];
};

export class RegisterCaronaEntryInput {
  bloc: BaseInput;
  cpf?: InputMaybe<Scalars['String']>;
  employeeName?: InputMaybe<Scalars['String']>;
  entryAt?: InputMaybe<Scalars['DateTime']>;
  entryNote?: InputMaybe<Scalars['String']>;
  isManualEntry?: InputMaybe<Scalars['Boolean']>;
  licensePlate?: InputMaybe<Scalars['String']>;
  qrRaw?: InputMaybe<Scalars['String']>;
  re?: InputMaybe<Scalars['String']>;
  registration?: InputMaybe<Scalars['String']>;
  unity?: InputMaybe<BaseInput>;
  vaga?: InputMaybe<Scalars['String']>;
};

export class RegisterCaronaExitInput {
  exitAt?: InputMaybe<Scalars['DateTime']>;
  exitNote?: InputMaybe<Scalars['String']>;
  isManualExit?: InputMaybe<Scalars['Boolean']>;
  record: BaseInput;
};

export class RegisterDaycareStayInput {
  childIds: Array<Scalars['ID']>;
  confirmWarnings?: InputMaybe<Scalars['Boolean']>;
  employeeRe?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  personDocument?: InputMaybe<Scalars['String']>;
  personKind: Scalars['String'];
  personName: Scalars['String'];
};

export class ReleaseTruckInput {
  comment?: InputMaybe<Scalars['String']>;
  exitWithTrailer?: InputMaybe<Scalars['Boolean']>;
  receipt?: InputMaybe<Array<ReleaseTruckReceiptInput>>;
  sealComment?: InputMaybe<Scalars['String']>;
  sealStatus?: InputMaybe<Scalars['Boolean']>;
  truck: ReleaseTruckTruckInput;
};

export class ReleaseTruckReceiptInput {
  comment: Scalars['String'];
  /** Inspect Receipt id */
  receipt: ReleaseTruckReceiptReceiptInput;
  status: Scalars['Boolean'];
};

export class ReleaseTruckReceiptReceiptInput {
  id: Scalars['String'];
};

export class ReleaseTruckTruckInput {
  id: Scalars['String'];
};

export class ResetPasswordInput {
  code: Scalars['String'];
  identifier: Scalars['String'];
  newPassword: Scalars['String'];
};

export class SearchAccessInput {
  bloc?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  unity?: InputMaybe<Scalars['String']>;
};

export class SearchAlarmInput {
  bloc?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  unity?: InputMaybe<Scalars['String']>;
};

export class SearchBlocInput {
  country?: InputMaybe<Scalars['String']>;
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  unity?: InputMaybe<Scalars['String']>;
};

export class SearchCameraInput {
  bloc?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  unity?: InputMaybe<Scalars['String']>;
};

export class SearchCaronaInput {
  end?: InputMaybe<Scalars['DateTime']>;
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['DateTime']>;
  /** ENUM 'inside' | 'exited' */
  status?: InputMaybe<Scalars['String']>;
  unity?: InputMaybe<Scalars['String']>;
};

export class SearchCheckListAccess {
  countryId?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['DateTime']>;
  page?: InputMaybe<Scalars['Int']>;
  responsible?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['DateTime']>;
  unityId?: InputMaybe<Scalars['String']>;
};

export class SearchCheckListAccessResult {
  PageSize: Scalars['Int'];
  PreviousPage: Scalars['Boolean'];
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  result: Array<SearchCheckListAccessResultItem>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class SearchCheckListAccessResultItem {
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  damage: Scalars['Int'];
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<User>;
  id: Scalars['ID'];
  items?: Maybe<Array<CheckListAccessItem>>;
  late: Scalars['Int'];
  status?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  unity?: Maybe<Unity>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export class SearchCheckListAlarm {
  countryId?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['DateTime']>;
  page?: InputMaybe<Scalars['Int']>;
  responsible?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['DateTime']>;
  unityId?: InputMaybe<Scalars['String']>;
};

export class SearchCheckListAlarmResult {
  PageSize: Scalars['Int'];
  PreviousPage: Scalars['Boolean'];
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  result: Array<SearchCheckListAlarmResultItem>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class SearchCheckListAlarmResultItem {
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  damage: Scalars['Int'];
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<User>;
  id: Scalars['ID'];
  items?: Maybe<Array<CheckListAlarmItem>>;
  late: Scalars['Int'];
  status?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  unity?: Maybe<Unity>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export class SearchCheckListCftv {
  countryId?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['DateTime']>;
  page?: InputMaybe<Scalars['Int']>;
  responsible?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['DateTime']>;
  unityId?: InputMaybe<Scalars['String']>;
};

export class SearchCheckListCftvResult {
  PageSize: Scalars['Int'];
  PreviousPage: Scalars['Boolean'];
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  result: Array<SearchCheckListCftvResultItem>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class SearchCheckListCftvResultItem {
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  damage: Scalars['Int'];
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<User>;
  id: Scalars['ID'];
  items?: Maybe<Array<CheckListCftvItem>>;
  late: Scalars['Int'];
  status?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  unity?: Maybe<Unity>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export class SearchDaycareChildInput {
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  unityId?: InputMaybe<Scalars['String']>;
};

export class SearchDaycarePickupInput {
  endDate?: InputMaybe<Scalars['DateTime']>;
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  unityId?: InputMaybe<Scalars['String']>;
};

export class SearchEnumTypeInput {
  country?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  unity?: InputMaybe<Scalars['String']>;
};

export class SearchOccurrenceInput {
  code?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['DateTime']>;
  /** enum pending|done */
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  unityId?: InputMaybe<Scalars['String']>;
};

export class SearchPhysicalSecurityInput {
  end?: InputMaybe<Scalars['DateTime']>;
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['DateTime']>;
};

export class SearchPolicyInput {
  country?: InputMaybe<Scalars['String']>;
  keyword?: InputMaybe<Scalars['String']>;
};

export class SearchServiceRequestInput {
  companyName?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['DateTime']>;
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['DateTime']>;
  /** ENUM finished|check|inspect|expired */
  status?: InputMaybe<Scalars['String']>;
  unity?: InputMaybe<Scalars['String']>;
};

export class SearchStatisticInput {
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
  unity?: InputMaybe<Scalars['String']>;
};

export class SearchTruckInput {
  end?: InputMaybe<Scalars['DateTime']>;
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['DateTime']>;
  /** ENUM finished|release|inspect */
  status?: InputMaybe<Scalars['String']>;
  unity?: InputMaybe<Scalars['String']>;
};

export class SearchUnityInput {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['DateTime']>;
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['DateTime']>;
  unity?: InputMaybe<Scalars['String']>;
};

export class SearchUserInput {
  countryId?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['DateTime']>;
  keyword?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['DateTime']>;
  unityId?: InputMaybe<Scalars['String']>;
};

export class ServicePage {
  PageSize: Scalars['Int'];
  PreviousPage: Scalars['Boolean'];
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  results: Array<ServiceRequest>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class ServiceRequest {
  area: Scalars['String'];
  cnpj?: Maybe<Scalars['String']>;
  company: Scalars['String'];
  cpf: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  entranceDate: Scalars['DateTime'];
  exitDate: Scalars['DateTime'];
  helper: Array<ServiceRequestHelper>;
  id: Scalars['String'];
  inspect: Array<ServiceRequestInspect>;
  leftover?: Maybe<Array<ServiceRequestPoolItem>>;
  licensePlate?: Maybe<Scalars['String']>;
  meal?: Maybe<Scalars['String']>;
  mealContract?: Maybe<Scalars['String']>;
  mealCostCenter?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  pool?: Maybe<Array<ServiceRequestPoolItem>>;
  requestNumber?: Maybe<Scalars['String']>;
  serviceRequestVehicle: Array<ServiceRequestVehicle>;
  status: Scalars['String'];
  unity?: Maybe<Unity>;
  updatedAt: Scalars['DateTime'];
  vehicle?: Maybe<Scalars['String']>;
  vehicles?: Maybe<Array<ServiceRequestVehicle>>;
  virtualEquipment?: Maybe<Array<ServiceRequestEquipment>>;
};

export class ServiceRequestEquipment {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  quantity?: Maybe<Scalars['Float']>;
  serviceRequestInspect?: Maybe<ServiceRequestInspect>;
};

export class ServiceRequestHelper {
  deletedAt?: Maybe<Scalars['DateTime']>;
  departureDate?: Maybe<Scalars['DateTime']>;
  doc: Scalars['String'];
  entryDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  name: Scalars['String'];
  serviceRequest: ServiceRequest;
};

export class ServiceRequestInspect {
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  date: Scalars['DateTime'];
  equipment?: Maybe<Array<ServiceRequestEquipment>>;
  equipmentImage?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  obs?: Maybe<Scalars['String']>;
  others?: Maybe<Scalars['String']>;
  serviceRequest?: Maybe<ServiceRequest>;
  signature?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  vehicle?: Maybe<ServiceRequestVehicle>;
  vehicleId?: Maybe<Scalars['String']>;
};

export class ServiceRequestPoolItem {
  entered: Scalars['Int'];
  exited: Scalars['Int'];
  name: Scalars['String'];
  remaining: Scalars['Int'];
};

export class ServiceRequestVehicle {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  licensePlate?: Maybe<Scalars['String']>;
  serviceRequest: ServiceRequest;
  state?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  vehicle?: Maybe<Scalars['String']>;
};

export class Truck {
  autoPhoto?: Maybe<Scalars['String']>;
  checklist?: Maybe<Array<TruckChecklist>>;
  company?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  driverCpf?: Maybe<Scalars['String']>;
  driverName?: Maybe<Scalars['String']>;
  helpers?: Maybe<Array<TruckHelper>>;
  id: Scalars['String'];
  inspection?: Maybe<TruckInspection>;
  isAuto?: Maybe<Scalars['Boolean']>;
  licensePlate?: Maybe<Scalars['String']>;
  licensePlatePhoto?: Maybe<Scalars['String']>;
  place?: Maybe<Scalars['String']>;
  placeCollect?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  receipts?: Maybe<Array<TruckReceipt>>;
  release?: Maybe<TruckRelease>;
  seal?: Maybe<Scalars['Boolean']>;
  sealCorrect?: Maybe<Scalars['Boolean']>;
  sealNumber?: Maybe<Scalars['String']>;
  sealPhoto?: Maybe<Scalars['String']>;
  signature?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  trailerLicensePlate?: Maybe<Scalars['String']>;
  trailerLicensePlatePhoto?: Maybe<Scalars['String']>;
  unity?: Maybe<Unity>;
};

export class TruckChecklist {
  comment?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  order?: Maybe<Scalars['Float']>;
  photo?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  statusTruck?: Maybe<Scalars['String']>;
  truck?: Maybe<Truck>;
  type: Scalars['String'];
};

export class TruckHelper {
  id: Scalars['String'];
  name: Scalars['String'];
  rg: Scalars['String'];
  truck?: Maybe<Truck>;
};

export class TruckInspection {
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  date: Scalars['DateTime'];
  equipment?: Maybe<Array<TruckInspectionEquipment>>;
  id: Scalars['String'];
  receipt?: Maybe<Array<TruckInspectionReceipt>>;
  sealNumber?: Maybe<Scalars['String']>;
  sealPhoto?: Maybe<Scalars['String']>;
  trailerLicensePlate?: Maybe<Scalars['String']>;
  truck?: Maybe<Truck>;
};

export class TruckInspectionEquipment {
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  inspection?: Maybe<TruckInspection>;
  name: Scalars['String'];
  quantity?: Maybe<Scalars['Float']>;
};

export class TruckInspectionReceipt {
  id: Scalars['String'];
  inspection?: Maybe<TruckInspection>;
  receipt: Scalars['String'];
  releaseReceipt?: Maybe<TruckReleaseReceipt>;
};

export class TruckPage {
  PageSize: Scalars['Int'];
  PreviousPage: Scalars['Boolean'];
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  results: Array<Truck>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class TruckReceipt {
  id: Scalars['String'];
  receipt: Scalars['String'];
  truck?: Maybe<Truck>;
};

export class TruckRelease {
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  exitWithTrailer?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  receipt?: Maybe<Array<TruckReleaseReceipt>>;
  sealComment?: Maybe<Scalars['String']>;
  sealPhoto?: Maybe<Scalars['String']>;
  sealStatus?: Maybe<Scalars['Boolean']>;
  truck?: Maybe<Truck>;
};

export class TruckReleaseReceipt {
  comment: Scalars['String'];
  id: Scalars['String'];
  receipt?: Maybe<TruckInspectionReceipt>;
  release?: Maybe<TruckRelease>;
  status: Scalars['Boolean'];
};

export class Unity {
  blocs?: Maybe<Array<Bloc>>;
  carpoolRecords?: Maybe<Array<CarpoolRecord>>;
  checkListAccess?: Maybe<CheckListAccess>;
  checkListAlarm?: Maybe<CheckListAlarm>;
  checkListCftv?: Maybe<CheckListCftv>;
  city?: Maybe<Scalars['String']>;
  code: Scalars['Float'];
  country?: Maybe<Country>;
  createdAt?: Maybe<Scalars['DateTime']>;
  daycareChildren?: Maybe<Array<DaycareChild>>;
  daycareEmployees?: Maybe<Array<DaycareEmployee>>;
  daycarePickupRecords?: Maybe<Array<DaycarePickupRecord>>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  enum?: Maybe<Array<EnumType>>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  occurrences: Array<Occurrence>;
  serviceRequest?: Maybe<ServiceRequest>;
  truck?: Maybe<Truck>;
  users?: Maybe<Array<User>>;
};

export class UnityBlocDto {
  bloc: Bloc;
  summary: Scalars['Int'];
};

export class UnityPage {
  PageSize: Scalars['Int'];
  PreviousPage: Scalars['Boolean'];
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  results: Array<Unity>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class UpdateAccessInput {
  bloc?: InputMaybe<CreateAccessBlocInput>;
  id: Scalars['ID'];
  place?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
  /** ENUM biometry|facialBiometrics|badge */
  type?: InputMaybe<Scalars['String']>;
};

export class UpdateAlarmInput {
  bloc?: InputMaybe<CreateAlarmBlocInput>;
  id: Scalars['String'];
  place?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
};

export class UpdateBlocInput {
  capacity?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  unity?: InputMaybe<CreateBlocUnityInput>;
};

export class UpdateCameraInput {
  bloc?: InputMaybe<CreateCameraBlocInput>;
  id: Scalars['String'];
  mode?: InputMaybe<Scalars['String']>;
  place?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export class UpdateDaycareChildInput {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

export class UpdateDaycareGuardianInput {
  documentRaw?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  kind?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export class UpdateEnumTypeInput {
  culture?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  detail?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
  unity?: InputMaybe<CreateEnumTypeUnityInput>;
  value?: InputMaybe<Scalars['String']>;
};

export class UpdateOccurrenceColaboratorsInput {
  name: Scalars['String'];
  re: Scalars['String'];
};

export class UpdateOccurrenceInput {
  abscent?: InputMaybe<Scalars['Boolean']>;
  area?: InputMaybe<Scalars['String']>;
  areaResponsible?: InputMaybe<Scalars['String']>;
  /** Enum employee|third|hired|visitor|invader|client|others */
  author?: InputMaybe<Scalars['String']>;
  /** Enum known|unknown */
  authorship?: InputMaybe<Scalars['String']>;
  bulletinNumber?: InputMaybe<Scalars['String']>;
  /** Enum effective|try|recovered */
  classification?: InputMaybe<Scalars['String']>;
  colaborator?: InputMaybe<Array<UpdateOccurrenceColaboratorsInput>>;
  company?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
  department?: InputMaybe<Scalars['String']>;
  /** decimal(10,2) */
  directLoss?: InputMaybe<Scalars['Float']>;
  /** decimal(10,2) */
  directLossCost?: InputMaybe<Scalars['Float']>;
  directLossDescription?: InputMaybe<Scalars['String']>;
  directLossObjects?: InputMaybe<Scalars['String']>;
  /** Enum value|material|others */
  directLossType?: InputMaybe<Scalars['String']>;
  /** decimal(10,2) */
  directLossValue?: InputMaybe<Scalars['Float']>;
  /** Enum yes|no|likely */
  employeesInvolved?: InputMaybe<Scalars['String']>;
  /** controller_failure|absence_of_physical_barriers|absence_of_cftv|failure_of_procedures|lack_of_vigilance|process_failure|employee_facilitation|employee_participation|inadequate_storage|lack_of_locks|inadequate_architecture|absence_alarms|others */
  favor?: InputMaybe<Scalars['String']>;
  favorDetail?: InputMaybe<Scalars['String']>;
  favorOther?: InputMaybe<Scalars['String']>;
  hour?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  /** decimal(10,2) */
  indirectLoss?: InputMaybe<Scalars['Float']>;
  indirectLossActivity?: InputMaybe<Scalars['String']>;
  /** decimal(10,2) */
  indirectLossCost?: InputMaybe<Scalars['Float']>;
  indirectLossInterruption?: InputMaybe<Scalars['Boolean']>;
  /** decimal(10,2) */
  indirectLossRemoval?: InputMaybe<Scalars['Float']>;
  indirectLossTime?: InputMaybe<Scalars['String']>;
  measuresResponsibleName?: InputMaybe<Scalars['String']>;
  measuresResponsibleRole?: InputMaybe<Scalars['String']>;
  mitigatingDeadLine?: InputMaybe<Scalars['DateTime']>;
  mitigatingMeasuresDescription?: InputMaybe<Scalars['String']>;
  occurrenceDetail?: InputMaybe<Scalars['String']>;
  place?: InputMaybe<Scalars['String']>;
  /** Enum avoided|retrieved|lost */
  recoveryStatus?: InputMaybe<Scalars['String']>;
  recoveryStatusDescription?: InputMaybe<Scalars['String']>;
  recurrent?: InputMaybe<Scalars['Boolean']>;
  responsible?: InputMaybe<Scalars['String']>;
  responsibleCommunicated?: InputMaybe<Array<UpdateOccurrenceUserResponsibleCommunicatedInput>>;
  responsibleCommunicatedOther?: InputMaybe<Scalars['String']>;
  /** decimal(10,2) */
  retrievedValue?: InputMaybe<Scalars['Float']>;
  /** Enum opportunity|planned|accident|major */
  sinister?: InputMaybe<Scalars['String']>;
  step?: InputMaybe<Scalars['Int']>;
  /** Enum rob|theft|fraud|misplacement(extravio)|damage|vandalism|kidnapping(sequestro)|aggression|drug_trafficking|drug_consumption|disintelligence|sex_crime|environment_crime|weapon|melee_weapon|others */
  type?: InputMaybe<Scalars['String']>;
  typeDetail?: InputMaybe<Scalars['String']>;
  unity?: InputMaybe<CreateOccurrenceunityInput>;
  /** Enum employee|third|hired|visitor|external_agent|client|company|others */
  victims?: InputMaybe<Scalars['String']>;
  victimsDetail?: InputMaybe<Scalars['String']>;
  /** Enum no_physical_aggression|no_injury|with_injury|death */
  violence?: InputMaybe<Scalars['String']>;
};

export class UpdateOccurrenceUserInput {
  address?: InputMaybe<Scalars['String']>;
  addressNumber?: InputMaybe<Scalars['String']>;
  birth?: InputMaybe<Scalars['DateTime']>;
  cep?: InputMaybe<Scalars['String']>;
  complement?: InputMaybe<Scalars['String']>;
  document?: InputMaybe<Scalars['String']>;
  father?: InputMaybe<Scalars['String']>;
  /** enum masc|fem */
  gender?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  jobRole?: InputMaybe<Scalars['String']>;
  mother?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<Scalars['String']>;
  occurrence?: InputMaybe<UpdateOccurrenceUserOccurrenceInput>;
  rg?: InputMaybe<Scalars['String']>;
  sector?: InputMaybe<Scalars['String']>;
  /** enum legal|pessoal|author */
  type?: InputMaybe<Scalars['String']>;
  uf?: InputMaybe<Scalars['String']>;
};

export class UpdateOccurrenceUserOccurrenceInput {
  id: Scalars['String'];
};

export class UpdateOccurrenceUserResponsibleCommunicatedInput {
  /** Enum security_head|security_manager|adm_manager|executive_manager|military_police|surveillance_team|compliance|civil_police|fireman|others */
  type: Scalars['String'];
};

export class UpdatePhysicalSecurityInput {
  cnpj?: InputMaybe<Scalars['String']>;
  companyStatus?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  membersData?: InputMaybe<Array<UpdatephysicalSecurityMemberInput>>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  segment?: InputMaybe<Scalars['String']>;
  stationNumber?: InputMaybe<Scalars['Int']>;
};

export class UpdatePolicyInput {
  country?: InputMaybe<CreatePolicyCountryInput>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isPortuguese?: InputMaybe<Scalars['Boolean']>;
  isSpanish?: InputMaybe<Scalars['Boolean']>;
  link?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export class UpdateServiceRequestDetailInput {
  area?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  cpf?: InputMaybe<Scalars['String']>;
  helper?: InputMaybe<Array<CreateServiceRequestHelperInput>>;
  id: Scalars['ID'];
  meal?: InputMaybe<Scalars['String']>;
  mealCostCenter?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  requestNumber?: InputMaybe<Scalars['String']>;
  vehicles?: InputMaybe<Array<CreateServiceRequestVehicleInput>>;
};

export class UpdateServiceRequestInput {
  area?: InputMaybe<Scalars['String']>;
  cnpj?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  cpf?: InputMaybe<Scalars['String']>;
  entranceDate?: InputMaybe<Scalars['DateTime']>;
  exitDate?: InputMaybe<Scalars['DateTime']>;
  helper?: InputMaybe<Array<CreateServiceRequestHelperInput>>;
  id: Scalars['ID'];
  meal?: InputMaybe<Scalars['String']>;
  mealCostCenter?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  requestNumber?: InputMaybe<Scalars['String']>;
  unity?: InputMaybe<CreateServiceRequestUnityInput>;
  vehicles?: InputMaybe<Array<CreateServiceRequestVehicleInput>>;
};

export class UpdateTruckCheckListInput {
  comment?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
  /** ENUM accept|error|notApply */
  statusTruck: Scalars['String'];
};

export class UpdateTruckHelperInput {
  name: Scalars['String'];
  rg: Scalars['String'];
};

export class UpdateTruckInput {
  checklist?: InputMaybe<Array<UpdateTruckCheckListInput>>;
  company?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
  driverCpf?: InputMaybe<Scalars['String']>;
  driverName?: InputMaybe<Scalars['String']>;
  helpers?: InputMaybe<Array<UpdateTruckHelperInput>>;
  id: Scalars['ID'];
  isAuto?: InputMaybe<Scalars['Boolean']>;
  licensePlate?: InputMaybe<Scalars['String']>;
  place?: InputMaybe<Scalars['String']>;
  placeCollect?: InputMaybe<Scalars['String']>;
  /** ENUM delivery|shipment|both */
  reason?: InputMaybe<Scalars['String']>;
  receipts?: InputMaybe<Array<UpdateTruckReceiptInput>>;
  seal?: InputMaybe<Scalars['Boolean']>;
  sealCorrect?: InputMaybe<Scalars['Boolean']>;
  sealNumber?: InputMaybe<Scalars['String']>;
  trailerLicensePlate?: InputMaybe<Scalars['String']>;
  unity: CreateTruckUnityInput;
};

export class UpdateTruckPlateInput {
  id: Scalars['ID'];
  licensePlate: Scalars['String'];
  trailerLicensePlate?: InputMaybe<Scalars['String']>;
};

export class UpdateTruckReceiptInput {
  id?: InputMaybe<Scalars['String']>;
  receipt: Scalars['String'];
};

export class UpdateUnityInput {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CreateUnityCountryInput>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

export class UpdateUserInput {
  country?: InputMaybe<CreateUserCountryInput>;
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  identifier?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  office?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  profile?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
  unity?: InputMaybe<CreateUserUnityInput>;
};

export class UpdateVehicleInput {
  id: Scalars['ID'];
  licensePlate: Scalars['String'];
  trailerLicensePlate?: InputMaybe<Scalars['String']>;
};

export class UpdatephysicalSecurityMemberCompanyInput {
  id: Scalars['String'];
};

export class UpdatephysicalSecurityMemberInput {
  document?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  physicalSecurity?: InputMaybe<UpdatephysicalSecurityMemberCompanyInput>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export class User {
  carpoolEntries?: Maybe<Array<CarpoolRecord>>;
  carpoolExits?: Maybe<Array<CarpoolRecord>>;
  checkListAccessComment?: Maybe<Array<CheckListAccessComment>>;
  checkListAccessCreatedBy?: Maybe<Array<CheckListAccess>>;
  checkListAccessDeletedBy?: Maybe<Array<CheckListAccess>>;
  checkListAccessItems?: Maybe<Array<CheckListAccessItem>>;
  checkListAlarmComment?: Maybe<Array<CheckListAlarmComment>>;
  checkListAlarmCreatedBy?: Maybe<Array<CheckListAlarm>>;
  checkListAlarmDeletedBy?: Maybe<Array<CheckListAlarm>>;
  checkListAlarmItems?: Maybe<Array<CheckListAlarmItem>>;
  checkListCftvComment?: Maybe<Array<CheckListCftvComment>>;
  checkListCftvCreatedBy?: Maybe<Array<CheckListCftv>>;
  checkListCftvDeletedBy?: Maybe<Array<CheckListCftv>>;
  checkListCftvItems?: Maybe<Array<CheckListCftvItem>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  daycareEntryRecords?: Maybe<Array<DaycarePickupRecord>>;
  daycareExitRecords?: Maybe<Array<DaycarePickupRecord>>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  identifier?: Maybe<Scalars['String']>;
  isMicrosoft?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  occurrencesCreatedBy?: Maybe<Array<CheckListAccess>>;
  office?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  profile?: Maybe<Scalars['String']>;
  resetPasswordExpiration?: Maybe<Scalars['DateTime']>;
  serviceRequestInspectUser?: Maybe<Array<ServiceRequestInspect>>;
  serviceRequestUser?: Maybe<Array<ServiceRequest>>;
  status?: Maybe<Scalars['Boolean']>;
  truck?: Maybe<Array<Truck>>;
  truckInspection?: Maybe<Array<TruckInspection>>;
  truckRelease?: Maybe<Array<TruckRelease>>;
  unity?: Maybe<Unity>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export class UserPage {
  PageSize: Scalars['Int'];
  PreviousPage: Scalars['Boolean'];
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
  users: Array<User>;
};

export class Vehicle {
  createdAt: Scalars['DateTime'];
  driverCpf: Scalars['String'];
  id: Scalars['ID'];
  licensePlate: Scalars['String'];
  trailerLicensePlate?: Maybe<Scalars['String']>;
};

export type CountryFragment = { id: string, name?: string | null, flag?: string | null };

export type UnityFragment = { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null };

export type UserFragment = { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null };

export type OccurrenceListItemFragment = { id: string, code?: number | null, date?: any | null, status?: string | null, mitigatingDeadLine?: any | null, users?: Array<{ address?: string | null, addressNumber?: string | null, birth?: any | null, cep?: string | null, complement?: string | null, document?: string | null, gender?: string | null, id: string, mother?: string | null, father?: string | null, jobRole?: string | null, name: string, nationality?: string | null, rg?: string | null, sector?: string | null, type: string, uf?: string | null }> | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null };

export type OccurrenceFileFragment = { id: string, media: string, originalName: string, url: string, comment: string };

export type OccurrenceUserFragment = { address?: string | null, addressNumber?: string | null, birth?: any | null, cep?: string | null, complement?: string | null, document?: string | null, gender?: string | null, id: string, mother?: string | null, father?: string | null, jobRole?: string | null, name: string, nationality?: string | null, rg?: string | null, sector?: string | null, type: string, uf?: string | null };

export type OccurrenceFragment = { abscent?: boolean | null, area?: string | null, areaResponsible?: string | null, author?: string | null, authorship?: string | null, bulletinNumber?: string | null, classification?: string | null, code?: number | null, company?: string | null, createdAt?: any | null, date?: any | null, deletedAt?: any | null, department?: string | null, directLoss?: number | null, directLossDescription?: string | null, directLossType?: string | null, directLossObjects?: string | null, directLossValue?: number | null, retrievedValue?: number | null, recoveryStatusDescription?: string | null, employeesInvolved?: string | null, favor?: string | null, favorDetail?: string | null, favorOther?: string | null, hour?: string | null, id: string, indirectLoss?: number | null, indirectLossActivity?: string | null, indirectLossCost?: number | null, indirectLossInterruption?: boolean | null, indirectLossRemoval?: number | null, indirectLossTime?: string | null, mitigatingMeasuresDescription?: string | null, mitigatingDeadLine?: any | null, occurrenceDetail?: string | null, place?: string | null, recoveryStatus?: string | null, recurrent?: boolean | null, responsible?: string | null, responsibleCommunicatedOther?: string | null, measuresResponsibleName?: string | null, measuresResponsibleRole?: string | null, sinister?: string | null, status?: string | null, step?: number | null, type?: string | null, typeDetail?: string | null, updatedAt?: any | null, victims?: string | null, victimsDetail?: string | null, violence?: string | null, files?: Array<{ id: string, media: string, originalName: string, url: string, comment: string }> | null, responsiblesCommunicated?: Array<{ id: string, type?: string | null }> | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null, users?: Array<{ address?: string | null, addressNumber?: string | null, birth?: any | null, cep?: string | null, complement?: string | null, document?: string | null, gender?: string | null, id: string, mother?: string | null, father?: string | null, jobRole?: string | null, name: string, nationality?: string | null, rg?: string | null, sector?: string | null, type: string, uf?: string | null }> | null };

export type BlocFragment = { id?: string | null, name?: string | null, code?: string | null, capacity?: number | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null, access?: Array<{ id?: string | null, place?: string | null, code?: number | null, type?: string | null, status?: boolean | null, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null, alarms?: Array<{ id: string, place?: string | null, code: number, type: string, status: boolean, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null, cameras?: Array<{ id: string, code: number, place: string, type: string, mode: string, time: string, status: string, createdAt: any, updatedAt: any, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null };

export type CarpoolRecordFragment = { id: string, employeeName?: string | null, registration?: string | null, re?: string | null, cpf?: string | null, licensePlate?: string | null, qrRaw?: string | null, entryAt: any, exitAt?: any | null, status: string, isManualEntry?: boolean | null, isManualExit?: boolean | null, entryNote?: string | null, exitNote?: string | null, vaga?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, bloc?: { id?: string | null, name?: string | null, code?: string | null, capacity?: number | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null, access?: Array<{ id?: string | null, place?: string | null, code?: number | null, type?: string | null, status?: boolean | null, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null, alarms?: Array<{ id: string, place?: string | null, code: number, type: string, status: boolean, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null, cameras?: Array<{ id: string, code: number, place: string, type: string, mode: string, time: string, status: string, createdAt: any, updatedAt: any, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null } | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null, entryBy?: { id: string, name?: string | null } | null, exitBy?: { id: string, name?: string | null } | null };

export type AlarmPageFragment = { PageSize: number, PreviousPage: boolean, currentPage: number, nextPage: boolean, totalCount: number, totalPage: number, results: Array<{ id: string, place?: string | null, code: number, type: string, status: boolean, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> };

export type AlarmFragment = { id: string, place?: string | null, code: number, type: string, status: boolean, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null };

export type AccessPageFragment = { PageSize: number, PreviousPage: boolean, currentPage: number, nextPage: boolean, totalCount: number, totalPage: number, results: Array<{ id?: string | null, place?: string | null, code?: number | null, type?: string | null, status?: boolean | null, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> };

export type AccessFragment = { id?: string | null, place?: string | null, code?: number | null, type?: string | null, status?: boolean | null, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null };

export type CameraPageFragment = { PageSize: number, PreviousPage: boolean, currentPage: number, nextPage: boolean, totalCount: number, totalPage: number, results: Array<{ id: string, code: number, place: string, type: string, mode: string, time: string, status: string, createdAt: any, updatedAt: any, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> };

export type CameraFragment = { id: string, code: number, place: string, type: string, mode: string, time: string, status: string, createdAt: any, updatedAt: any, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null };

export type DefaultMessageFragment = { message: string, status: number };

export type SearchCheckListAccessResultFragment = { PageSize: number, PreviousPage: boolean, currentPage: number, nextPage: boolean, totalCount: number, totalPage: number, result: Array<{ createdAt: any, damage: number, date?: any | null, id: string, late: number, status?: string | null, total: number, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null }> };

export type CheckListCreateDtoFragment = { id: string };

export type ChecklistAccessUnfinishedDtoFragment = { status: string, blocs: Array<{ done: number, id: string, lastItemDate?: any | null, name: string, total: number, items: Array<{ condition?: string | null, createdAt?: any | null, dateLimit?: any | null, id?: string | null, status?: string | null, access?: { id?: string | null, place?: string | null, code?: number | null, type?: string | null, status?: boolean | null, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null } | null, comments?: Array<{ id: string, comment: string, createdAt: any, status: string, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null }> }> };

export type CheckListAccessCommentFragment = { id: string, comment: string, createdAt: any, status: string, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null };

export type CheckListAccessItemFragment = { condition?: string | null, createdAt?: any | null, dateLimit?: any | null, id?: string | null, status?: string | null, access?: { id?: string | null, place?: string | null, code?: number | null, type?: string | null, status?: boolean | null, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null } | null, comments?: Array<{ id: string, comment: string, createdAt: any, status: string, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null };

export type CheckListAccessFinishedDtoFragment = { PageSize: number, PreviousPage: boolean, currentPage: number, nextPage: boolean, totalCount: number, totalPage: number, checklist: { id: string, date?: any | null, status?: string | null, createdAt: any, deletedAt?: any | null, updatedAt?: any | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, deletedBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null }, items: Array<{ condition?: string | null, createdAt?: any | null, dateLimit?: any | null, id?: string | null, status?: string | null, access?: { id?: string | null, place?: string | null, code?: number | null, type?: string | null, status?: boolean | null, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null } | null, comments?: Array<{ id: string, comment: string, createdAt: any, status: string, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null }> };

export type CheckListAccessFragment = { id: string, date?: any | null, status?: string | null, createdAt: any, deletedAt?: any | null, updatedAt?: any | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, deletedBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null };

export type CheckListAlarmFragment = { id: string, date?: any | null, status?: string | null, createdAt: any, deletedAt?: any | null, updatedAt?: any | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, deletedBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null };

export type SearchCheckListCftvResultFragment = { PageSize: number, PreviousPage: boolean, currentPage: number, nextPage: boolean, totalCount: number, totalPage: number, result: Array<{ createdAt: any, damage: number, date?: any | null, id: string, late: number, status?: string | null, total: number, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null }> };

export type CheckListCftvCreateDtoFragment = { id: string };

export type CheckListCftvUnfinishedDtoFragment = { status: string, blocs: Array<{ done: number, id: string, lastItemDate?: any | null, name: string, total: number, items: Array<{ alignment?: string | null, alimentation?: string | null, daysRecorded?: string | null, focus?: string | null, signal?: string | null, createdAt?: any | null, dateLimit?: any | null, id?: string | null, status?: string | null, camera?: { id: string, code: number, place: string, type: string, mode: string, time: string, status: string, createdAt: any, updatedAt: any, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null } | null, comments?: Array<{ id: string, comment: string, status: string, createdAt: any, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null }> }> };

export type CheckListCftvCommentFragment = { id: string, comment: string, status: string, createdAt: any, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null };

export type CheckListCftvItemFragment = { alignment?: string | null, alimentation?: string | null, daysRecorded?: string | null, focus?: string | null, signal?: string | null, createdAt?: any | null, dateLimit?: any | null, id?: string | null, status?: string | null, camera?: { id: string, code: number, place: string, type: string, mode: string, time: string, status: string, createdAt: any, updatedAt: any, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null } | null, comments?: Array<{ id: string, comment: string, status: string, createdAt: any, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null };

export type CheckListCftvFragment = { createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null };

export type CheckListCftvFinishedDtoFragment = { PageSize: number, PreviousPage: boolean, currentPage: number, nextPage: boolean, totalCount: number, totalPage: number, checklist: { createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null }, items: Array<{ alignment?: string | null, alimentation?: string | null, daysRecorded?: string | null, focus?: string | null, signal?: string | null, createdAt?: any | null, dateLimit?: any | null, id?: string | null, status?: string | null, camera?: { id: string, code: number, place: string, type: string, mode: string, time: string, status: string, createdAt: any, updatedAt: any, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null } | null, comments?: Array<{ id: string, comment: string, status: string, createdAt: any, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null }> };

export type SearchCheckListAlarmResultFragment = { PageSize: number, PreviousPage: boolean, currentPage: number, nextPage: boolean, totalCount: number, totalPage: number, result: Array<{ createdAt: any, damage: number, date?: any | null, id: string, late: number, status?: string | null, total: number, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null }> };

export type CheckListAlarmCreateDtoFragment = { id: string };

export type CheckListAlarmUnfinishedDtoFragment = { status: string, blocs: Array<{ done: number, id: string, lastItemDate?: any | null, name: string, total: number, items: Array<{ condition?: string | null, createdAt?: any | null, dateLimit?: any | null, id?: string | null, status?: string | null, alarm?: { id: string, place?: string | null, code: number, type: string, status: boolean, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null } | null, comments?: Array<{ id: string, comment: string, status: string, createdAt: any, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null }> }> };

export type CheckListAlarmCommentFragment = { id: string, comment: string, status: string, createdAt: any, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null };

export type CheckListAlarmItemFragment = { condition?: string | null, createdAt?: any | null, dateLimit?: any | null, id?: string | null, status?: string | null, alarm?: { id: string, place?: string | null, code: number, type: string, status: boolean, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null } | null, comments?: Array<{ id: string, comment: string, status: string, createdAt: any, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null };

export type CheckListAlarmFinishedDtoFragment = { PageSize: number, PreviousPage: boolean, currentPage: number, nextPage: boolean, totalCount: number, totalPage: number, checklist: { id: string, date?: any | null, status?: string | null, createdAt: any, deletedAt?: any | null, updatedAt?: any | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, deletedBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null }, items: Array<{ condition?: string | null, createdAt?: any | null, dateLimit?: any | null, id?: string | null, status?: string | null, alarm?: { id: string, place?: string | null, code: number, type: string, status: boolean, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null } | null, comments?: Array<{ id: string, comment: string, status: string, createdAt: any, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null }> };

export type PhysicalSecurityPageFragment = { PageSize: number, PreviousPage: boolean, currentPage: number, nextPage: boolean, totalCount: number, totalPage: number, physicalSecurity: Array<{ id: string, code?: number | null, companyStatus: boolean, name: string, cnpj: string, segment: string, phone: string, stationNumber: number, createdAt: any, deletedAt?: any | null, members?: Array<{ id: string, name: string, document: string, status: boolean }> | null }> };

export type PhysicalSecurityFragment = { id: string, code?: number | null, companyStatus: boolean, name: string, cnpj: string, segment: string, phone: string, stationNumber: number, createdAt: any, deletedAt?: any | null, members?: Array<{ id: string, name: string, document: string, status: boolean }> | null };

export type PhysicalSecurityMemberFragment = { id: string, name: string, document: string, status: boolean };

export type PolicyFragment = { id: string, title: string, description: string, link: string, isPortuguese: boolean, isSpanish: boolean, createdAt: any, updatedAt: any, country?: { id: string, name?: string | null, flag?: string | null } | null };

export type TruckFragment = { id: string, date?: any | null, driverName?: string | null, driverCpf?: string | null, company?: string | null, licensePlate?: string | null, licensePlatePhoto?: string | null, trailerLicensePlate?: string | null, trailerLicensePlatePhoto?: string | null, autoPhoto?: string | null, isAuto?: boolean | null, sealNumber?: string | null, place?: string | null, placeCollect?: string | null, seal?: boolean | null, sealPhoto?: string | null, sealCorrect?: boolean | null, reason?: string | null, signature?: string | null, status?: string | null, createdAt?: any | null, deletedAt?: any | null, helpers?: Array<{ id: string, name: string, rg: string }> | null, unity?: { id: string, name?: string | null } | null, receipts?: Array<{ id: string, receipt: string }> | null, inspection?: { id: string, comment: string, createdAt: any, date: any, sealNumber?: string | null, sealPhoto?: string | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, receipt?: Array<{ id: string, receipt: string }> | null, equipment?: Array<{ id?: string | null, name: string, quantity?: number | null }> | null } | null, release?: { id: string, comment: string, exitWithTrailer?: boolean | null, createdAt: any, sealPhoto?: string | null, sealStatus?: boolean | null, receipt?: Array<{ id: string, comment: string, status: boolean, receipt?: { id: string, receipt: string } | null }> | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null } | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, checklist?: Array<{ id: string, name: string, status?: boolean | null, statusTruck?: string | null, type: string, comment?: string | null, photo?: string | null }> | null };

export type ServiceRequestFragment = { id: string, company: string, licensePlate?: string | null, status: string, createdAt: any, deletedAt?: any | null, area: string, entranceDate: any, cpf: string, cnpj?: string | null, exitDate: any, requestNumber?: string | null, vehicle?: string | null, meal?: string | null, mealContract?: string | null, mealCostCenter?: string | null, name: string, vehicles?: Array<{ id: string, licensePlate?: string | null, vehicle?: string | null, state?: string | null }> | null, virtualEquipment?: Array<{ name: string, quantity?: number | null }> | null, pool?: Array<{ name: string, entered: number, exited: number, remaining: number }> | null, helper: Array<{ id: string, name: string, entryDate?: any | null, departureDate?: any | null, doc: string }>, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, inspect: Array<{ id: string, type: string, others?: string | null, date: any, vehicleId?: string | null, signature?: string | null, equipmentImage?: string | null, createdAt: any, obs?: string | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, equipment?: Array<{ name: string, quantity?: number | null }> | null }> };

export type ServiceRequestInspectFragment = { id: string, type: string, others?: string | null, date: any, vehicleId?: string | null, signature?: string | null, equipmentImage?: string | null, createdAt: any, obs?: string | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, equipment?: Array<{ name: string, quantity?: number | null }> | null };

export type SearchCheckListAccessQueryVariables = Exact<{
  data: SearchCheckListAccess;
}>;


export type SearchCheckListAccessQuery = { searchCheckListAccess: { PageSize: number, PreviousPage: boolean, currentPage: number, nextPage: boolean, totalCount: number, totalPage: number, result: Array<{ createdAt: any, damage: number, date?: any | null, id: string, late: number, status?: string | null, total: number, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null }> } };

export type GetCheckListAccessUnfinishedQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCheckListAccessUnfinishedQuery = { checkListAccessUnfinished: { status: string, blocs: Array<{ done: number, id: string, lastItemDate?: any | null, name: string, total: number, items: Array<{ condition?: string | null, createdAt?: any | null, dateLimit?: any | null, id?: string | null, status?: string | null, access?: { id?: string | null, place?: string | null, code?: number | null, type?: string | null, status?: boolean | null, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null } | null, comments?: Array<{ id: string, comment: string, createdAt: any, status: string, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null }> }> } };

export type GetCheckListAccessFinishedQueryVariables = Exact<{
  data: CheckListAccessFinishedFilter;
}>;


export type GetCheckListAccessFinishedQuery = { checkListAccessFinished: { PageSize: number, PreviousPage: boolean, currentPage: number, nextPage: boolean, totalCount: number, totalPage: number, checklist: { id: string, date?: any | null, status?: string | null, createdAt: any, deletedAt?: any | null, updatedAt?: any | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, deletedBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null }, items: Array<{ condition?: string | null, createdAt?: any | null, dateLimit?: any | null, id?: string | null, status?: string | null, access?: { id?: string | null, place?: string | null, code?: number | null, type?: string | null, status?: boolean | null, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null } | null, comments?: Array<{ id: string, comment: string, createdAt: any, status: string, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null }> } };

export type CreateCheckListAccessMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateCheckListAccessMutation = { createCheckListAccess: { id: string } };

export type UpdateCheckListAccessMutationVariables = Exact<{
  data: CheckListUpdateInput;
}>;


export type UpdateCheckListAccessMutation = { updateCheckListAccess: { message: string, status: number } };

export type UpdateCheckListAccessItemStatusMutationVariables = Exact<{
  data: CheckListItemStatusUpdateInput;
}>;


export type UpdateCheckListAccessItemStatusMutation = { updateCheckListAccessItemStatus: { message: string, status: number } };

export type RemoveCheckListAccessMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveCheckListAccessMutation = { removeCheckListAccess: { message: string, status: number } };

export type SearchAccessQueryVariables = Exact<{
  data: SearchAccessInput;
}>;


export type SearchAccessQuery = { searchAccess: { PageSize: number, PreviousPage: boolean, currentPage: number, nextPage: boolean, totalCount: number, totalPage: number, results: Array<{ id?: string | null, place?: string | null, code?: number | null, type?: string | null, status?: boolean | null, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> } };

export type GetBlocsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBlocsQuery = { blocs: Array<{ id?: string | null, name?: string | null, code?: string | null, unity?: { name?: string | null } | null, cameras?: Array<{ id: string, status: string }> | null }> };

export type CreateAccessMutationVariables = Exact<{
  data: CreateAccessInput;
}>;


export type CreateAccessMutation = { createAccess: { id?: string | null, place?: string | null, code?: number | null, type?: string | null, status?: boolean | null, bloc?: { name?: string | null } | null } };

export type UpdateAccessMutationVariables = Exact<{
  data: UpdateAccessInput;
}>;


export type UpdateAccessMutation = { updateAccess: { id?: string | null, place?: string | null, code?: number | null, type?: string | null, status?: boolean | null, bloc?: { name?: string | null } | null } };

export type RemoveAccessMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveAccessMutation = { removeAccess: { status: number, message: string } };

export type SearchCheckListAlarmQueryVariables = Exact<{
  data: SearchCheckListAlarm;
}>;


export type SearchCheckListAlarmQuery = { searchCheckListAlarm: { PageSize: number, PreviousPage: boolean, currentPage: number, nextPage: boolean, totalCount: number, totalPage: number, result: Array<{ createdAt: any, damage: number, date?: any | null, id: string, late: number, status?: string | null, total: number, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null }> } };

export type GetCheckListAlarmUnfinishedQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCheckListAlarmUnfinishedQuery = { checkListAlarmUnfinished: { status: string, blocs: Array<{ done: number, id: string, lastItemDate?: any | null, name: string, total: number, items: Array<{ condition?: string | null, createdAt?: any | null, dateLimit?: any | null, id?: string | null, status?: string | null, alarm?: { id: string, place?: string | null, code: number, type: string, status: boolean, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null } | null, comments?: Array<{ id: string, comment: string, status: string, createdAt: any, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null }> }> } };

export type GetCheckListAlarmFinishedQueryVariables = Exact<{
  data: CheckListAlarmFinishedFilter;
}>;


export type GetCheckListAlarmFinishedQuery = { checkListAlarmFinished: { PageSize: number, PreviousPage: boolean, currentPage: number, nextPage: boolean, totalCount: number, totalPage: number, checklist: { id: string, date?: any | null, status?: string | null, createdAt: any, deletedAt?: any | null, updatedAt?: any | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, deletedBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null }, items: Array<{ condition?: string | null, createdAt?: any | null, dateLimit?: any | null, id?: string | null, status?: string | null, alarm?: { id: string, place?: string | null, code: number, type: string, status: boolean, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null } | null, comments?: Array<{ id: string, comment: string, status: string, createdAt: any, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null }> } };

export type CreateCheckListAlarmMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateCheckListAlarmMutation = { createCheckListAlarm: { id: string } };

export type UpdateCheckListAlarmMutationVariables = Exact<{
  data: CheckListAlarmUpdateInput;
}>;


export type UpdateCheckListAlarmMutation = { updateCheckListAlarm: { message: string, status: number } };

export type UpdateCheckListAlarmItemStatusMutationVariables = Exact<{
  data: CheckListAlarmItemStatusUpdateInput;
}>;


export type UpdateCheckListAlarmItemStatusMutation = { updateCheckListAlarmItemStatus: { message: string, status: number } };

export type RemoveCheckListAlarmMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveCheckListAlarmMutation = { removeCheckListAlarm: { message: string, status: number } };

export type SearchAlarmQueryVariables = Exact<{
  data: SearchAlarmInput;
}>;


export type SearchAlarmQuery = { searchAlarm: { PageSize: number, PreviousPage: boolean, currentPage: number, nextPage: boolean, totalCount: number, totalPage: number, results: Array<{ id: string, place?: string | null, code: number, type: string, status: boolean, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> } };

export type AlarmByBlocQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AlarmByBlocQuery = { alarmByBloc: Array<{ id: string, place?: string | null, code: number, type: string, status: boolean, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> };

export type CreateAlarmMutationVariables = Exact<{
  data: CreateAlarmInput;
}>;


export type CreateAlarmMutation = { createAlarm: { id: string, place?: string | null, code: number, type: string, status: boolean, bloc?: { name?: string | null } | null } };

export type UpdateAlarmMutationVariables = Exact<{
  data: UpdateAlarmInput;
}>;


export type UpdateAlarmMutation = { updateAlarm: { id: string, place?: string | null, code: number, type: string, status: boolean, bloc?: { name?: string | null } | null } };

export type RemoveAlarmMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveAlarmMutation = { removeAlarm: { status: number, message: string } };

export type SearchBlocsQueryVariables = Exact<{
  input: SearchBlocInput;
}>;


export type SearchBlocsQuery = { searchBloc: { totalCount: number, PageSize: number, currentPage: number, totalPage: number, PreviousPage: boolean, nextPage: boolean, results: Array<{ id?: string | null, name?: string | null, code?: string | null, capacity?: number | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null, access?: Array<{ id?: string | null, place?: string | null, code?: number | null, type?: string | null, status?: boolean | null, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null, alarms?: Array<{ id: string, place?: string | null, code: number, type: string, status: boolean, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null, cameras?: Array<{ id: string, code: number, place: string, type: string, mode: string, time: string, status: string, createdAt: any, updatedAt: any, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null }> } };

export type GetBlocByUnityQueryVariables = Exact<{
  unityId: Scalars['String'];
}>;


export type GetBlocByUnityQuery = { blocByUnity: Array<{ id?: string | null, name?: string | null, code?: string | null, capacity?: number | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null, access?: Array<{ id?: string | null, place?: string | null, code?: number | null, type?: string | null, status?: boolean | null, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null, alarms?: Array<{ id: string, place?: string | null, code: number, type: string, status: boolean, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null, cameras?: Array<{ id: string, code: number, place: string, type: string, mode: string, time: string, status: string, createdAt: any, updatedAt: any, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null }> };

export type CreateBlocMutationVariables = Exact<{
  input: CreateBlocInput;
}>;


export type CreateBlocMutation = { createBloc: { id?: string | null, name?: string | null, code?: string | null, capacity?: number | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null, access?: Array<{ id?: string | null, place?: string | null, code?: number | null, type?: string | null, status?: boolean | null, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null, alarms?: Array<{ id: string, place?: string | null, code: number, type: string, status: boolean, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null, cameras?: Array<{ id: string, code: number, place: string, type: string, mode: string, time: string, status: string, createdAt: any, updatedAt: any, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null } };

export type UnityBlocsQueryVariables = Exact<{
  type: Scalars['String'];
}>;


export type UnityBlocsQuery = { unityBlocs: Array<{ summary: number, bloc: { id?: string | null, name?: string | null, code?: string | null, capacity?: number | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null, access?: Array<{ id?: string | null, place?: string | null, code?: number | null, type?: string | null, status?: boolean | null, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null, alarms?: Array<{ id: string, place?: string | null, code: number, type: string, status: boolean, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null, cameras?: Array<{ id: string, code: number, place: string, type: string, mode: string, time: string, status: string, createdAt: any, updatedAt: any, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null } }> };

export type UpdateBlocMutationVariables = Exact<{
  input: UpdateBlocInput;
}>;


export type UpdateBlocMutation = { updateBloc: { id?: string | null, name?: string | null, code?: string | null, capacity?: number | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null, access?: Array<{ id?: string | null, place?: string | null, code?: number | null, type?: string | null, status?: boolean | null, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null, alarms?: Array<{ id: string, place?: string | null, code: number, type: string, status: boolean, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null, cameras?: Array<{ id: string, code: number, place: string, type: string, mode: string, time: string, status: string, createdAt: any, updatedAt: any, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null } };

export type RemoveBlocMutationVariables = Exact<{
  input: Scalars['ID'];
}>;


export type RemoveBlocMutation = { removeBloc: { message: string } };

export type SearchCameraQueryVariables = Exact<{
  data: SearchCameraInput;
}>;


export type SearchCameraQuery = { searchCamera: { PageSize: number, PreviousPage: boolean, currentPage: number, nextPage: boolean, totalCount: number, totalPage: number, results: Array<{ id: string, code: number, place: string, type: string, mode: string, time: string, status: string, createdAt: any, updatedAt: any, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> } };

export type CreateCameraMutationVariables = Exact<{
  data: CreateCameraInput;
}>;


export type CreateCameraMutation = { createCamera: { id: string, code: number, place: string, type: string, mode: string, time: string, status: string, createdAt: any, updatedAt: any, bloc?: { name?: string | null } | null } };

export type UpdateCameraMutationVariables = Exact<{
  data: UpdateCameraInput;
}>;


export type UpdateCameraMutation = { updateCamera: { id: string, code: number, place: string, type: string, mode: string, time: string, status: string, createdAt: any, updatedAt: any, bloc?: { name?: string | null } | null } };

export type RemoveCameraMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveCameraMutation = { removeCamera: { status: number, message: string } };

export type CaronaBlocsAvailabilityQueryVariables = Exact<{
  unity: Scalars['ID'];
}>;


export type CaronaBlocsAvailabilityQuery = { caronaBlocsAvailability: Array<{ capacity: number, occupied: number, available: number, bloc: { id?: string | null, name?: string | null, capacity?: number | null } }> };

export type RegisterCaronaEntryMutationVariables = Exact<{
  data: RegisterCaronaEntryInput;
}>;


export type RegisterCaronaEntryMutation = { registerCaronaEntry: { id: string, employeeName?: string | null, registration?: string | null, re?: string | null, cpf?: string | null, licensePlate?: string | null, qrRaw?: string | null, entryAt: any, exitAt?: any | null, status: string, isManualEntry?: boolean | null, isManualExit?: boolean | null, entryNote?: string | null, exitNote?: string | null, vaga?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, bloc?: { id?: string | null, name?: string | null, code?: string | null, capacity?: number | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null, access?: Array<{ id?: string | null, place?: string | null, code?: number | null, type?: string | null, status?: boolean | null, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null, alarms?: Array<{ id: string, place?: string | null, code: number, type: string, status: boolean, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null, cameras?: Array<{ id: string, code: number, place: string, type: string, mode: string, time: string, status: string, createdAt: any, updatedAt: any, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null } | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null, entryBy?: { id: string, name?: string | null } | null, exitBy?: { id: string, name?: string | null } | null } };

export type RegisterCaronaExitMutationVariables = Exact<{
  data: RegisterCaronaExitInput;
}>;


export type RegisterCaronaExitMutation = { registerCaronaExit: { id: string, employeeName?: string | null, registration?: string | null, re?: string | null, cpf?: string | null, licensePlate?: string | null, qrRaw?: string | null, entryAt: any, exitAt?: any | null, status: string, isManualEntry?: boolean | null, isManualExit?: boolean | null, entryNote?: string | null, exitNote?: string | null, vaga?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, bloc?: { id?: string | null, name?: string | null, code?: string | null, capacity?: number | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null, access?: Array<{ id?: string | null, place?: string | null, code?: number | null, type?: string | null, status?: boolean | null, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null, alarms?: Array<{ id: string, place?: string | null, code: number, type: string, status: boolean, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null, cameras?: Array<{ id: string, code: number, place: string, type: string, mode: string, time: string, status: string, createdAt: any, updatedAt: any, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null } | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null, entryBy?: { id: string, name?: string | null } | null, exitBy?: { id: string, name?: string | null } | null } };

export type OpenCaronaRecordQueryVariables = Exact<{
  unity: Scalars['ID'];
  term: Scalars['String'];
}>;


export type OpenCaronaRecordQuery = { openCaronaRecord?: { id: string, employeeName?: string | null, registration?: string | null, re?: string | null, cpf?: string | null, licensePlate?: string | null, qrRaw?: string | null, entryAt: any, exitAt?: any | null, status: string, isManualEntry?: boolean | null, isManualExit?: boolean | null, entryNote?: string | null, exitNote?: string | null, vaga?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, bloc?: { id?: string | null, name?: string | null, code?: string | null, capacity?: number | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null, access?: Array<{ id?: string | null, place?: string | null, code?: number | null, type?: string | null, status?: boolean | null, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null, alarms?: Array<{ id: string, place?: string | null, code: number, type: string, status: boolean, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null, cameras?: Array<{ id: string, code: number, place: string, type: string, mode: string, time: string, status: string, createdAt: any, updatedAt: any, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null } | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null, entryBy?: { id: string, name?: string | null } | null, exitBy?: { id: string, name?: string | null } | null } | null };

export type OpenCaronaRecordsQueryVariables = Exact<{
  unity: Scalars['ID'];
  term: Scalars['String'];
}>;


export type OpenCaronaRecordsQuery = { openCaronaRecords: Array<{ id: string, employeeName?: string | null, registration?: string | null, re?: string | null, cpf?: string | null, licensePlate?: string | null, qrRaw?: string | null, entryAt: any, exitAt?: any | null, status: string, isManualEntry?: boolean | null, isManualExit?: boolean | null, entryNote?: string | null, exitNote?: string | null, vaga?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, bloc?: { id?: string | null, name?: string | null, code?: string | null, capacity?: number | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null, access?: Array<{ id?: string | null, place?: string | null, code?: number | null, type?: string | null, status?: boolean | null, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null, alarms?: Array<{ id: string, place?: string | null, code: number, type: string, status: boolean, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null, cameras?: Array<{ id: string, code: number, place: string, type: string, mode: string, time: string, status: string, createdAt: any, updatedAt: any, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null } | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null, entryBy?: { id: string, name?: string | null } | null, exitBy?: { id: string, name?: string | null } | null }> };

export type SearchCaronaQueryVariables = Exact<{
  data: SearchCaronaInput;
}>;


export type SearchCaronaQuery = { searchCarona: { PageSize: number, currentPage: number, totalPage: number, PreviousPage: boolean, nextPage: boolean, totalCount: number, results: Array<{ id: string, employeeName?: string | null, registration?: string | null, re?: string | null, cpf?: string | null, licensePlate?: string | null, qrRaw?: string | null, entryAt: any, exitAt?: any | null, status: string, isManualEntry?: boolean | null, isManualExit?: boolean | null, entryNote?: string | null, exitNote?: string | null, vaga?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, bloc?: { id?: string | null, name?: string | null, code?: string | null, capacity?: number | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null, access?: Array<{ id?: string | null, place?: string | null, code?: number | null, type?: string | null, status?: boolean | null, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null, alarms?: Array<{ id: string, place?: string | null, code: number, type: string, status: boolean, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null, cameras?: Array<{ id: string, code: number, place: string, type: string, mode: string, time: string, status: string, createdAt: any, updatedAt: any, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null } | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null, entryBy?: { id: string, name?: string | null } | null, exitBy?: { id: string, name?: string | null } | null }> } };

export type CaronaQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CaronaQuery = { carona?: { id: string, employeeName?: string | null, registration?: string | null, re?: string | null, cpf?: string | null, licensePlate?: string | null, qrRaw?: string | null, entryAt: any, exitAt?: any | null, status: string, isManualEntry?: boolean | null, isManualExit?: boolean | null, entryNote?: string | null, exitNote?: string | null, vaga?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, bloc?: { id?: string | null, name?: string | null, code?: string | null, capacity?: number | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null, access?: Array<{ id?: string | null, place?: string | null, code?: number | null, type?: string | null, status?: boolean | null, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null, alarms?: Array<{ id: string, place?: string | null, code: number, type: string, status: boolean, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null, cameras?: Array<{ id: string, code: number, place: string, type: string, mode: string, time: string, status: string, createdAt: any, updatedAt: any, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null } | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null, entryBy?: { id: string, name?: string | null } | null, exitBy?: { id: string, name?: string | null } | null } | null };

export type CaronaVagaOcupadaQueryVariables = Exact<{
  unity: Scalars['ID'];
  vaga: Scalars['String'];
}>;


export type CaronaVagaOcupadaQuery = { caronaVagaOcupada: boolean };

export type RemoveCaronaMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveCaronaMutation = { removeCarona: { status: number, message: string } };

export type SearchCheckListCftvQueryVariables = Exact<{
  data: SearchCheckListCftv;
}>;


export type SearchCheckListCftvQuery = { searchCheckListCftv: { PageSize: number, PreviousPage: boolean, currentPage: number, nextPage: boolean, totalCount: number, totalPage: number, result: Array<{ createdAt: any, damage: number, date?: any | null, id: string, late: number, status?: string | null, total: number, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null }> } };

export type GetCheckListCftvUnfinishedQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCheckListCftvUnfinishedQuery = { checkListCftvUnfinished: { status: string, blocs: Array<{ done: number, id: string, lastItemDate?: any | null, name: string, total: number, items: Array<{ alignment?: string | null, alimentation?: string | null, daysRecorded?: string | null, focus?: string | null, signal?: string | null, createdAt?: any | null, dateLimit?: any | null, id?: string | null, status?: string | null, camera?: { id: string, code: number, place: string, type: string, mode: string, time: string, status: string, createdAt: any, updatedAt: any, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null } | null, comments?: Array<{ id: string, comment: string, status: string, createdAt: any, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null }> }> } };

export type GetCheckListCftvFinishedQueryVariables = Exact<{
  data: CheckListCftvFinishedFilter;
}>;


export type GetCheckListCftvFinishedQuery = { checkListCftvFinished: { PageSize: number, PreviousPage: boolean, currentPage: number, nextPage: boolean, totalCount: number, totalPage: number, checklist: { createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null }, items: Array<{ alignment?: string | null, alimentation?: string | null, daysRecorded?: string | null, focus?: string | null, signal?: string | null, createdAt?: any | null, dateLimit?: any | null, id?: string | null, status?: string | null, camera?: { id: string, code: number, place: string, type: string, mode: string, time: string, status: string, createdAt: any, updatedAt: any, bloc?: { id?: string | null, name?: string | null, code?: string | null, deletedAt?: any | null, createdAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null } | null, comments?: Array<{ id: string, comment: string, status: string, createdAt: any, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null }> | null }> } };

export type CreateCheckListCftvMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateCheckListCftvMutation = { createCheckListCftv: { id: string } };

export type UpdateCheckListCftvMutationVariables = Exact<{
  data: CheckListCftvUpdateInput;
}>;


export type UpdateCheckListCftvMutation = { updateCheckListCftv: { message: string, status: number } };

export type UpdateCheckListCftvItemStatusMutationVariables = Exact<{
  data: CheckListCftvItemStatusUpdateInput;
}>;


export type UpdateCheckListCftvItemStatusMutation = { updateCheckListCftvItemStatus: { message: string, status: number } };

export type RemoveCheckListCftvMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveCheckListCftvMutation = { removeCheckListCftv: { message: string, status: number } };

export type GetCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesQuery = { countries: Array<{ id: string, name?: string | null, flag?: string | null }> };

export type GetOccurrenceDashboardQueryVariables = Exact<{
  data: SearchStatisticInput;
}>;


export type GetOccurrenceDashboardQuery = { occurrenceDashboard: Array<{ month: string, date: string, year: string, detail: Array<{ count: string, type: string }> }> };

export type GetOccurrenceLossDashboardQueryVariables = Exact<{
  data: SearchStatisticInput;
}>;


export type GetOccurrenceLossDashboardQuery = { occurrenceLossDashboard: Array<{ direct: number, indirect: number, month: string, total: number }> };

export type GetOccurrenceActivityQueryVariables = Exact<{
  data: SearchStatisticInput;
}>;


export type GetOccurrenceActivityQuery = { occurrenceActivityDashboard: Array<{ month: string, time: number }> };

export type GetOccurrenceAvoidedRecoveredQueryVariables = Exact<{
  data: SearchStatisticInput;
}>;


export type GetOccurrenceAvoidedRecoveredQuery = { occurrenceAvoidedRecoveredDashboard: Array<{ count: number, status: string }> };

export type SearchDaycareChildQueryVariables = Exact<{
  data: SearchDaycareChildInput;
}>;


export type SearchDaycareChildQuery = { searchDaycareChild: { totalCount: number, PageSize: number, currentPage: number, totalPage: number, PreviousPage: boolean, nextPage: boolean, results: Array<{ id: string, name: string, year?: number | null, employee?: { id: string, re: string, name: string, email?: string | null } | null, guardians?: Array<{ id: string, kind: string, name: string, documentRaw?: string | null, position: number }> | null }> } };

export type DaycareChildDetailFragment = { id: string, name: string, year?: number | null, employee?: { id: string, re: string, name: string, email?: string | null } | null, guardians?: Array<{ id: string, kind: string, name: string, documentRaw?: string | null, position: number }> | null };

export type DaycareChildQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DaycareChildQuery = { daycareChild: { id: string, name: string, year?: number | null, employee?: { id: string, re: string, name: string, email?: string | null } | null, guardians?: Array<{ id: string, kind: string, name: string, documentRaw?: string | null, position: number }> | null } };

export type CreateDaycareGuardianMutationVariables = Exact<{
  data: CreateDaycareGuardianInput;
}>;


export type CreateDaycareGuardianMutation = { createDaycareGuardian: { id: string, name: string, year?: number | null, employee?: { id: string, re: string, name: string, email?: string | null } | null, guardians?: Array<{ id: string, kind: string, name: string, documentRaw?: string | null, position: number }> | null } };

export type UpdateDaycareGuardianMutationVariables = Exact<{
  data: UpdateDaycareGuardianInput;
}>;


export type UpdateDaycareGuardianMutation = { updateDaycareGuardian: { id: string, name: string, year?: number | null, employee?: { id: string, re: string, name: string, email?: string | null } | null, guardians?: Array<{ id: string, kind: string, name: string, documentRaw?: string | null, position: number }> | null } };

export type RemoveDaycareGuardianMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveDaycareGuardianMutation = { removeDaycareGuardian: { status: number, message: string } };

export type CreateDaycareChildMutationVariables = Exact<{
  data: CreateDaycareChildInput;
}>;


export type CreateDaycareChildMutation = { createDaycareChild: { id: string, name: string, year?: number | null, employee?: { id: string, re: string, name: string, email?: string | null } | null, guardians?: Array<{ id: string, kind: string, name: string, documentRaw?: string | null, position: number }> | null } };

export type UpdateDaycareChildMutationVariables = Exact<{
  data: UpdateDaycareChildInput;
}>;


export type UpdateDaycareChildMutation = { updateDaycareChild: { id: string, name: string, year?: number | null, employee?: { id: string, re: string, name: string, email?: string | null } | null, guardians?: Array<{ id: string, kind: string, name: string, documentRaw?: string | null, position: number }> | null } };

export type RemoveDaycareChildMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveDaycareChildMutation = { removeDaycareChild: { status: number, message: string } };

export type SearchDaycarePickupCandidatesQueryVariables = Exact<{
  term: Scalars['String'];
}>;


export type SearchDaycarePickupCandidatesQuery = { searchDaycarePickupCandidates: Array<{ personKind: string, personName: string, personDocument?: string | null, employeeRe: string, children: Array<{ id: string, name: string, status: string, entryAt?: any | null }> }> };

export type RegisterDaycareEntryMutationVariables = Exact<{
  data: RegisterDaycareStayInput;
}>;


export type RegisterDaycareEntryMutation = { registerDaycareEntry: { count: number, message: string, requiresConfirmation?: boolean | null, warning?: string | null } };

export type RegisterDaycareExitMutationVariables = Exact<{
  data: RegisterDaycareStayInput;
}>;


export type RegisterDaycareExitMutation = { registerDaycareExit: { count: number, message: string, requiresConfirmation?: boolean | null, warning?: string | null } };

export type SearchDaycarePickupQueryVariables = Exact<{
  data: SearchDaycarePickupInput;
}>;


export type SearchDaycarePickupQuery = { searchDaycarePickup: { totalCount: number, PageSize: number, currentPage: number, totalPage: number, PreviousPage: boolean, nextPage: boolean, results: Array<{ id: string, childName: string, employeeRe: string, status: string, entryAt?: any | null, entryPersonName?: string | null, entryPersonKind?: string | null, entryByName?: string | null, entryNote?: string | null, exitAt?: any | null, exitPersonName?: string | null, exitPersonKind?: string | null, exitByName?: string | null, exitNote?: string | null }> } };

export type GetEnumByCultureQueryVariables = Exact<{
  culture: Scalars['String'];
}>;


export type GetEnumByCultureQuery = { enumByCulture: Array<{ id: string, type: string, value: string, detail?: string | null, description?: string | null, culture: string, unity?: { id: string, name?: string | null, country?: { id: string, name?: string | null } | null } | null }> };

export type GetEnumByUnityQueryVariables = Exact<{
  unityId: Scalars['String'];
}>;


export type GetEnumByUnityQuery = { enumByUnity: Array<{ id: string, type: string, value: string, detail?: string | null, description?: string | null, culture: string, unity?: { id: string, name?: string | null, country?: { id: string, name?: string | null } | null } | null }> };

export type GetEnumByTypeAndCultureQueryVariables = Exact<{
  type: Scalars['String'];
  culture: Scalars['String'];
}>;


export type GetEnumByTypeAndCultureQuery = { enumByTypeCulture: Array<{ id: string, type: string, value: string, detail?: string | null, description?: string | null, culture: string, unity?: { id: string, name?: string | null, country?: { id: string, name?: string | null } | null } | null }> };

export type CreateEnumTypeMutationVariables = Exact<{
  input: CreateEnumTypeInput;
}>;


export type CreateEnumTypeMutation = { createEnumType: { id: string, type: string, value: string, detail?: string | null, culture: string, unity?: { id: string } | null } };

export type UpdateEnumTypeMutationVariables = Exact<{
  input: UpdateEnumTypeInput;
}>;


export type UpdateEnumTypeMutation = { updateEnumType: { id: string, type: string, value: string, detail?: string | null, culture: string, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null } | null } | null } };

export type RemoveEnumTypeMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type RemoveEnumTypeMutation = { removeEnumType: { message: string } };

export type SearchEnumTypeQueryVariables = Exact<{
  input: SearchEnumTypeInput;
}>;


export type SearchEnumTypeQuery = { searchEnumType: { totalCount: number, PageSize: number, currentPage: number, totalPage: number, PreviousPage: boolean, nextPage: boolean, results: Array<{ id: string, type: string, value: string, detail?: string | null, culture: string, unity?: { id: string, name?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null }> } };

export type LoginMutationVariables = Exact<{
  data: AuthInput;
}>;


export type LoginMutation = { login: { token: string, user: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } } };

export type SearchOccurrencesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  input: SearchOccurrenceInput;
}>;


export type SearchOccurrencesQuery = { searchOccurrence: { PageSize: number, PreviousPage: boolean, currentPage: number, nextPage: boolean, totalCount: number, totalPage: number, occurrence: Array<{ id: string, code?: number | null, date?: any | null, status?: string | null, mitigatingDeadLine?: any | null, users?: Array<{ address?: string | null, addressNumber?: string | null, birth?: any | null, cep?: string | null, complement?: string | null, document?: string | null, gender?: string | null, id: string, mother?: string | null, father?: string | null, jobRole?: string | null, name: string, nationality?: string | null, rg?: string | null, sector?: string | null, type: string, uf?: string | null }> | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null }> } };

export type GetOccurrenceByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetOccurrenceByIdQuery = { occurrence: { abscent?: boolean | null, area?: string | null, areaResponsible?: string | null, author?: string | null, authorship?: string | null, bulletinNumber?: string | null, classification?: string | null, code?: number | null, company?: string | null, createdAt?: any | null, date?: any | null, deletedAt?: any | null, department?: string | null, directLoss?: number | null, directLossDescription?: string | null, directLossType?: string | null, directLossObjects?: string | null, directLossValue?: number | null, retrievedValue?: number | null, recoveryStatusDescription?: string | null, employeesInvolved?: string | null, favor?: string | null, favorDetail?: string | null, favorOther?: string | null, hour?: string | null, id: string, indirectLoss?: number | null, indirectLossActivity?: string | null, indirectLossCost?: number | null, indirectLossInterruption?: boolean | null, indirectLossRemoval?: number | null, indirectLossTime?: string | null, mitigatingMeasuresDescription?: string | null, mitigatingDeadLine?: any | null, occurrenceDetail?: string | null, place?: string | null, recoveryStatus?: string | null, recurrent?: boolean | null, responsible?: string | null, responsibleCommunicatedOther?: string | null, measuresResponsibleName?: string | null, measuresResponsibleRole?: string | null, sinister?: string | null, status?: string | null, step?: number | null, type?: string | null, typeDetail?: string | null, updatedAt?: any | null, victims?: string | null, victimsDetail?: string | null, violence?: string | null, files?: Array<{ id: string, media: string, originalName: string, url: string, comment: string }> | null, responsiblesCommunicated?: Array<{ id: string, type?: string | null }> | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null, users?: Array<{ address?: string | null, addressNumber?: string | null, birth?: any | null, cep?: string | null, complement?: string | null, document?: string | null, gender?: string | null, id: string, mother?: string | null, father?: string | null, jobRole?: string | null, name: string, nationality?: string | null, rg?: string | null, sector?: string | null, type: string, uf?: string | null }> | null } };

export type CreateOccurrenceMutationVariables = Exact<{
  input: CreateOccurrenceInput;
}>;


export type CreateOccurrenceMutation = { createOccurrence: { abscent?: boolean | null, area?: string | null, areaResponsible?: string | null, author?: string | null, authorship?: string | null, bulletinNumber?: string | null, classification?: string | null, code?: number | null, company?: string | null, createdAt?: any | null, date?: any | null, deletedAt?: any | null, department?: string | null, directLoss?: number | null, directLossDescription?: string | null, directLossType?: string | null, directLossObjects?: string | null, directLossValue?: number | null, retrievedValue?: number | null, recoveryStatusDescription?: string | null, employeesInvolved?: string | null, favor?: string | null, favorDetail?: string | null, favorOther?: string | null, hour?: string | null, id: string, indirectLoss?: number | null, indirectLossActivity?: string | null, indirectLossCost?: number | null, indirectLossInterruption?: boolean | null, indirectLossRemoval?: number | null, indirectLossTime?: string | null, mitigatingMeasuresDescription?: string | null, mitigatingDeadLine?: any | null, occurrenceDetail?: string | null, place?: string | null, recoveryStatus?: string | null, recurrent?: boolean | null, responsible?: string | null, responsibleCommunicatedOther?: string | null, measuresResponsibleName?: string | null, measuresResponsibleRole?: string | null, sinister?: string | null, status?: string | null, step?: number | null, type?: string | null, typeDetail?: string | null, updatedAt?: any | null, victims?: string | null, victimsDetail?: string | null, violence?: string | null, files?: Array<{ id: string, media: string, originalName: string, url: string, comment: string }> | null, responsiblesCommunicated?: Array<{ id: string, type?: string | null }> | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null, users?: Array<{ address?: string | null, addressNumber?: string | null, birth?: any | null, cep?: string | null, complement?: string | null, document?: string | null, gender?: string | null, id: string, mother?: string | null, father?: string | null, jobRole?: string | null, name: string, nationality?: string | null, rg?: string | null, sector?: string | null, type: string, uf?: string | null }> | null } };

export type UpdateOccurrenceMutationVariables = Exact<{
  input: UpdateOccurrenceInput;
  users: Array<UpdateOccurrenceUserInput> | UpdateOccurrenceUserInput;
}>;


export type UpdateOccurrenceMutation = { updateOccurrence: { abscent?: boolean | null, area?: string | null, areaResponsible?: string | null, author?: string | null, authorship?: string | null, bulletinNumber?: string | null, classification?: string | null, code?: number | null, company?: string | null, createdAt?: any | null, date?: any | null, deletedAt?: any | null, department?: string | null, directLoss?: number | null, directLossDescription?: string | null, directLossType?: string | null, directLossObjects?: string | null, directLossValue?: number | null, retrievedValue?: number | null, recoveryStatusDescription?: string | null, employeesInvolved?: string | null, favor?: string | null, favorDetail?: string | null, favorOther?: string | null, hour?: string | null, id: string, indirectLoss?: number | null, indirectLossActivity?: string | null, indirectLossCost?: number | null, indirectLossInterruption?: boolean | null, indirectLossRemoval?: number | null, indirectLossTime?: string | null, mitigatingMeasuresDescription?: string | null, mitigatingDeadLine?: any | null, occurrenceDetail?: string | null, place?: string | null, recoveryStatus?: string | null, recurrent?: boolean | null, responsible?: string | null, responsibleCommunicatedOther?: string | null, measuresResponsibleName?: string | null, measuresResponsibleRole?: string | null, sinister?: string | null, status?: string | null, step?: number | null, type?: string | null, typeDetail?: string | null, updatedAt?: any | null, victims?: string | null, victimsDetail?: string | null, violence?: string | null, files?: Array<{ id: string, media: string, originalName: string, url: string, comment: string }> | null, responsiblesCommunicated?: Array<{ id: string, type?: string | null }> | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null, users?: Array<{ address?: string | null, addressNumber?: string | null, birth?: any | null, cep?: string | null, complement?: string | null, document?: string | null, gender?: string | null, id: string, mother?: string | null, father?: string | null, jobRole?: string | null, name: string, nationality?: string | null, rg?: string | null, sector?: string | null, type: string, uf?: string | null }> | null } };

export type RemoveOccurrenceMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveOccurrenceMutation = { removeOccurrence: { message: string, status: number } };

export type RemoveOccurrenceFileMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveOccurrenceFileMutation = { removeOccurrenceFile: { message: string, status: number } };

export type SearchPhysicalSecurityQueryVariables = Exact<{
  data: SearchPhysicalSecurityInput;
}>;


export type SearchPhysicalSecurityQuery = { searchPhysicalSecurity: { PageSize: number, PreviousPage: boolean, currentPage: number, nextPage: boolean, totalCount: number, totalPage: number, physicalSecurity: Array<{ id: string, code?: number | null, companyStatus: boolean, name: string, cnpj: string, segment: string, phone: string, stationNumber: number, createdAt: any, deletedAt?: any | null, members?: Array<{ id: string, name: string, document: string, status: boolean }> | null }> } };

export type RemovePhysicalSecurityMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemovePhysicalSecurityMutation = { removePhysicalSecurity: { message: string, status: number } };

export type RemovePhysicalSecurityMemberMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemovePhysicalSecurityMemberMutation = { removePhysicalSecurityMember: { message: string, status: number } };

export type CreatePhysicalSecurityMutationVariables = Exact<{
  data: CreatePhysicalSecurityInput;
}>;


export type CreatePhysicalSecurityMutation = { createPhysicalSecurity: { id: string, code?: number | null, companyStatus: boolean, name: string, cnpj: string, segment: string, phone: string, stationNumber: number, createdAt: any, deletedAt?: any | null, members?: Array<{ id: string, name: string, document: string, status: boolean }> | null } };

export type UpdatePhysicalSecurityMutationVariables = Exact<{
  data: UpdatePhysicalSecurityInput;
}>;


export type UpdatePhysicalSecurityMutation = { updatePhysicalSecurity: { id: string, code?: number | null, companyStatus: boolean, name: string, cnpj: string, segment: string, phone: string, stationNumber: number, createdAt: any, deletedAt?: any | null, members?: Array<{ id: string, name: string, document: string, status: boolean }> | null } };

export type PhysicalSecurityQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type PhysicalSecurityQuery = { physicalSecurity: { id: string, code?: number | null, companyStatus: boolean, name: string, cnpj: string, segment: string, phone: string, stationNumber: number, createdAt: any, deletedAt?: any | null, members?: Array<{ id: string, name: string, document: string, status: boolean }> | null } };

export type SearchPolicyQueryVariables = Exact<{
  data: SearchPolicyInput;
}>;


export type SearchPolicyQuery = { searchPolicy: Array<{ id: string, title: string, description: string, link: string, isPortuguese: boolean, isSpanish: boolean, createdAt: any, updatedAt: any, country?: { id: string, name?: string | null, flag?: string | null } | null }> };

export type RemovePolicyMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemovePolicyMutation = { removePolicy: { message: string, status: number } };

export type UpdatePolicyMutationVariables = Exact<{
  data: UpdatePolicyInput;
}>;


export type UpdatePolicyMutation = { updatePolicy: { id: string, title: string, description: string, link: string, isPortuguese: boolean, isSpanish: boolean, createdAt: any, updatedAt: any, country?: { id: string, name?: string | null, flag?: string | null } | null } };

export type CreatePolicyMutationVariables = Exact<{
  data: CreatePolicyInput;
}>;


export type CreatePolicyMutation = { createPolicy: { id: string, title: string, description: string, link: string, isPortuguese: boolean, isSpanish: boolean, createdAt: any, updatedAt: any, country?: { id: string, name?: string | null, flag?: string | null } | null } };

export type SearchServiceRequestQueryVariables = Exact<{
  data: SearchServiceRequestInput;
}>;


export type SearchServiceRequestQuery = { searchServiceRequest: { totalCount: number, PageSize: number, currentPage: number, totalPage: number, PreviousPage: boolean, nextPage: boolean, results: Array<{ id: string, company: string, licensePlate?: string | null, status: string, createdAt: any, deletedAt?: any | null, area: string, entranceDate: any, cpf: string, cnpj?: string | null, exitDate: any, requestNumber?: string | null, vehicle?: string | null, meal?: string | null, mealContract?: string | null, mealCostCenter?: string | null, name: string, vehicles?: Array<{ id: string, licensePlate?: string | null, vehicle?: string | null, state?: string | null }> | null, virtualEquipment?: Array<{ name: string, quantity?: number | null }> | null, pool?: Array<{ name: string, entered: number, exited: number, remaining: number }> | null, helper: Array<{ id: string, name: string, entryDate?: any | null, departureDate?: any | null, doc: string }>, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, inspect: Array<{ id: string, type: string, others?: string | null, date: any, vehicleId?: string | null, signature?: string | null, equipmentImage?: string | null, createdAt: any, obs?: string | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, equipment?: Array<{ name: string, quantity?: number | null }> | null }> }> } };

export type ServiceRequestQueryVariables = Exact<{
  data: Scalars['ID'];
}>;


export type ServiceRequestQuery = { serviceRequest: { id: string, company: string, licensePlate?: string | null, status: string, createdAt: any, deletedAt?: any | null, area: string, entranceDate: any, cpf: string, cnpj?: string | null, exitDate: any, requestNumber?: string | null, vehicle?: string | null, meal?: string | null, mealContract?: string | null, mealCostCenter?: string | null, name: string, vehicles?: Array<{ id: string, licensePlate?: string | null, vehicle?: string | null, state?: string | null }> | null, virtualEquipment?: Array<{ name: string, quantity?: number | null }> | null, pool?: Array<{ name: string, entered: number, exited: number, remaining: number }> | null, helper: Array<{ id: string, name: string, entryDate?: any | null, departureDate?: any | null, doc: string }>, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, inspect: Array<{ id: string, type: string, others?: string | null, date: any, vehicleId?: string | null, signature?: string | null, equipmentImage?: string | null, createdAt: any, obs?: string | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, equipment?: Array<{ name: string, quantity?: number | null }> | null }> } };

export type ServiceRequestInspectionQueryVariables = Exact<{
  data: Scalars['ID'];
}>;


export type ServiceRequestInspectionQuery = { serviceRequestInspection: { id: string, type: string, others?: string | null, date: any, vehicleId?: string | null, signature?: string | null, equipmentImage?: string | null, createdAt: any, obs?: string | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, equipment?: Array<{ name: string, quantity?: number | null }> | null } };

export type CreateServiceRequestMutationVariables = Exact<{
  data: CreateServiceRequestInput;
}>;


export type CreateServiceRequestMutation = { createServiceRequest: { id: string, company: string, licensePlate?: string | null, status: string, createdAt: any, deletedAt?: any | null, area: string, entranceDate: any, cpf: string, cnpj?: string | null, exitDate: any, requestNumber?: string | null, vehicle?: string | null, meal?: string | null, mealContract?: string | null, mealCostCenter?: string | null, name: string, vehicles?: Array<{ id: string, licensePlate?: string | null, vehicle?: string | null, state?: string | null }> | null, virtualEquipment?: Array<{ name: string, quantity?: number | null }> | null, pool?: Array<{ name: string, entered: number, exited: number, remaining: number }> | null, helper: Array<{ id: string, name: string, entryDate?: any | null, departureDate?: any | null, doc: string }>, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, inspect: Array<{ id: string, type: string, others?: string | null, date: any, vehicleId?: string | null, signature?: string | null, equipmentImage?: string | null, createdAt: any, obs?: string | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, equipment?: Array<{ name: string, quantity?: number | null }> | null }> } };

export type UpdateServiceRequestMutationVariables = Exact<{
  data: UpdateServiceRequestInput;
}>;


export type UpdateServiceRequestMutation = { updateServiceRequest: { id: string, company: string, licensePlate?: string | null, status: string, createdAt: any, deletedAt?: any | null, area: string, entranceDate: any, cpf: string, cnpj?: string | null, exitDate: any, requestNumber?: string | null, vehicle?: string | null, meal?: string | null, mealContract?: string | null, mealCostCenter?: string | null, name: string, vehicles?: Array<{ id: string, licensePlate?: string | null, vehicle?: string | null, state?: string | null }> | null, virtualEquipment?: Array<{ name: string, quantity?: number | null }> | null, pool?: Array<{ name: string, entered: number, exited: number, remaining: number }> | null, helper: Array<{ id: string, name: string, entryDate?: any | null, departureDate?: any | null, doc: string }>, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, inspect: Array<{ id: string, type: string, others?: string | null, date: any, vehicleId?: string | null, signature?: string | null, equipmentImage?: string | null, createdAt: any, obs?: string | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, equipment?: Array<{ name: string, quantity?: number | null }> | null }> } };

export type UpdateServiceRequestDetailMutationVariables = Exact<{
  data: UpdateServiceRequestDetailInput;
}>;


export type UpdateServiceRequestDetailMutation = { updateServiceRequestDetail: { id: string, company: string, licensePlate?: string | null, status: string, createdAt: any, deletedAt?: any | null, area: string, entranceDate: any, cpf: string, cnpj?: string | null, exitDate: any, requestNumber?: string | null, vehicle?: string | null, meal?: string | null, mealContract?: string | null, mealCostCenter?: string | null, name: string, vehicles?: Array<{ id: string, licensePlate?: string | null, vehicle?: string | null, state?: string | null }> | null, virtualEquipment?: Array<{ name: string, quantity?: number | null }> | null, pool?: Array<{ name: string, entered: number, exited: number, remaining: number }> | null, helper: Array<{ id: string, name: string, entryDate?: any | null, departureDate?: any | null, doc: string }>, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, inspect: Array<{ id: string, type: string, others?: string | null, date: any, vehicleId?: string | null, signature?: string | null, equipmentImage?: string | null, createdAt: any, obs?: string | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, equipment?: Array<{ name: string, quantity?: number | null }> | null }> } };

export type InspectServiceRequestMutationVariables = Exact<{
  data: InspectServiceRequestInput;
}>;


export type InspectServiceRequestMutation = { inspectServiceRequest: { id: string, type: string, others?: string | null, date: any, vehicleId?: string | null, signature?: string | null, equipmentImage?: string | null, createdAt: any, obs?: string | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, equipment?: Array<{ name: string, quantity?: number | null }> | null } };

export type FinishServiceRequestMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FinishServiceRequestMutation = { finishServiceRequest: { id: string, company: string, licensePlate?: string | null, status: string, createdAt: any, deletedAt?: any | null, area: string, entranceDate: any, cpf: string, cnpj?: string | null, exitDate: any, requestNumber?: string | null, vehicle?: string | null, meal?: string | null, mealContract?: string | null, mealCostCenter?: string | null, name: string, leftover?: Array<{ name: string, entered: number, exited: number, remaining: number }> | null, vehicles?: Array<{ id: string, licensePlate?: string | null, vehicle?: string | null, state?: string | null }> | null, virtualEquipment?: Array<{ name: string, quantity?: number | null }> | null, pool?: Array<{ name: string, entered: number, exited: number, remaining: number }> | null, helper: Array<{ id: string, name: string, entryDate?: any | null, departureDate?: any | null, doc: string }>, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, inspect: Array<{ id: string, type: string, others?: string | null, date: any, vehicleId?: string | null, signature?: string | null, equipmentImage?: string | null, createdAt: any, obs?: string | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, equipment?: Array<{ name: string, quantity?: number | null }> | null }> } };

export type AddServiceRequestVehicleMutationVariables = Exact<{
  data: AddServiceRequestVehicleInput;
}>;


export type AddServiceRequestVehicleMutation = { addServiceRequestVehicle: { id: string, company: string, licensePlate?: string | null, status: string, createdAt: any, deletedAt?: any | null, area: string, entranceDate: any, cpf: string, cnpj?: string | null, exitDate: any, requestNumber?: string | null, vehicle?: string | null, meal?: string | null, mealContract?: string | null, mealCostCenter?: string | null, name: string, vehicles?: Array<{ id: string, licensePlate?: string | null, vehicle?: string | null, state?: string | null }> | null, virtualEquipment?: Array<{ name: string, quantity?: number | null }> | null, pool?: Array<{ name: string, entered: number, exited: number, remaining: number }> | null, helper: Array<{ id: string, name: string, entryDate?: any | null, departureDate?: any | null, doc: string }>, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, inspect: Array<{ id: string, type: string, others?: string | null, date: any, vehicleId?: string | null, signature?: string | null, equipmentImage?: string | null, createdAt: any, obs?: string | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, equipment?: Array<{ name: string, quantity?: number | null }> | null }> } };

export type RemoveServiceRequestMutationVariables = Exact<{
  data: Scalars['ID'];
}>;


export type RemoveServiceRequestMutation = { removeServiceRequest: { message: string, status: number } };

export type SearchTruckQueryVariables = Exact<{
  data: SearchTruckInput;
}>;


export type SearchTruckQuery = { searchTruck: { totalCount: number, PageSize: number, currentPage: number, totalPage: number, PreviousPage: boolean, nextPage: boolean, results: Array<{ id: string, date?: any | null, driverName?: string | null, driverCpf?: string | null, company?: string | null, licensePlate?: string | null, licensePlatePhoto?: string | null, trailerLicensePlate?: string | null, trailerLicensePlatePhoto?: string | null, autoPhoto?: string | null, isAuto?: boolean | null, sealNumber?: string | null, place?: string | null, placeCollect?: string | null, seal?: boolean | null, sealPhoto?: string | null, sealCorrect?: boolean | null, reason?: string | null, signature?: string | null, status?: string | null, createdAt?: any | null, deletedAt?: any | null, helpers?: Array<{ id: string, name: string, rg: string }> | null, unity?: { id: string, name?: string | null } | null, receipts?: Array<{ id: string, receipt: string }> | null, inspection?: { id: string, comment: string, createdAt: any, date: any, sealNumber?: string | null, sealPhoto?: string | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, receipt?: Array<{ id: string, receipt: string }> | null, equipment?: Array<{ id?: string | null, name: string, quantity?: number | null }> | null } | null, release?: { id: string, comment: string, exitWithTrailer?: boolean | null, createdAt: any, sealPhoto?: string | null, sealStatus?: boolean | null, receipt?: Array<{ id: string, comment: string, status: boolean, receipt?: { id: string, receipt: string } | null }> | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null } | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, checklist?: Array<{ id: string, name: string, status?: boolean | null, statusTruck?: string | null, type: string, comment?: string | null, photo?: string | null }> | null }> } };

export type FindCpfQueryVariables = Exact<{
  cpf: Scalars['String'];
}>;


export type FindCpfQuery = { findCPF: { driverName?: string | null, company?: string | null, licensePlate?: string | null } };

export type RemoveTruckMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveTruckMutation = { removeTruck: { message: string, status: number } };

export type TruckQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TruckQuery = { truck: { id: string, date?: any | null, driverName?: string | null, driverCpf?: string | null, company?: string | null, licensePlate?: string | null, licensePlatePhoto?: string | null, trailerLicensePlate?: string | null, trailerLicensePlatePhoto?: string | null, autoPhoto?: string | null, isAuto?: boolean | null, sealNumber?: string | null, place?: string | null, placeCollect?: string | null, seal?: boolean | null, sealPhoto?: string | null, sealCorrect?: boolean | null, reason?: string | null, signature?: string | null, status?: string | null, createdAt?: any | null, deletedAt?: any | null, helpers?: Array<{ id: string, name: string, rg: string }> | null, unity?: { id: string, name?: string | null } | null, receipts?: Array<{ id: string, receipt: string }> | null, inspection?: { id: string, comment: string, createdAt: any, date: any, sealNumber?: string | null, sealPhoto?: string | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, receipt?: Array<{ id: string, receipt: string }> | null, equipment?: Array<{ id?: string | null, name: string, quantity?: number | null }> | null } | null, release?: { id: string, comment: string, exitWithTrailer?: boolean | null, createdAt: any, sealPhoto?: string | null, sealStatus?: boolean | null, receipt?: Array<{ id: string, comment: string, status: boolean, receipt?: { id: string, receipt: string } | null }> | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null } | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, checklist?: Array<{ id: string, name: string, status?: boolean | null, statusTruck?: string | null, type: string, comment?: string | null, photo?: string | null }> | null } };

export type TruckChecklistEnumQueryVariables = Exact<{ [key: string]: never; }>;


export type TruckChecklistEnumQuery = { truckChecklistEnum: Array<{ type: string, name: string, status?: boolean | null, comment?: string | null }> };

export type EquipmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type EquipmentsQuery = { equipments: Array<{ id: string, name: string }> };

export type CreateTruckMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateTruckMutation = { createTruck: { id: string, date?: any | null, driverName?: string | null, driverCpf?: string | null, company?: string | null, licensePlate?: string | null, licensePlatePhoto?: string | null, trailerLicensePlate?: string | null, trailerLicensePlatePhoto?: string | null, autoPhoto?: string | null, isAuto?: boolean | null, sealNumber?: string | null, place?: string | null, placeCollect?: string | null, seal?: boolean | null, sealPhoto?: string | null, sealCorrect?: boolean | null, reason?: string | null, signature?: string | null, status?: string | null, createdAt?: any | null, deletedAt?: any | null, helpers?: Array<{ id: string, name: string, rg: string }> | null, unity?: { id: string, name?: string | null } | null, receipts?: Array<{ id: string, receipt: string }> | null, inspection?: { id: string, comment: string, createdAt: any, date: any, sealNumber?: string | null, sealPhoto?: string | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, receipt?: Array<{ id: string, receipt: string }> | null, equipment?: Array<{ id?: string | null, name: string, quantity?: number | null }> | null } | null, release?: { id: string, comment: string, exitWithTrailer?: boolean | null, createdAt: any, sealPhoto?: string | null, sealStatus?: boolean | null, receipt?: Array<{ id: string, comment: string, status: boolean, receipt?: { id: string, receipt: string } | null }> | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null } | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, checklist?: Array<{ id: string, name: string, status?: boolean | null, statusTruck?: string | null, type: string, comment?: string | null, photo?: string | null }> | null } };

export type UpdateTruckMutationVariables = Exact<{
  data: UpdateTruckInput;
}>;


export type UpdateTruckMutation = { updateTruck: { id: string, date?: any | null, driverName?: string | null, driverCpf?: string | null, company?: string | null, licensePlate?: string | null, licensePlatePhoto?: string | null, trailerLicensePlate?: string | null, trailerLicensePlatePhoto?: string | null, autoPhoto?: string | null, isAuto?: boolean | null, sealNumber?: string | null, place?: string | null, placeCollect?: string | null, seal?: boolean | null, sealPhoto?: string | null, sealCorrect?: boolean | null, reason?: string | null, signature?: string | null, status?: string | null, createdAt?: any | null, deletedAt?: any | null, helpers?: Array<{ id: string, name: string, rg: string }> | null, unity?: { id: string, name?: string | null } | null, receipts?: Array<{ id: string, receipt: string }> | null, inspection?: { id: string, comment: string, createdAt: any, date: any, sealNumber?: string | null, sealPhoto?: string | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, receipt?: Array<{ id: string, receipt: string }> | null, equipment?: Array<{ id?: string | null, name: string, quantity?: number | null }> | null } | null, release?: { id: string, comment: string, exitWithTrailer?: boolean | null, createdAt: any, sealPhoto?: string | null, sealStatus?: boolean | null, receipt?: Array<{ id: string, comment: string, status: boolean, receipt?: { id: string, receipt: string } | null }> | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null } | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, checklist?: Array<{ id: string, name: string, status?: boolean | null, statusTruck?: string | null, type: string, comment?: string | null, photo?: string | null }> | null } };

export type UpdateTruckPlateMutationVariables = Exact<{
  data: UpdateTruckPlateInput;
}>;


export type UpdateTruckPlateMutation = { updateTruckPlate: { id: string, licensePlate?: string | null, trailerLicensePlate?: string | null, status?: string | null } };

export type InspectTruckMutationVariables = Exact<{
  data: InspectTruckInput;
}>;


export type InspectTruckMutation = { inspectTruck: { id: string, date?: any | null, driverName?: string | null, driverCpf?: string | null, company?: string | null, licensePlate?: string | null, licensePlatePhoto?: string | null, trailerLicensePlate?: string | null, trailerLicensePlatePhoto?: string | null, autoPhoto?: string | null, isAuto?: boolean | null, sealNumber?: string | null, place?: string | null, placeCollect?: string | null, seal?: boolean | null, sealPhoto?: string | null, sealCorrect?: boolean | null, reason?: string | null, signature?: string | null, status?: string | null, createdAt?: any | null, deletedAt?: any | null, helpers?: Array<{ id: string, name: string, rg: string }> | null, unity?: { id: string, name?: string | null } | null, receipts?: Array<{ id: string, receipt: string }> | null, inspection?: { id: string, comment: string, createdAt: any, date: any, sealNumber?: string | null, sealPhoto?: string | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, receipt?: Array<{ id: string, receipt: string }> | null, equipment?: Array<{ id?: string | null, name: string, quantity?: number | null }> | null } | null, release?: { id: string, comment: string, exitWithTrailer?: boolean | null, createdAt: any, sealPhoto?: string | null, sealStatus?: boolean | null, receipt?: Array<{ id: string, comment: string, status: boolean, receipt?: { id: string, receipt: string } | null }> | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null } | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, checklist?: Array<{ id: string, name: string, status?: boolean | null, statusTruck?: string | null, type: string, comment?: string | null, photo?: string | null }> | null } };

export type ReleaseTruckMutationVariables = Exact<{
  data: ReleaseTruckInput;
}>;


export type ReleaseTruckMutation = { releaseTruck: { id: string, date?: any | null, driverName?: string | null, driverCpf?: string | null, company?: string | null, licensePlate?: string | null, licensePlatePhoto?: string | null, trailerLicensePlate?: string | null, trailerLicensePlatePhoto?: string | null, autoPhoto?: string | null, isAuto?: boolean | null, sealNumber?: string | null, place?: string | null, placeCollect?: string | null, seal?: boolean | null, sealPhoto?: string | null, sealCorrect?: boolean | null, reason?: string | null, signature?: string | null, status?: string | null, createdAt?: any | null, deletedAt?: any | null, helpers?: Array<{ id: string, name: string, rg: string }> | null, unity?: { id: string, name?: string | null } | null, receipts?: Array<{ id: string, receipt: string }> | null, inspection?: { id: string, comment: string, createdAt: any, date: any, sealNumber?: string | null, sealPhoto?: string | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, receipt?: Array<{ id: string, receipt: string }> | null, equipment?: Array<{ id?: string | null, name: string, quantity?: number | null }> | null } | null, release?: { id: string, comment: string, exitWithTrailer?: boolean | null, createdAt: any, sealPhoto?: string | null, sealStatus?: boolean | null, receipt?: Array<{ id: string, comment: string, status: boolean, receipt?: { id: string, receipt: string } | null }> | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null } | null, createdBy?: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } | null, checklist?: Array<{ id: string, name: string, status?: boolean | null, statusTruck?: string | null, type: string, comment?: string | null, photo?: string | null }> | null } };

export type RemoveTruckChecklistPhotoMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveTruckChecklistPhotoMutation = { removeTruckChecklistPhoto: { message: string, status: number } };

export type VehiclesByCpfQueryVariables = Exact<{
  cpf: Scalars['String'];
}>;


export type VehiclesByCpfQuery = { vehiclesByCpf: Array<{ id: string, licensePlate: string, trailerLicensePlate?: string | null, createdAt: any }> };

export type CreateVehicleMutationVariables = Exact<{
  data: CreateVehicleInput;
}>;


export type CreateVehicleMutation = { createVehicle: { id: string, licensePlate: string, trailerLicensePlate?: string | null } };

export type UpdateVehicleMutationVariables = Exact<{
  data: UpdateVehicleInput;
}>;


export type UpdateVehicleMutation = { updateVehicle: { id: string, licensePlate: string, trailerLicensePlate?: string | null } };

export type DeleteVehicleMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteVehicleMutation = { deleteVehicle: { status: number, message: string } };

export type GetUnitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnitiesQuery = { unities: Array<{ id: string, name?: string | null }> };

export type GetUnitiesByCountryQueryVariables = Exact<{
  countryId: Scalars['String'];
}>;


export type GetUnitiesByCountryQuery = { getUnitiesByCountry: Array<{ id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null }> };

export type SearchUnityQueryVariables = Exact<{
  input: SearchUnityInput;
}>;


export type SearchUnityQuery = { searchUnity: { totalCount: number, PageSize: number, currentPage: number, totalPage: number, PreviousPage: boolean, nextPage: boolean, results: Array<{ id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null }> } };

export type CreateUnityMutationVariables = Exact<{
  data: CreateUnityInput;
}>;


export type CreateUnityMutation = { createUnity: { id: string, name?: string | null, code: number, city?: string | null, deletedAt?: any | null, users?: Array<{ name?: string | null }> | null, occurrences: Array<{ author?: string | null }>, country?: { name?: string | null } | null, blocs?: Array<{ name?: string | null }> | null, checkListAlarm?: { id: string } | null, checkListAccess?: { id: string } | null, checkListCftv?: { id: string } | null } };

export type UpdateUnityMutationVariables = Exact<{
  data: UpdateUnityInput;
}>;


export type UpdateUnityMutation = { updateUnity: { id: string, name?: string | null, code: number, city?: string | null, deletedAt?: any | null, users?: Array<{ name?: string | null }> | null, occurrences: Array<{ author?: string | null }>, country?: { name?: string | null } | null, blocs?: Array<{ name?: string | null }> | null, checkListAlarm?: { id: string } | null, checkListAccess?: { id: string } | null, checkListCftv?: { id: string } | null } };

export type RemoveUnityMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveUnityMutation = { removeUnity: { status: number, message: string } };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { currentUser: { id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } };

export type UsersQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersQuery = { users: Array<{ id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null }> };

export type SearchUsersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  input: SearchUserInput;
}>;


export type SearchUsersQuery = { searchUsers: { totalCount: number, PageSize: number, currentPage: number, totalPage: number, PreviousPage: boolean, nextPage: boolean, users: Array<{ id: string, name?: string | null, email?: string | null, identifier?: string | null, profile?: string | null, office?: string | null, photo?: string | null, status?: boolean | null, phone?: string | null, isMicrosoft?: boolean | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null }> } };

export type CreateUserMutationVariables = Exact<{
  data: CreateUserInput;
}>;


export type CreateUserMutation = { createUser: { id: string, name?: string | null, status?: boolean | null, profile?: string | null, phone?: string | null, photo?: string | null, createdAt?: any | null, updatedAt?: any | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } };

export type UpdateUserMutationVariables = Exact<{
  data: UpdateUserInput;
}>;


export type UpdateUserMutation = { updateUser: { id: string, name?: string | null, status?: boolean | null, profile?: string | null, phone?: string | null, photo?: string | null, unity?: { id: string, name?: string | null, code: number, city?: string | null, country?: { id: string, name?: string | null, flag?: string | null } | null } | null } };

export type RemoveUserMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveUserMutation = { removeUser: { status: number, message: string } };

export type ForgotPasswordMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type ForgotPasswordMutation = { forgotPassword: { message: string, status: number } };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { resetPassword: { message: string, status: number } };

export const OccurrenceUserFragmentDoc = gql`
    fragment OccurrenceUser on OccurrenceUser {
  address
  addressNumber
  birth
  cep
  complement
  document
  gender
  id
  mother
  father
  jobRole
  name
  nationality
  rg
  sector
  type
  uf
}
    `;
export const CountryFragmentDoc = gql`
    fragment Country on Country {
  id
  name
  flag
}
    `;
export const UnityFragmentDoc = gql`
    fragment Unity on Unity {
  id
  name
  code
  city
  country {
    ...Country
  }
}
    ${CountryFragmentDoc}`;
export const OccurrenceListItemFragmentDoc = gql`
    fragment OccurrenceListItem on Occurrence {
  id
  code
  date
  status
  mitigatingDeadLine
  users {
    ...OccurrenceUser
  }
  unity {
    ...Unity
  }
}
    ${OccurrenceUserFragmentDoc}
${UnityFragmentDoc}`;
export const OccurrenceFileFragmentDoc = gql`
    fragment OccurrenceFile on OccurrenceFile {
  id
  media
  originalName
  url
  comment
}
    `;
export const OccurrenceFragmentDoc = gql`
    fragment Occurrence on Occurrence {
  abscent
  area
  areaResponsible
  author
  authorship
  bulletinNumber
  classification
  code
  company
  createdAt
  date
  deletedAt
  department
  directLoss
  directLossDescription
  directLossType
  directLossObjects
  directLossValue
  retrievedValue
  recoveryStatusDescription
  employeesInvolved
  favor
  favorDetail
  favorOther
  files {
    ...OccurrenceFile
  }
  hour
  id
  indirectLoss
  indirectLossActivity
  indirectLossCost
  indirectLossInterruption
  indirectLossRemoval
  indirectLossTime
  mitigatingMeasuresDescription
  mitigatingDeadLine
  occurrenceDetail
  place
  recoveryStatus
  recurrent
  responsible
  responsiblesCommunicated {
    id
    type
  }
  responsibleCommunicatedOther
  measuresResponsibleName
  measuresResponsibleRole
  sinister
  status
  step
  type
  typeDetail
  unity {
    ...Unity
  }
  updatedAt
  users {
    ...OccurrenceUser
  }
  victims
  victimsDetail
  violence
}
    ${OccurrenceFileFragmentDoc}
${UnityFragmentDoc}
${OccurrenceUserFragmentDoc}`;
export const AccessFragmentDoc = gql`
    fragment Access on Access {
  id
  place
  code
  type
  status
  bloc {
    id
    name
    code
    deletedAt
    createdAt
    unity {
      ...Unity
    }
  }
}
    ${UnityFragmentDoc}`;
export const AlarmFragmentDoc = gql`
    fragment Alarm on Alarm {
  id
  place
  code
  type
  status
  bloc {
    id
    name
    code
    deletedAt
    createdAt
    unity {
      ...Unity
    }
  }
}
    ${UnityFragmentDoc}`;
export const CameraFragmentDoc = gql`
    fragment Camera on Camera {
  id
  code
  place
  type
  mode
  time
  status
  createdAt
  updatedAt
  bloc {
    id
    name
    code
    deletedAt
    createdAt
    unity {
      ...Unity
    }
  }
}
    ${UnityFragmentDoc}`;
export const BlocFragmentDoc = gql`
    fragment Bloc on Bloc {
  id
  name
  code
  capacity
  unity {
    ...Unity
  }
  access {
    ...Access
  }
  alarms {
    ...Alarm
  }
  cameras {
    ...Camera
  }
  deletedAt
  createdAt
}
    ${UnityFragmentDoc}
${AccessFragmentDoc}
${AlarmFragmentDoc}
${CameraFragmentDoc}`;
export const CarpoolRecordFragmentDoc = gql`
    fragment CarpoolRecord on CarpoolRecord {
  id
  employeeName
  registration
  re
  cpf
  licensePlate
  qrRaw
  entryAt
  exitAt
  status
  isManualEntry
  isManualExit
  entryNote
  exitNote
  bloc {
    ...Bloc
  }
  vaga
  unity {
    ...Unity
  }
  entryBy {
    id
    name
  }
  exitBy {
    id
    name
  }
  createdAt
  updatedAt
  deletedAt
}
    ${BlocFragmentDoc}
${UnityFragmentDoc}`;
export const AlarmPageFragmentDoc = gql`
    fragment AlarmPage on AlarmPage {
  PageSize
  PreviousPage
  currentPage
  nextPage
  totalCount
  totalPage
  results {
    ...Alarm
  }
}
    ${AlarmFragmentDoc}`;
export const AccessPageFragmentDoc = gql`
    fragment AccessPage on AccessPage {
  PageSize
  PreviousPage
  currentPage
  nextPage
  totalCount
  totalPage
  results {
    ...Access
  }
}
    ${AccessFragmentDoc}`;
export const CameraPageFragmentDoc = gql`
    fragment CameraPage on CameraPage {
  PageSize
  PreviousPage
  currentPage
  nextPage
  totalCount
  totalPage
  results {
    ...Camera
  }
}
    ${CameraFragmentDoc}`;
export const DefaultMessageFragmentDoc = gql`
    fragment DefaultMessage on DefaultMessage {
  message
  status
}
    `;
export const UserFragmentDoc = gql`
    fragment User on User {
  id
  name
  email
  identifier
  profile
  office
  photo
  status
  phone
  isMicrosoft
  unity {
    ...Unity
  }
}
    ${UnityFragmentDoc}`;
export const SearchCheckListAccessResultFragmentDoc = gql`
    fragment SearchCheckListAccessResult on SearchCheckListAccessResult {
  PageSize
  PreviousPage
  currentPage
  nextPage
  totalCount
  totalPage
  result {
    createdAt
    createdBy {
      ...User
    }
    damage
    date
    id
    late
    status
    total
    unity {
      ...Unity
    }
  }
}
    ${UserFragmentDoc}
${UnityFragmentDoc}`;
export const CheckListCreateDtoFragmentDoc = gql`
    fragment CheckListCreateDto on CheckListCreateDto {
  id
}
    `;
export const CheckListAccessCommentFragmentDoc = gql`
    fragment CheckListAccessComment on CheckListAccessComment {
  id
  comment
  createdAt
  status
  createdBy {
    ...User
  }
}
    ${UserFragmentDoc}`;
export const CheckListAccessItemFragmentDoc = gql`
    fragment CheckListAccessItem on CheckListAccessItem {
  condition
  createdAt
  dateLimit
  id
  status
  access {
    ...Access
  }
  comments {
    ...CheckListAccessComment
  }
}
    ${AccessFragmentDoc}
${CheckListAccessCommentFragmentDoc}`;
export const ChecklistAccessUnfinishedDtoFragmentDoc = gql`
    fragment ChecklistAccessUnfinishedDto on ChecklistAccessUnfinishedDto {
  status
  blocs {
    done
    id
    lastItemDate
    name
    total
    items {
      ...CheckListAccessItem
    }
  }
}
    ${CheckListAccessItemFragmentDoc}`;
export const CheckListAccessFragmentDoc = gql`
    fragment CheckListAccess on CheckListAccess {
  id
  date
  status
  createdBy {
    ...User
  }
  createdAt
  deletedAt
  updatedAt
  deletedBy {
    ...User
  }
  unity {
    ...Unity
  }
}
    ${UserFragmentDoc}
${UnityFragmentDoc}`;
export const CheckListAccessFinishedDtoFragmentDoc = gql`
    fragment CheckListAccessFinishedDto on CheckListAccessFinishedDto {
  PageSize
  PreviousPage
  currentPage
  nextPage
  checklist {
    ...CheckListAccess
  }
  totalCount
  totalPage
  items {
    ...CheckListAccessItem
  }
}
    ${CheckListAccessFragmentDoc}
${CheckListAccessItemFragmentDoc}`;
export const SearchCheckListCftvResultFragmentDoc = gql`
    fragment SearchCheckListCftvResult on SearchCheckListCftvResult {
  PageSize
  PreviousPage
  currentPage
  nextPage
  totalCount
  totalPage
  result {
    createdAt
    createdBy {
      ...User
    }
    damage
    date
    id
    late
    status
    total
    unity {
      ...Unity
    }
  }
}
    ${UserFragmentDoc}
${UnityFragmentDoc}`;
export const CheckListCftvCreateDtoFragmentDoc = gql`
    fragment CheckListCftvCreateDto on CheckListCftvCreateDto {
  id
}
    `;
export const CheckListCftvCommentFragmentDoc = gql`
    fragment CheckListCftvComment on CheckListCftvComment {
  id
  comment
  status
  createdAt
  createdBy {
    ...User
  }
}
    ${UserFragmentDoc}`;
export const CheckListCftvItemFragmentDoc = gql`
    fragment CheckListCftvItem on CheckListCftvItem {
  alignment
  alimentation
  daysRecorded
  focus
  signal
  createdAt
  dateLimit
  id
  status
  camera {
    ...Camera
  }
  comments {
    ...CheckListCftvComment
  }
}
    ${CameraFragmentDoc}
${CheckListCftvCommentFragmentDoc}`;
export const CheckListCftvUnfinishedDtoFragmentDoc = gql`
    fragment CheckListCftvUnfinishedDto on CheckListCftvUnfinishedDto {
  status
  blocs {
    done
    id
    lastItemDate
    name
    total
    items {
      ...CheckListCftvItem
    }
  }
}
    ${CheckListCftvItemFragmentDoc}`;
export const CheckListCftvFragmentDoc = gql`
    fragment CheckListCftv on CheckListCftv {
  createdBy {
    ...User
  }
  unity {
    ...Unity
  }
}
    ${UserFragmentDoc}
${UnityFragmentDoc}`;
export const CheckListCftvFinishedDtoFragmentDoc = gql`
    fragment CheckListCftvFinishedDto on CheckListCftvFinishedDto {
  PageSize
  PreviousPage
  currentPage
  nextPage
  totalCount
  totalPage
  checklist {
    ...CheckListCftv
  }
  items {
    ...CheckListCftvItem
  }
}
    ${CheckListCftvFragmentDoc}
${CheckListCftvItemFragmentDoc}`;
export const SearchCheckListAlarmResultFragmentDoc = gql`
    fragment SearchCheckListAlarmResult on SearchCheckListAlarmResult {
  PageSize
  PreviousPage
  currentPage
  nextPage
  totalCount
  totalPage
  result {
    createdAt
    createdBy {
      ...User
    }
    damage
    date
    id
    late
    status
    total
    unity {
      ...Unity
    }
  }
}
    ${UserFragmentDoc}
${UnityFragmentDoc}`;
export const CheckListAlarmCreateDtoFragmentDoc = gql`
    fragment CheckListAlarmCreateDto on CheckListAlarmCreateDto {
  id
}
    `;
export const CheckListAlarmCommentFragmentDoc = gql`
    fragment CheckListAlarmComment on CheckListAlarmComment {
  id
  comment
  status
  createdAt
  createdBy {
    ...User
  }
}
    ${UserFragmentDoc}`;
export const CheckListAlarmItemFragmentDoc = gql`
    fragment CheckListAlarmItem on CheckListAlarmItem {
  condition
  createdAt
  dateLimit
  id
  status
  alarm {
    ...Alarm
  }
  comments {
    ...CheckListAlarmComment
  }
}
    ${AlarmFragmentDoc}
${CheckListAlarmCommentFragmentDoc}`;
export const CheckListAlarmUnfinishedDtoFragmentDoc = gql`
    fragment CheckListAlarmUnfinishedDto on CheckListAlarmUnfinishedDto {
  status
  blocs {
    done
    id
    lastItemDate
    name
    total
    items {
      ...CheckListAlarmItem
    }
  }
}
    ${CheckListAlarmItemFragmentDoc}`;
export const CheckListAlarmFragmentDoc = gql`
    fragment CheckListAlarm on CheckListAlarm {
  id
  date
  status
  createdBy {
    ...User
  }
  createdAt
  deletedAt
  updatedAt
  deletedBy {
    ...User
  }
  unity {
    ...Unity
  }
}
    ${UserFragmentDoc}
${UnityFragmentDoc}`;
export const CheckListAlarmFinishedDtoFragmentDoc = gql`
    fragment CheckListAlarmFinishedDto on CheckListAlarmFinishedDto {
  PageSize
  PreviousPage
  currentPage
  nextPage
  totalCount
  checklist {
    ...CheckListAlarm
  }
  totalPage
  items {
    ...CheckListAlarmItem
  }
}
    ${CheckListAlarmFragmentDoc}
${CheckListAlarmItemFragmentDoc}`;
export const PhysicalSecurityMemberFragmentDoc = gql`
    fragment PhysicalSecurityMember on PhysicalSecurityMember {
  id
  name
  document
  status
}
    `;
export const PhysicalSecurityFragmentDoc = gql`
    fragment PhysicalSecurity on PhysicalSecurity {
  id
  code
  companyStatus
  name
  cnpj
  segment
  phone
  stationNumber
  createdAt
  deletedAt
  members {
    ...PhysicalSecurityMember
  }
}
    ${PhysicalSecurityMemberFragmentDoc}`;
export const PhysicalSecurityPageFragmentDoc = gql`
    fragment PhysicalSecurityPage on PhysicalSecurityPage {
  PageSize
  PreviousPage
  currentPage
  nextPage
  totalCount
  totalPage
  physicalSecurity {
    ...PhysicalSecurity
  }
}
    ${PhysicalSecurityFragmentDoc}`;
export const PolicyFragmentDoc = gql`
    fragment Policy on Policy {
  id
  title
  description
  link
  isPortuguese
  isSpanish
  country {
    ...Country
  }
  createdAt
  updatedAt
}
    ${CountryFragmentDoc}`;
export const TruckFragmentDoc = gql`
    fragment Truck on Truck {
  id
  date
  driverName
  driverCpf
  company
  licensePlate
  licensePlatePhoto
  trailerLicensePlate
  trailerLicensePlatePhoto
  autoPhoto
  isAuto
  sealNumber
  place
  placeCollect
  seal
  sealPhoto
  sealCorrect
  reason
  helpers {
    id
    name
    rg
  }
  unity {
    id
    name
  }
  receipts {
    id
    receipt
  }
  inspection {
    id
    comment
    createdAt
    createdBy {
      ...User
    }
    date
    sealNumber
    sealPhoto
    receipt {
      id
      receipt
    }
    equipment {
      id
      name
      quantity
    }
  }
  release {
    id
    comment
    exitWithTrailer
    createdAt
    receipt {
      id
      comment
      status
      receipt {
        id
        receipt
      }
    }
    sealPhoto
    sealStatus
    createdBy {
      ...User
    }
  }
  signature
  status
  createdAt
  deletedAt
  createdBy {
    ...User
  }
  checklist {
    id
    name
    status
    statusTruck
    type
    comment
    photo
  }
}
    ${UserFragmentDoc}`;
export const ServiceRequestInspectFragmentDoc = gql`
    fragment ServiceRequestInspect on ServiceRequestInspect {
  id
  type
  others
  date
  vehicleId
  signature
  equipmentImage
  createdAt
  createdBy {
    ...User
  }
  equipment {
    name
    quantity
  }
  obs
}
    ${UserFragmentDoc}`;
export const ServiceRequestFragmentDoc = gql`
    fragment ServiceRequest on ServiceRequest {
  id
  company
  licensePlate
  status
  createdAt
  deletedAt
  area
  entranceDate
  cpf
  cnpj
  exitDate
  requestNumber
  vehicle
  vehicles {
    id
    licensePlate
    vehicle
    state
  }
  meal
  mealContract
  mealCostCenter
  virtualEquipment {
    name
    quantity
  }
  pool {
    name
    entered
    exited
    remaining
  }
  helper {
    id
    name
    entryDate
    departureDate
    doc
  }
  name
  createdBy {
    ...User
  }
  inspect {
    ...ServiceRequestInspect
  }
}
    ${UserFragmentDoc}
${ServiceRequestInspectFragmentDoc}`;
export const DaycareChildDetailFragmentDoc = gql`
    fragment DaycareChildDetail on DaycareChild {
  id
  name
  year
  employee {
    id
    re
    name
    email
  }
  guardians {
    id
    kind
    name
    documentRaw
    position
  }
}
    `;
export const SearchCheckListAccessDocument = gql`
    query SearchCheckListAccess($data: SearchCheckListAccess!) {
  searchCheckListAccess(data: $data) {
    ...SearchCheckListAccessResult
  }
}
    ${SearchCheckListAccessResultFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchCheckListAccessGQL extends Apollo.Query<SearchCheckListAccessQuery, SearchCheckListAccessQueryVariables> {
    document = SearchCheckListAccessDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCheckListAccessUnfinishedDocument = gql`
    query GetCheckListAccessUnfinished($id: String!) {
  checkListAccessUnfinished(id: $id) {
    ...ChecklistAccessUnfinishedDto
  }
}
    ${ChecklistAccessUnfinishedDtoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCheckListAccessUnfinishedGQL extends Apollo.Query<GetCheckListAccessUnfinishedQuery, GetCheckListAccessUnfinishedQueryVariables> {
    document = GetCheckListAccessUnfinishedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCheckListAccessFinishedDocument = gql`
    query GetCheckListAccessFinished($data: CheckListAccessFinishedFilter!) {
  checkListAccessFinished(data: $data) {
    ...CheckListAccessFinishedDto
  }
}
    ${CheckListAccessFinishedDtoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCheckListAccessFinishedGQL extends Apollo.Query<GetCheckListAccessFinishedQuery, GetCheckListAccessFinishedQueryVariables> {
    document = GetCheckListAccessFinishedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCheckListAccessDocument = gql`
    mutation CreateCheckListAccess {
  createCheckListAccess {
    ...CheckListCreateDto
  }
}
    ${CheckListCreateDtoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCheckListAccessGQL extends Apollo.Mutation<CreateCheckListAccessMutation, CreateCheckListAccessMutationVariables> {
    document = CreateCheckListAccessDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCheckListAccessDocument = gql`
    mutation UpdateCheckListAccess($data: CheckListUpdateInput!) {
  updateCheckListAccess(data: $data) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCheckListAccessGQL extends Apollo.Mutation<UpdateCheckListAccessMutation, UpdateCheckListAccessMutationVariables> {
    document = UpdateCheckListAccessDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCheckListAccessItemStatusDocument = gql`
    mutation UpdateCheckListAccessItemStatus($data: CheckListItemStatusUpdateInput!) {
  updateCheckListAccessItemStatus(data: $data) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCheckListAccessItemStatusGQL extends Apollo.Mutation<UpdateCheckListAccessItemStatusMutation, UpdateCheckListAccessItemStatusMutationVariables> {
    document = UpdateCheckListAccessItemStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveCheckListAccessDocument = gql`
    mutation RemoveCheckListAccess($id: String!) {
  removeCheckListAccess(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveCheckListAccessGQL extends Apollo.Mutation<RemoveCheckListAccessMutation, RemoveCheckListAccessMutationVariables> {
    document = RemoveCheckListAccessDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchAccessDocument = gql`
    query SearchAccess($data: SearchAccessInput!) {
  searchAccess(data: $data) {
    ...AccessPage
  }
}
    ${AccessPageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchAccessGQL extends Apollo.Query<SearchAccessQuery, SearchAccessQueryVariables> {
    document = SearchAccessDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBlocsDocument = gql`
    query GetBlocs {
  blocs {
    id
    name
    code
    unity {
      name
    }
    cameras {
      id
      status
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBlocsGQL extends Apollo.Query<GetBlocsQuery, GetBlocsQueryVariables> {
    document = GetBlocsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAccessDocument = gql`
    mutation CreateAccess($data: CreateAccessInput!) {
  createAccess(data: $data) {
    id
    place
    code
    type
    status
    bloc {
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAccessGQL extends Apollo.Mutation<CreateAccessMutation, CreateAccessMutationVariables> {
    document = CreateAccessDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAccessDocument = gql`
    mutation UpdateAccess($data: UpdateAccessInput!) {
  updateAccess(data: $data) {
    id
    place
    code
    type
    status
    bloc {
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAccessGQL extends Apollo.Mutation<UpdateAccessMutation, UpdateAccessMutationVariables> {
    document = UpdateAccessDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveAccessDocument = gql`
    mutation RemoveAccess($id: ID!) {
  removeAccess(id: $id) {
    status
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveAccessGQL extends Apollo.Mutation<RemoveAccessMutation, RemoveAccessMutationVariables> {
    document = RemoveAccessDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchCheckListAlarmDocument = gql`
    query SearchCheckListAlarm($data: SearchCheckListAlarm!) {
  searchCheckListAlarm(data: $data) {
    ...SearchCheckListAlarmResult
  }
}
    ${SearchCheckListAlarmResultFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchCheckListAlarmGQL extends Apollo.Query<SearchCheckListAlarmQuery, SearchCheckListAlarmQueryVariables> {
    document = SearchCheckListAlarmDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCheckListAlarmUnfinishedDocument = gql`
    query GetCheckListAlarmUnfinished($id: String!) {
  checkListAlarmUnfinished(id: $id) {
    ...CheckListAlarmUnfinishedDto
  }
}
    ${CheckListAlarmUnfinishedDtoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCheckListAlarmUnfinishedGQL extends Apollo.Query<GetCheckListAlarmUnfinishedQuery, GetCheckListAlarmUnfinishedQueryVariables> {
    document = GetCheckListAlarmUnfinishedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCheckListAlarmFinishedDocument = gql`
    query GetCheckListAlarmFinished($data: CheckListAlarmFinishedFilter!) {
  checkListAlarmFinished(data: $data) {
    ...CheckListAlarmFinishedDto
  }
}
    ${CheckListAlarmFinishedDtoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCheckListAlarmFinishedGQL extends Apollo.Query<GetCheckListAlarmFinishedQuery, GetCheckListAlarmFinishedQueryVariables> {
    document = GetCheckListAlarmFinishedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCheckListAlarmDocument = gql`
    mutation CreateCheckListAlarm {
  createCheckListAlarm {
    ...CheckListAlarmCreateDto
  }
}
    ${CheckListAlarmCreateDtoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCheckListAlarmGQL extends Apollo.Mutation<CreateCheckListAlarmMutation, CreateCheckListAlarmMutationVariables> {
    document = CreateCheckListAlarmDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCheckListAlarmDocument = gql`
    mutation UpdateCheckListAlarm($data: CheckListAlarmUpdateInput!) {
  updateCheckListAlarm(data: $data) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCheckListAlarmGQL extends Apollo.Mutation<UpdateCheckListAlarmMutation, UpdateCheckListAlarmMutationVariables> {
    document = UpdateCheckListAlarmDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCheckListAlarmItemStatusDocument = gql`
    mutation UpdateCheckListAlarmItemStatus($data: CheckListAlarmItemStatusUpdateInput!) {
  updateCheckListAlarmItemStatus(data: $data) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCheckListAlarmItemStatusGQL extends Apollo.Mutation<UpdateCheckListAlarmItemStatusMutation, UpdateCheckListAlarmItemStatusMutationVariables> {
    document = UpdateCheckListAlarmItemStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveCheckListAlarmDocument = gql`
    mutation RemoveCheckListAlarm($id: String!) {
  removeCheckListAlarm(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveCheckListAlarmGQL extends Apollo.Mutation<RemoveCheckListAlarmMutation, RemoveCheckListAlarmMutationVariables> {
    document = RemoveCheckListAlarmDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchAlarmDocument = gql`
    query SearchAlarm($data: SearchAlarmInput!) {
  searchAlarm(data: $data) {
    ...AlarmPage
  }
}
    ${AlarmPageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchAlarmGQL extends Apollo.Query<SearchAlarmQuery, SearchAlarmQueryVariables> {
    document = SearchAlarmDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmByBlocDocument = gql`
    query alarmByBloc($id: String!) {
  alarmByBloc(id: $id) {
    ...Alarm
  }
}
    ${AlarmFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmByBlocGQL extends Apollo.Query<AlarmByBlocQuery, AlarmByBlocQueryVariables> {
    document = AlarmByBlocDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAlarmDocument = gql`
    mutation CreateAlarm($data: CreateAlarmInput!) {
  createAlarm(data: $data) {
    id
    place
    code
    type
    status
    bloc {
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAlarmGQL extends Apollo.Mutation<CreateAlarmMutation, CreateAlarmMutationVariables> {
    document = CreateAlarmDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAlarmDocument = gql`
    mutation UpdateAlarm($data: UpdateAlarmInput!) {
  updateAlarm(data: $data) {
    id
    place
    code
    type
    status
    bloc {
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAlarmGQL extends Apollo.Mutation<UpdateAlarmMutation, UpdateAlarmMutationVariables> {
    document = UpdateAlarmDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveAlarmDocument = gql`
    mutation RemoveAlarm($id: String!) {
  removeAlarm(id: $id) {
    status
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveAlarmGQL extends Apollo.Mutation<RemoveAlarmMutation, RemoveAlarmMutationVariables> {
    document = RemoveAlarmDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchBlocsDocument = gql`
    query SearchBlocs($input: SearchBlocInput!) {
  searchBloc(data: $input) {
    totalCount
    PageSize
    currentPage
    totalPage
    PreviousPage
    nextPage
    results {
      ...Bloc
    }
  }
}
    ${BlocFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchBlocsGQL extends Apollo.Query<SearchBlocsQuery, SearchBlocsQueryVariables> {
    document = SearchBlocsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBlocByUnityDocument = gql`
    query GetBlocByUnity($unityId: String!) {
  blocByUnity(id: $unityId) {
    ...Bloc
  }
}
    ${BlocFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBlocByUnityGQL extends Apollo.Query<GetBlocByUnityQuery, GetBlocByUnityQueryVariables> {
    document = GetBlocByUnityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateBlocDocument = gql`
    mutation CreateBloc($input: CreateBlocInput!) {
  createBloc(data: $input) {
    ...Bloc
  }
}
    ${BlocFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateBlocGQL extends Apollo.Mutation<CreateBlocMutation, CreateBlocMutationVariables> {
    document = CreateBlocDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnityBlocsDocument = gql`
    query unityBlocs($type: String!) {
  unityBlocs(type: $type) {
    bloc {
      ...Bloc
    }
    summary
  }
}
    ${BlocFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UnityBlocsGQL extends Apollo.Query<UnityBlocsQuery, UnityBlocsQueryVariables> {
    document = UnityBlocsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateBlocDocument = gql`
    mutation UpdateBloc($input: UpdateBlocInput!) {
  updateBloc(data: $input) {
    ...Bloc
  }
}
    ${BlocFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateBlocGQL extends Apollo.Mutation<UpdateBlocMutation, UpdateBlocMutationVariables> {
    document = UpdateBlocDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveBlocDocument = gql`
    mutation RemoveBloc($input: ID!) {
  removeBloc(id: $input) {
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveBlocGQL extends Apollo.Mutation<RemoveBlocMutation, RemoveBlocMutationVariables> {
    document = RemoveBlocDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchCameraDocument = gql`
    query searchCamera($data: SearchCameraInput!) {
  searchCamera(data: $data) {
    ...CameraPage
  }
}
    ${CameraPageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchCameraGQL extends Apollo.Query<SearchCameraQuery, SearchCameraQueryVariables> {
    document = SearchCameraDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCameraDocument = gql`
    mutation CreateCamera($data: CreateCameraInput!) {
  createCamera(data: $data) {
    id
    code
    place
    type
    mode
    time
    status
    createdAt
    updatedAt
    bloc {
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCameraGQL extends Apollo.Mutation<CreateCameraMutation, CreateCameraMutationVariables> {
    document = CreateCameraDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCameraDocument = gql`
    mutation updateCamera($data: UpdateCameraInput!) {
  updateCamera(data: $data) {
    id
    code
    place
    type
    mode
    time
    status
    createdAt
    updatedAt
    bloc {
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCameraGQL extends Apollo.Mutation<UpdateCameraMutation, UpdateCameraMutationVariables> {
    document = UpdateCameraDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveCameraDocument = gql`
    mutation removeCamera($id: String!) {
  removeCamera(id: $id) {
    status
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveCameraGQL extends Apollo.Mutation<RemoveCameraMutation, RemoveCameraMutationVariables> {
    document = RemoveCameraDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CaronaBlocsAvailabilityDocument = gql`
    query CaronaBlocsAvailability($unity: ID!) {
  caronaBlocsAvailability(unity: $unity) {
    bloc {
      id
      name
      capacity
    }
    capacity
    occupied
    available
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CaronaBlocsAvailabilityGQL extends Apollo.Query<CaronaBlocsAvailabilityQuery, CaronaBlocsAvailabilityQueryVariables> {
    document = CaronaBlocsAvailabilityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegisterCaronaEntryDocument = gql`
    mutation RegisterCaronaEntry($data: RegisterCaronaEntryInput!) {
  registerCaronaEntry(data: $data) {
    ...CarpoolRecord
  }
}
    ${CarpoolRecordFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RegisterCaronaEntryGQL extends Apollo.Mutation<RegisterCaronaEntryMutation, RegisterCaronaEntryMutationVariables> {
    document = RegisterCaronaEntryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegisterCaronaExitDocument = gql`
    mutation RegisterCaronaExit($data: RegisterCaronaExitInput!) {
  registerCaronaExit(data: $data) {
    ...CarpoolRecord
  }
}
    ${CarpoolRecordFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RegisterCaronaExitGQL extends Apollo.Mutation<RegisterCaronaExitMutation, RegisterCaronaExitMutationVariables> {
    document = RegisterCaronaExitDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OpenCaronaRecordDocument = gql`
    query OpenCaronaRecord($unity: ID!, $term: String!) {
  openCaronaRecord(unity: $unity, term: $term) {
    ...CarpoolRecord
  }
}
    ${CarpoolRecordFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OpenCaronaRecordGQL extends Apollo.Query<OpenCaronaRecordQuery, OpenCaronaRecordQueryVariables> {
    document = OpenCaronaRecordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OpenCaronaRecordsDocument = gql`
    query OpenCaronaRecords($unity: ID!, $term: String!) {
  openCaronaRecords(unity: $unity, term: $term) {
    ...CarpoolRecord
  }
}
    ${CarpoolRecordFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OpenCaronaRecordsGQL extends Apollo.Query<OpenCaronaRecordsQuery, OpenCaronaRecordsQueryVariables> {
    document = OpenCaronaRecordsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchCaronaDocument = gql`
    query SearchCarona($data: SearchCaronaInput!) {
  searchCarona(data: $data) {
    PageSize
    currentPage
    totalPage
    PreviousPage
    nextPage
    totalCount
    results {
      ...CarpoolRecord
    }
  }
}
    ${CarpoolRecordFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchCaronaGQL extends Apollo.Query<SearchCaronaQuery, SearchCaronaQueryVariables> {
    document = SearchCaronaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CaronaDocument = gql`
    query Carona($id: ID!) {
  carona(id: $id) {
    ...CarpoolRecord
  }
}
    ${CarpoolRecordFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CaronaGQL extends Apollo.Query<CaronaQuery, CaronaQueryVariables> {
    document = CaronaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CaronaVagaOcupadaDocument = gql`
    query CaronaVagaOcupada($unity: ID!, $vaga: String!) {
  caronaVagaOcupada(unity: $unity, vaga: $vaga)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CaronaVagaOcupadaGQL extends Apollo.Query<CaronaVagaOcupadaQuery, CaronaVagaOcupadaQueryVariables> {
    document = CaronaVagaOcupadaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveCaronaDocument = gql`
    mutation RemoveCarona($id: ID!) {
  removeCarona(id: $id) {
    status
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveCaronaGQL extends Apollo.Mutation<RemoveCaronaMutation, RemoveCaronaMutationVariables> {
    document = RemoveCaronaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchCheckListCftvDocument = gql`
    query SearchCheckListCftv($data: SearchCheckListCftv!) {
  searchCheckListCftv(data: $data) {
    ...SearchCheckListCftvResult
  }
}
    ${SearchCheckListCftvResultFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchCheckListCftvGQL extends Apollo.Query<SearchCheckListCftvQuery, SearchCheckListCftvQueryVariables> {
    document = SearchCheckListCftvDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCheckListCftvUnfinishedDocument = gql`
    query GetCheckListCftvUnfinished($id: String!) {
  checkListCftvUnfinished(id: $id) {
    ...CheckListCftvUnfinishedDto
  }
}
    ${CheckListCftvUnfinishedDtoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCheckListCftvUnfinishedGQL extends Apollo.Query<GetCheckListCftvUnfinishedQuery, GetCheckListCftvUnfinishedQueryVariables> {
    document = GetCheckListCftvUnfinishedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCheckListCftvFinishedDocument = gql`
    query GetCheckListCftvFinished($data: CheckListCftvFinishedFilter!) {
  checkListCftvFinished(data: $data) {
    ...CheckListCftvFinishedDto
  }
}
    ${CheckListCftvFinishedDtoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCheckListCftvFinishedGQL extends Apollo.Query<GetCheckListCftvFinishedQuery, GetCheckListCftvFinishedQueryVariables> {
    document = GetCheckListCftvFinishedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCheckListCftvDocument = gql`
    mutation CreateCheckListCftv {
  createCheckListCftv {
    ...CheckListCftvCreateDto
  }
}
    ${CheckListCftvCreateDtoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCheckListCftvGQL extends Apollo.Mutation<CreateCheckListCftvMutation, CreateCheckListCftvMutationVariables> {
    document = CreateCheckListCftvDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCheckListCftvDocument = gql`
    mutation UpdateCheckListCftv($data: CheckListCftvUpdateInput!) {
  updateCheckListCftv(data: $data) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCheckListCftvGQL extends Apollo.Mutation<UpdateCheckListCftvMutation, UpdateCheckListCftvMutationVariables> {
    document = UpdateCheckListCftvDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCheckListCftvItemStatusDocument = gql`
    mutation UpdateCheckListCftvItemStatus($data: CheckListCftvItemStatusUpdateInput!) {
  updateCheckListCftvItemStatus(data: $data) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCheckListCftvItemStatusGQL extends Apollo.Mutation<UpdateCheckListCftvItemStatusMutation, UpdateCheckListCftvItemStatusMutationVariables> {
    document = UpdateCheckListCftvItemStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveCheckListCftvDocument = gql`
    mutation RemoveCheckListCftv($id: String!) {
  removeCheckListCftv(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveCheckListCftvGQL extends Apollo.Mutation<RemoveCheckListCftvMutation, RemoveCheckListCftvMutationVariables> {
    document = RemoveCheckListCftvDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCountriesDocument = gql`
    query GetCountries {
  countries {
    id
    name
    flag
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCountriesGQL extends Apollo.Query<GetCountriesQuery, GetCountriesQueryVariables> {
    document = GetCountriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOccurrenceDashboardDocument = gql`
    query GetOccurrenceDashboard($data: SearchStatisticInput!) {
  occurrenceDashboard(data: $data) {
    month
    date
    detail {
      count
      type
    }
    year
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOccurrenceDashboardGQL extends Apollo.Query<GetOccurrenceDashboardQuery, GetOccurrenceDashboardQueryVariables> {
    document = GetOccurrenceDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOccurrenceLossDashboardDocument = gql`
    query GetOccurrenceLossDashboard($data: SearchStatisticInput!) {
  occurrenceLossDashboard(data: $data) {
    direct
    indirect
    month
    total
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOccurrenceLossDashboardGQL extends Apollo.Query<GetOccurrenceLossDashboardQuery, GetOccurrenceLossDashboardQueryVariables> {
    document = GetOccurrenceLossDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOccurrenceActivityDocument = gql`
    query GetOccurrenceActivity($data: SearchStatisticInput!) {
  occurrenceActivityDashboard(data: $data) {
    month
    time
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOccurrenceActivityGQL extends Apollo.Query<GetOccurrenceActivityQuery, GetOccurrenceActivityQueryVariables> {
    document = GetOccurrenceActivityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOccurrenceAvoidedRecoveredDocument = gql`
    query GetOccurrenceAvoidedRecovered($data: SearchStatisticInput!) {
  occurrenceAvoidedRecoveredDashboard(data: $data) {
    count
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOccurrenceAvoidedRecoveredGQL extends Apollo.Query<GetOccurrenceAvoidedRecoveredQuery, GetOccurrenceAvoidedRecoveredQueryVariables> {
    document = GetOccurrenceAvoidedRecoveredDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchDaycareChildDocument = gql`
    query SearchDaycareChild($data: SearchDaycareChildInput!) {
  searchDaycareChild(data: $data) {
    totalCount
    PageSize
    currentPage
    totalPage
    PreviousPage
    nextPage
    results {
      id
      name
      year
      employee {
        id
        re
        name
        email
      }
      guardians {
        id
        kind
        name
        documentRaw
        position
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchDaycareChildGQL extends Apollo.Query<SearchDaycareChildQuery, SearchDaycareChildQueryVariables> {
    document = SearchDaycareChildDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DaycareChildDocument = gql`
    query DaycareChild($id: ID!) {
  daycareChild(id: $id) {
    ...DaycareChildDetail
  }
}
    ${DaycareChildDetailFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DaycareChildGQL extends Apollo.Query<DaycareChildQuery, DaycareChildQueryVariables> {
    document = DaycareChildDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDaycareGuardianDocument = gql`
    mutation CreateDaycareGuardian($data: CreateDaycareGuardianInput!) {
  createDaycareGuardian(data: $data) {
    ...DaycareChildDetail
  }
}
    ${DaycareChildDetailFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDaycareGuardianGQL extends Apollo.Mutation<CreateDaycareGuardianMutation, CreateDaycareGuardianMutationVariables> {
    document = CreateDaycareGuardianDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDaycareGuardianDocument = gql`
    mutation UpdateDaycareGuardian($data: UpdateDaycareGuardianInput!) {
  updateDaycareGuardian(data: $data) {
    ...DaycareChildDetail
  }
}
    ${DaycareChildDetailFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDaycareGuardianGQL extends Apollo.Mutation<UpdateDaycareGuardianMutation, UpdateDaycareGuardianMutationVariables> {
    document = UpdateDaycareGuardianDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveDaycareGuardianDocument = gql`
    mutation RemoveDaycareGuardian($id: ID!) {
  removeDaycareGuardian(id: $id) {
    status
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveDaycareGuardianGQL extends Apollo.Mutation<RemoveDaycareGuardianMutation, RemoveDaycareGuardianMutationVariables> {
    document = RemoveDaycareGuardianDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDaycareChildDocument = gql`
    mutation CreateDaycareChild($data: CreateDaycareChildInput!) {
  createDaycareChild(data: $data) {
    ...DaycareChildDetail
  }
}
    ${DaycareChildDetailFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDaycareChildGQL extends Apollo.Mutation<CreateDaycareChildMutation, CreateDaycareChildMutationVariables> {
    document = CreateDaycareChildDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDaycareChildDocument = gql`
    mutation UpdateDaycareChild($data: UpdateDaycareChildInput!) {
  updateDaycareChild(data: $data) {
    ...DaycareChildDetail
  }
}
    ${DaycareChildDetailFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDaycareChildGQL extends Apollo.Mutation<UpdateDaycareChildMutation, UpdateDaycareChildMutationVariables> {
    document = UpdateDaycareChildDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveDaycareChildDocument = gql`
    mutation RemoveDaycareChild($id: ID!) {
  removeDaycareChild(id: $id) {
    status
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveDaycareChildGQL extends Apollo.Mutation<RemoveDaycareChildMutation, RemoveDaycareChildMutationVariables> {
    document = RemoveDaycareChildDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchDaycarePickupCandidatesDocument = gql`
    query SearchDaycarePickupCandidates($term: String!) {
  searchDaycarePickupCandidates(term: $term) {
    personKind
    personName
    personDocument
    employeeRe
    children {
      id
      name
      status
      entryAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchDaycarePickupCandidatesGQL extends Apollo.Query<SearchDaycarePickupCandidatesQuery, SearchDaycarePickupCandidatesQueryVariables> {
    document = SearchDaycarePickupCandidatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegisterDaycareEntryDocument = gql`
    mutation RegisterDaycareEntry($data: RegisterDaycareStayInput!) {
  registerDaycareEntry(data: $data) {
    count
    message
    requiresConfirmation
    warning
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegisterDaycareEntryGQL extends Apollo.Mutation<RegisterDaycareEntryMutation, RegisterDaycareEntryMutationVariables> {
    document = RegisterDaycareEntryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegisterDaycareExitDocument = gql`
    mutation RegisterDaycareExit($data: RegisterDaycareStayInput!) {
  registerDaycareExit(data: $data) {
    count
    message
    requiresConfirmation
    warning
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegisterDaycareExitGQL extends Apollo.Mutation<RegisterDaycareExitMutation, RegisterDaycareExitMutationVariables> {
    document = RegisterDaycareExitDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchDaycarePickupDocument = gql`
    query SearchDaycarePickup($data: SearchDaycarePickupInput!) {
  searchDaycarePickup(data: $data) {
    totalCount
    PageSize
    currentPage
    totalPage
    PreviousPage
    nextPage
    results {
      id
      childName
      employeeRe
      status
      entryAt
      entryPersonName
      entryPersonKind
      entryByName
      entryNote
      exitAt
      exitPersonName
      exitPersonKind
      exitByName
      exitNote
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchDaycarePickupGQL extends Apollo.Query<SearchDaycarePickupQuery, SearchDaycarePickupQueryVariables> {
    document = SearchDaycarePickupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEnumByCultureDocument = gql`
    query GetEnumByCulture($culture: String!) {
  enumByCulture(culture: $culture) {
    id
    type
    value
    detail
    description
    culture
    unity {
      id
      name
      country {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEnumByCultureGQL extends Apollo.Query<GetEnumByCultureQuery, GetEnumByCultureQueryVariables> {
    document = GetEnumByCultureDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEnumByUnityDocument = gql`
    query GetEnumByUnity($unityId: String!) {
  enumByUnity(id: $unityId) {
    id
    type
    value
    detail
    description
    culture
    unity {
      id
      name
      country {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEnumByUnityGQL extends Apollo.Query<GetEnumByUnityQuery, GetEnumByUnityQueryVariables> {
    document = GetEnumByUnityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEnumByTypeAndCultureDocument = gql`
    query GetEnumByTypeAndCulture($type: String!, $culture: String!) {
  enumByTypeCulture(type: $type, culture: $culture) {
    id
    type
    value
    detail
    description
    culture
    unity {
      id
      name
      country {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEnumByTypeAndCultureGQL extends Apollo.Query<GetEnumByTypeAndCultureQuery, GetEnumByTypeAndCultureQueryVariables> {
    document = GetEnumByTypeAndCultureDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateEnumTypeDocument = gql`
    mutation CreateEnumType($input: CreateEnumTypeInput!) {
  createEnumType(data: $input) {
    id
    type
    value
    detail
    culture
    unity {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateEnumTypeGQL extends Apollo.Mutation<CreateEnumTypeMutation, CreateEnumTypeMutationVariables> {
    document = CreateEnumTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEnumTypeDocument = gql`
    mutation UpdateEnumType($input: UpdateEnumTypeInput!) {
  updateEnumType(data: $input) {
    id
    type
    value
    detail
    culture
    unity {
      id
      name
      code
      city
      country {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEnumTypeGQL extends Apollo.Mutation<UpdateEnumTypeMutation, UpdateEnumTypeMutationVariables> {
    document = UpdateEnumTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveEnumTypeDocument = gql`
    mutation RemoveEnumType($input: String!) {
  removeEnumType(id: $input) {
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveEnumTypeGQL extends Apollo.Mutation<RemoveEnumTypeMutation, RemoveEnumTypeMutationVariables> {
    document = RemoveEnumTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchEnumTypeDocument = gql`
    query SearchEnumType($input: SearchEnumTypeInput!) {
  searchEnumType(data: $input) {
    totalCount
    PageSize
    currentPage
    totalPage
    PreviousPage
    nextPage
    results {
      id
      type
      value
      detail
      culture
      unity {
        id
        name
        country {
          id
          name
          flag
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchEnumTypeGQL extends Apollo.Query<SearchEnumTypeQuery, SearchEnumTypeQueryVariables> {
    document = SearchEnumTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoginDocument = gql`
    mutation Login($data: AuthInput!) {
  login(data: $data) {
    user {
      ...User
    }
    token
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoginGQL extends Apollo.Mutation<LoginMutation, LoginMutationVariables> {
    document = LoginDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchOccurrencesDocument = gql`
    query SearchOccurrences($page: Int, $input: SearchOccurrenceInput!) {
  searchOccurrence(page: $page, data: $input) {
    PageSize
    PreviousPage
    currentPage
    nextPage
    totalCount
    totalPage
    occurrence {
      ...OccurrenceListItem
    }
  }
}
    ${OccurrenceListItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchOccurrencesGQL extends Apollo.Query<SearchOccurrencesQuery, SearchOccurrencesQueryVariables> {
    document = SearchOccurrencesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOccurrenceByIdDocument = gql`
    query GetOccurrenceById($id: String!) {
  occurrence(id: $id) {
    ...Occurrence
  }
}
    ${OccurrenceFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOccurrenceByIdGQL extends Apollo.Query<GetOccurrenceByIdQuery, GetOccurrenceByIdQueryVariables> {
    document = GetOccurrenceByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOccurrenceDocument = gql`
    mutation CreateOccurrence($input: CreateOccurrenceInput!) {
  createOccurrence(data: $input) {
    ...Occurrence
  }
}
    ${OccurrenceFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOccurrenceGQL extends Apollo.Mutation<CreateOccurrenceMutation, CreateOccurrenceMutationVariables> {
    document = CreateOccurrenceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOccurrenceDocument = gql`
    mutation UpdateOccurrence($input: UpdateOccurrenceInput!, $users: [UpdateOccurrenceUserInput!]!) {
  updateOccurrence(data: $input, userData: $users) {
    ...Occurrence
  }
}
    ${OccurrenceFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOccurrenceGQL extends Apollo.Mutation<UpdateOccurrenceMutation, UpdateOccurrenceMutationVariables> {
    document = UpdateOccurrenceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveOccurrenceDocument = gql`
    mutation RemoveOccurrence($id: String!) {
  removeOccurrence(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveOccurrenceGQL extends Apollo.Mutation<RemoveOccurrenceMutation, RemoveOccurrenceMutationVariables> {
    document = RemoveOccurrenceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveOccurrenceFileDocument = gql`
    mutation RemoveOccurrenceFile($id: String!) {
  removeOccurrenceFile(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveOccurrenceFileGQL extends Apollo.Mutation<RemoveOccurrenceFileMutation, RemoveOccurrenceFileMutationVariables> {
    document = RemoveOccurrenceFileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchPhysicalSecurityDocument = gql`
    query SearchPhysicalSecurity($data: SearchPhysicalSecurityInput!) {
  searchPhysicalSecurity(data: $data) {
    ...PhysicalSecurityPage
  }
}
    ${PhysicalSecurityPageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchPhysicalSecurityGQL extends Apollo.Query<SearchPhysicalSecurityQuery, SearchPhysicalSecurityQueryVariables> {
    document = SearchPhysicalSecurityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemovePhysicalSecurityDocument = gql`
    mutation RemovePhysicalSecurity($id: String!) {
  removePhysicalSecurity(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemovePhysicalSecurityGQL extends Apollo.Mutation<RemovePhysicalSecurityMutation, RemovePhysicalSecurityMutationVariables> {
    document = RemovePhysicalSecurityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemovePhysicalSecurityMemberDocument = gql`
    mutation RemovePhysicalSecurityMember($id: String!) {
  removePhysicalSecurityMember(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemovePhysicalSecurityMemberGQL extends Apollo.Mutation<RemovePhysicalSecurityMemberMutation, RemovePhysicalSecurityMemberMutationVariables> {
    document = RemovePhysicalSecurityMemberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePhysicalSecurityDocument = gql`
    mutation CreatePhysicalSecurity($data: CreatePhysicalSecurityInput!) {
  createPhysicalSecurity(data: $data) {
    ...PhysicalSecurity
  }
}
    ${PhysicalSecurityFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePhysicalSecurityGQL extends Apollo.Mutation<CreatePhysicalSecurityMutation, CreatePhysicalSecurityMutationVariables> {
    document = CreatePhysicalSecurityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePhysicalSecurityDocument = gql`
    mutation UpdatePhysicalSecurity($data: UpdatePhysicalSecurityInput!) {
  updatePhysicalSecurity(data: $data) {
    ...PhysicalSecurity
  }
}
    ${PhysicalSecurityFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePhysicalSecurityGQL extends Apollo.Mutation<UpdatePhysicalSecurityMutation, UpdatePhysicalSecurityMutationVariables> {
    document = UpdatePhysicalSecurityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PhysicalSecurityDocument = gql`
    query PhysicalSecurity($id: String!) {
  physicalSecurity(id: $id) {
    ...PhysicalSecurity
  }
}
    ${PhysicalSecurityFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PhysicalSecurityGQL extends Apollo.Query<PhysicalSecurityQuery, PhysicalSecurityQueryVariables> {
    document = PhysicalSecurityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchPolicyDocument = gql`
    query SearchPolicy($data: SearchPolicyInput!) {
  searchPolicy(data: $data) {
    ...Policy
  }
}
    ${PolicyFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchPolicyGQL extends Apollo.Query<SearchPolicyQuery, SearchPolicyQueryVariables> {
    document = SearchPolicyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemovePolicyDocument = gql`
    mutation RemovePolicy($id: ID!) {
  removePolicy(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemovePolicyGQL extends Apollo.Mutation<RemovePolicyMutation, RemovePolicyMutationVariables> {
    document = RemovePolicyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePolicyDocument = gql`
    mutation UpdatePolicy($data: UpdatePolicyInput!) {
  updatePolicy(data: $data) {
    ...Policy
  }
}
    ${PolicyFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePolicyGQL extends Apollo.Mutation<UpdatePolicyMutation, UpdatePolicyMutationVariables> {
    document = UpdatePolicyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePolicyDocument = gql`
    mutation CreatePolicy($data: CreatePolicyInput!) {
  createPolicy(data: $data) {
    ...Policy
  }
}
    ${PolicyFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePolicyGQL extends Apollo.Mutation<CreatePolicyMutation, CreatePolicyMutationVariables> {
    document = CreatePolicyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchServiceRequestDocument = gql`
    query SearchServiceRequest($data: SearchServiceRequestInput!) {
  searchServiceRequest(data: $data) {
    totalCount
    PageSize
    currentPage
    totalPage
    PreviousPage
    nextPage
    results {
      ...ServiceRequest
    }
  }
}
    ${ServiceRequestFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchServiceRequestGQL extends Apollo.Query<SearchServiceRequestQuery, SearchServiceRequestQueryVariables> {
    document = SearchServiceRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ServiceRequestDocument = gql`
    query ServiceRequest($data: ID!) {
  serviceRequest(id: $data) {
    ...ServiceRequest
  }
}
    ${ServiceRequestFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ServiceRequestGQL extends Apollo.Query<ServiceRequestQuery, ServiceRequestQueryVariables> {
    document = ServiceRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ServiceRequestInspectionDocument = gql`
    query ServiceRequestInspection($data: ID!) {
  serviceRequestInspection(id: $data) {
    ...ServiceRequestInspect
  }
}
    ${ServiceRequestInspectFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ServiceRequestInspectionGQL extends Apollo.Query<ServiceRequestInspectionQuery, ServiceRequestInspectionQueryVariables> {
    document = ServiceRequestInspectionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateServiceRequestDocument = gql`
    mutation CreateServiceRequest($data: CreateServiceRequestInput!) {
  createServiceRequest(data: $data) {
    ...ServiceRequest
  }
}
    ${ServiceRequestFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateServiceRequestGQL extends Apollo.Mutation<CreateServiceRequestMutation, CreateServiceRequestMutationVariables> {
    document = CreateServiceRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateServiceRequestDocument = gql`
    mutation UpdateServiceRequest($data: UpdateServiceRequestInput!) {
  updateServiceRequest(data: $data) {
    ...ServiceRequest
  }
}
    ${ServiceRequestFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateServiceRequestGQL extends Apollo.Mutation<UpdateServiceRequestMutation, UpdateServiceRequestMutationVariables> {
    document = UpdateServiceRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateServiceRequestDetailDocument = gql`
    mutation UpdateServiceRequestDetail($data: UpdateServiceRequestDetailInput!) {
  updateServiceRequestDetail(data: $data) {
    ...ServiceRequest
  }
}
    ${ServiceRequestFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateServiceRequestDetailGQL extends Apollo.Mutation<UpdateServiceRequestDetailMutation, UpdateServiceRequestDetailMutationVariables> {
    document = UpdateServiceRequestDetailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InspectServiceRequestDocument = gql`
    mutation InspectServiceRequest($data: InspectServiceRequestInput!) {
  inspectServiceRequest(data: $data) {
    ...ServiceRequestInspect
  }
}
    ${ServiceRequestInspectFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InspectServiceRequestGQL extends Apollo.Mutation<InspectServiceRequestMutation, InspectServiceRequestMutationVariables> {
    document = InspectServiceRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FinishServiceRequestDocument = gql`
    mutation FinishServiceRequest($id: ID!) {
  finishServiceRequest(id: $id) {
    ...ServiceRequest
    leftover {
      name
      entered
      exited
      remaining
    }
  }
}
    ${ServiceRequestFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FinishServiceRequestGQL extends Apollo.Mutation<FinishServiceRequestMutation, FinishServiceRequestMutationVariables> {
    document = FinishServiceRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddServiceRequestVehicleDocument = gql`
    mutation AddServiceRequestVehicle($data: AddServiceRequestVehicleInput!) {
  addServiceRequestVehicle(data: $data) {
    ...ServiceRequest
  }
}
    ${ServiceRequestFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddServiceRequestVehicleGQL extends Apollo.Mutation<AddServiceRequestVehicleMutation, AddServiceRequestVehicleMutationVariables> {
    document = AddServiceRequestVehicleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveServiceRequestDocument = gql`
    mutation RemoveServiceRequest($data: ID!) {
  removeServiceRequest(id: $data) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveServiceRequestGQL extends Apollo.Mutation<RemoveServiceRequestMutation, RemoveServiceRequestMutationVariables> {
    document = RemoveServiceRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchTruckDocument = gql`
    query SearchTruck($data: SearchTruckInput!) {
  searchTruck(data: $data) {
    totalCount
    PageSize
    currentPage
    totalPage
    PreviousPage
    nextPage
    results {
      ...Truck
    }
  }
}
    ${TruckFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchTruckGQL extends Apollo.Query<SearchTruckQuery, SearchTruckQueryVariables> {
    document = SearchTruckDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindCpfDocument = gql`
    query FindCPF($cpf: String!) {
  findCPF(cpf: $cpf) {
    driverName
    company
    licensePlate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FindCpfGQL extends Apollo.Query<FindCpfQuery, FindCpfQueryVariables> {
    document = FindCpfDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveTruckDocument = gql`
    mutation RemoveTruck($id: ID!) {
  removeTruck(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveTruckGQL extends Apollo.Mutation<RemoveTruckMutation, RemoveTruckMutationVariables> {
    document = RemoveTruckDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TruckDocument = gql`
    query truck($id: ID!) {
  truck(id: $id) {
    ...Truck
  }
}
    ${TruckFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TruckGQL extends Apollo.Query<TruckQuery, TruckQueryVariables> {
    document = TruckDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TruckChecklistEnumDocument = gql`
    query TruckChecklistEnum {
  truckChecklistEnum {
    type
    name
    status
    comment
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TruckChecklistEnumGQL extends Apollo.Query<TruckChecklistEnumQuery, TruckChecklistEnumQueryVariables> {
    document = TruckChecklistEnumDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EquipmentsDocument = gql`
    query Equipments {
  equipments {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EquipmentsGQL extends Apollo.Query<EquipmentsQuery, EquipmentsQueryVariables> {
    document = EquipmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTruckDocument = gql`
    mutation CreateTruck {
  createTruck {
    ...Truck
  }
}
    ${TruckFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTruckGQL extends Apollo.Mutation<CreateTruckMutation, CreateTruckMutationVariables> {
    document = CreateTruckDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTruckDocument = gql`
    mutation UpdateTruck($data: UpdateTruckInput!) {
  updateTruck(data: $data) {
    ...Truck
  }
}
    ${TruckFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTruckGQL extends Apollo.Mutation<UpdateTruckMutation, UpdateTruckMutationVariables> {
    document = UpdateTruckDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTruckPlateDocument = gql`
    mutation UpdateTruckPlate($data: UpdateTruckPlateInput!) {
  updateTruckPlate(data: $data) {
    id
    licensePlate
    trailerLicensePlate
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTruckPlateGQL extends Apollo.Mutation<UpdateTruckPlateMutation, UpdateTruckPlateMutationVariables> {
    document = UpdateTruckPlateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InspectTruckDocument = gql`
    mutation InspectTruck($data: InspectTruckInput!) {
  inspectTruck(data: $data) {
    ...Truck
  }
}
    ${TruckFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InspectTruckGQL extends Apollo.Mutation<InspectTruckMutation, InspectTruckMutationVariables> {
    document = InspectTruckDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReleaseTruckDocument = gql`
    mutation ReleaseTruck($data: ReleaseTruckInput!) {
  releaseTruck(data: $data) {
    ...Truck
  }
}
    ${TruckFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ReleaseTruckGQL extends Apollo.Mutation<ReleaseTruckMutation, ReleaseTruckMutationVariables> {
    document = ReleaseTruckDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveTruckChecklistPhotoDocument = gql`
    mutation RemoveTruckChecklistPhoto($id: ID!) {
  removeTruckChecklistPhoto(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveTruckChecklistPhotoGQL extends Apollo.Mutation<RemoveTruckChecklistPhotoMutation, RemoveTruckChecklistPhotoMutationVariables> {
    document = RemoveTruckChecklistPhotoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const VehiclesByCpfDocument = gql`
    query vehiclesByCpf($cpf: String!) {
  vehiclesByCpf(cpf: $cpf) {
    id
    licensePlate
    trailerLicensePlate
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class VehiclesByCpfGQL extends Apollo.Query<VehiclesByCpfQuery, VehiclesByCpfQueryVariables> {
    document = VehiclesByCpfDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateVehicleDocument = gql`
    mutation createVehicle($data: CreateVehicleInput!) {
  createVehicle(data: $data) {
    id
    licensePlate
    trailerLicensePlate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateVehicleGQL extends Apollo.Mutation<CreateVehicleMutation, CreateVehicleMutationVariables> {
    document = CreateVehicleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateVehicleDocument = gql`
    mutation updateVehicle($data: UpdateVehicleInput!) {
  updateVehicle(data: $data) {
    id
    licensePlate
    trailerLicensePlate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateVehicleGQL extends Apollo.Mutation<UpdateVehicleMutation, UpdateVehicleMutationVariables> {
    document = UpdateVehicleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteVehicleDocument = gql`
    mutation deleteVehicle($id: ID!) {
  deleteVehicle(id: $id) {
    status
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteVehicleGQL extends Apollo.Mutation<DeleteVehicleMutation, DeleteVehicleMutationVariables> {
    document = DeleteVehicleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUnitiesDocument = gql`
    query GetUnities {
  unities {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUnitiesGQL extends Apollo.Query<GetUnitiesQuery, GetUnitiesQueryVariables> {
    document = GetUnitiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUnitiesByCountryDocument = gql`
    query GetUnitiesByCountry($countryId: String!) {
  getUnitiesByCountry(id: $countryId) {
    ...Unity
  }
}
    ${UnityFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUnitiesByCountryGQL extends Apollo.Query<GetUnitiesByCountryQuery, GetUnitiesByCountryQueryVariables> {
    document = GetUnitiesByCountryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchUnityDocument = gql`
    query SearchUnity($input: SearchUnityInput!) {
  searchUnity(data: $input) {
    totalCount
    PageSize
    currentPage
    totalPage
    PreviousPage
    nextPage
    results {
      ...Unity
    }
  }
}
    ${UnityFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchUnityGQL extends Apollo.Query<SearchUnityQuery, SearchUnityQueryVariables> {
    document = SearchUnityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUnityDocument = gql`
    mutation createUnity($data: CreateUnityInput!) {
  createUnity(data: $data) {
    id
    name
    code
    users {
      name
    }
    occurrences {
      author
    }
    country {
      name
    }
    blocs {
      name
    }
    city
    deletedAt
    checkListAlarm {
      id
    }
    checkListAccess {
      id
    }
    checkListCftv {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUnityGQL extends Apollo.Mutation<CreateUnityMutation, CreateUnityMutationVariables> {
    document = CreateUnityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUnityDocument = gql`
    mutation updateUnity($data: UpdateUnityInput!) {
  updateUnity(data: $data) {
    id
    name
    code
    users {
      name
    }
    occurrences {
      author
    }
    country {
      name
    }
    blocs {
      name
    }
    city
    deletedAt
    checkListAlarm {
      id
    }
    checkListAccess {
      id
    }
    checkListCftv {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUnityGQL extends Apollo.Mutation<UpdateUnityMutation, UpdateUnityMutationVariables> {
    document = UpdateUnityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveUnityDocument = gql`
    mutation removeUnity($id: String!) {
  removeUnity(id: $id) {
    status
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveUnityGQL extends Apollo.Mutation<RemoveUnityMutation, RemoveUnityMutationVariables> {
    document = RemoveUnityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    ...User
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentUserGQL extends Apollo.Query<CurrentUserQuery, CurrentUserQueryVariables> {
    document = CurrentUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UsersDocument = gql`
    query Users {
  users {
    ...User
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UsersGQL extends Apollo.Query<UsersQuery, UsersQueryVariables> {
    document = UsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchUsersDocument = gql`
    query SearchUsers($page: Int, $input: SearchUserInput!) {
  searchUsers(page: $page, data: $input) {
    totalCount
    PageSize
    currentPage
    totalPage
    PreviousPage
    nextPage
    users {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchUsersGQL extends Apollo.Query<SearchUsersQuery, SearchUsersQueryVariables> {
    document = SearchUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUserDocument = gql`
    mutation CreateUser($data: CreateUserInput!) {
  createUser(data: $data) {
    id
    name
    unity {
      ...Unity
    }
    status
    profile
    phone
    photo
    createdAt
    updatedAt
  }
}
    ${UnityFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUserGQL extends Apollo.Mutation<CreateUserMutation, CreateUserMutationVariables> {
    document = CreateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserDocument = gql`
    mutation updateUser($data: UpdateUserInput!) {
  updateUser(data: $data) {
    id
    name
    unity {
      ...Unity
    }
    status
    profile
    phone
    photo
  }
}
    ${UnityFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserGQL extends Apollo.Mutation<UpdateUserMutation, UpdateUserMutationVariables> {
    document = UpdateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveUserDocument = gql`
    mutation removeUser($id: String!) {
  removeUser(id: $id) {
    status
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveUserGQL extends Apollo.Mutation<RemoveUserMutation, RemoveUserMutationVariables> {
    document = RemoveUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword($input: String!) {
  forgotPassword(identifier: $input) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ForgotPasswordGQL extends Apollo.Mutation<ForgotPasswordMutation, ForgotPasswordMutationVariables> {
    document = ForgotPasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResetPasswordDocument = gql`
    mutation ResetPassword($input: ResetPasswordInput!) {
  resetPassword(data: $input) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ResetPasswordGQL extends Apollo.Mutation<ResetPasswordMutation, ResetPasswordMutationVariables> {
    document = ResetPasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }